import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, Injector, Input, OnInit, Optional, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { AddeditcalcComponent } from '@app/main/projects/addeditcalc.component';
import { CommonModule, DOCUMENT } from '@node_modules/@angular/common';
import { FormsModule } from '@node_modules/@angular/forms';
import { NgbModule } from '@node_modules/@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@node_modules/@ng-select/ng-select';
import { AbpModule } from '@node_modules/abp-ng2-module';
import { NgxPaginationModule } from 'ngx-pagination';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { UtilsModule } from '@shared/utils/utils.module';
import { CustomName } from '../../cablepro.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import { BreakingOutput, CableproServiceProxy, CableproXmlInput, CalculationInput, CalculationReportInput, ConductorDto, CoreDto, CustomereportFieldsInput, DeviceOutput, BSDRFServiceServiceProxy, DRFWizrd, InstallTableDto, InsulationDto, ListProtectiveInput, ManufacturerOutput, MCBOutput, PhaseDto, ProtectiveData, ProtectiveDeviceData, ProtectiveItem, ProtectiveXmlInput, SettingOutput, SpecifyConductorDto, SubscriptionServiceProxy, TableItem, UiControlsLookupDto, UserLoginInfoDto, WindSpeedDto, WizardFactorInput, WizardFactorOutput, WizardServiceProxy } from '@shared/service-proxies/service-proxies';
import { ActivatedRoute, Router } from '@node_modules/@angular/router';
import { CalculationService, DRFService, ProductService, SettingService } from 'services/project.service';
import { CableproCalculationServiceProxy, CalculationResult } from '@shared/service-proxies/service-proxy-calc';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { LoaderService } from '../../loader.service';
import { PdfReportServiceProxy } from '@shared/service-proxies/service-proxy-rpt';
import { SharedService } from '@shared/service-proxies/shared.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL2 } from '@app/main/projects/settings.component';
import { fromEvent, Observable, of, Subject, Subscription } from '@node_modules/rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from '@node_modules/rxjs/operators';
import { ImageUtils } from '@shared/helpers/ImageUtils';
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { Model, Table22Model, Table23InstallationModel, Table23Model, Table25Model, Table271Model, Table28Model, Table29Model } from '../../models/iec-cablesize.model';
import { ErrorWarningModel, ProtectionConfigurationModel } from '../../models/network-calc.model';
import { NgxSliderModule } from '@node_modules/@angular-slider/ngx-slider';
import { HighlightPipe } from '@shared/utils/searchFilter';

@Component({
  selector: 'app-iec-cablesize',
  templateUrl: './iec-cablesize.component.html',
  styleUrls: ['./iec-cablesize.component.css'],
  standalone: true,
  animations: [appModuleAnimation()],
  imports: [NgSelectModule, FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, AddeditcalcComponent, NgxPaginationModule, CustomName, NgxSliderModule, HighlightPipe]
})
export class IecCablesizeComponent extends AppComponentBase implements OnInit, AfterViewInit {
  public calculationInput: CalculationInput = new CalculationInput();
  public wizardFactorInput: WizardFactorInput = new WizardFactorInput();
  public wizardFactorInputList: WizardFactorInput[] = [];
  public wizardFactorOutput: WizardFactorOutput[] = [];
  public mode: string = 'add';
  public showreportloader: boolean = false;
  public insulationValues: any;
  public insulationObj: any;
  public conductorObj: any;
  public coreObj: any;
  public phaseObj: any;
  public insulationData: InsulationDto[] = [];
  public conductorData: ConductorDto[] = [];
  public coreData: CoreDto[] = [];
  public phaseData: PhaseDto[] = [];
  public installTableData: InstallTableDto[] = [];
  public specifyConductorData: SpecifyConductorDto[] = [];
  public uiControlsLookUpData: UiControlsLookupDto[] = [];
  public windSpeedData: WindSpeedDto[] = [];
  public PrevInsulationId = 0;
  public PrevConductorId = 0;
  public PrevCoreId = 0;
  public PrevPhaseId = 0;
  public PrevImageIndex = 0;
  public CableproInput = new Model();
  public hasWind: boolean;
  public TableId: number;
  public ShowActive = false;
  public showActiveLab = true;
  public ShowConduitSize: boolean = false;
  public ShowConduitSizeLab: boolean = true;
  public PrevConduitSize: any;
  public ShowNeutral = false;
  public ShowNeutralLab = true;
  public ShowEarth = false;
  public ShowEarthLab = true;
  public CableSize = {};
  public PrevCableSize = null;
  public forceCalc: boolean = false;
  public Xml: any;
  public Dictatingfactorres: any;
  public resultXml: any;
  public PrevActiveValue: any;
  public PrevNeutralValue: any;
  public PrevMCBVal: any = '';
  public inc: number = 1
  public PrevMCCBVal: any = '';
  public PrevACBVal: any = '';
  public PrevHRCVal: any = '';
  public PrevCurveVal: any = '';
  public PrevCustomeRatingVal: any = '';
  public showLable = false;
  public active_res: any = '-';
  public neutral_res: any = '-';
  public earth_res: any = '-';
  public voltage_res: any = '-';
  public voltage_res1: any = '-';
  public faultLoop_res: any = '-';
  //public conduit_res: any = '-';
  public Circuitrating_drated: any;
  public Dictatingfactor: any;
  public Currentrating_cable_tabulated: any;
  public Currentrating_cable_tabulated_Ref_Desc_TableNo: any;
  public Currentrating_cable_tabulated_Ref_Desc_ColumnNo: any;
  public CCC_Currentrating_cable_tabulated_Operating_temperature: any;
  public VoltageDrop_RefAndDesc_Resistance_TableNo: any;
  public VoltageDrop_RefAndDesc_Resistance_ColumnNo_MinTemp: any;
  public VoltageDrop_RefAndDesc_Resistance_ColumnNo_MaxTemp: any;
  public VoltageDrop_RefAndDesc_Reactance_TableNo: any;
  public VoltageDrop_RefAndDesc_Reactance_ColumnNo: any;
  public VoltageDrop_Data_PhaseConductor_Resistance: any;
  public VoltageDrop_Data_PhaseConductor_Reactance: any;
  public VoltageDrop_Result_MaxLengthOfRun: any;
  public ShortCircuitPerformance_PhaseConductor_MinActive_Cond_Size: any = '-';
  public ShortCircuitPerformance_PhaseConductor_kfactor: any = '-';
  public ShortCircuitPerformance_ok: any = 'PASS';
  public ShortCircuitPerformance_EarthConductor_ok: any = '1';
  public ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct: any = '-';
  public ShortCircuitPerformance_NuetralConductor_MinNuetral_Cond_Size: any = '-';
  public ShortCircuitPerformance_NuetralConductor_Kfactor: any = '-';
  public ShortCircuitPerformance_EarthConductor_MinEarth_Cond_Size: any = '-';
  public ShortCircuitPerformance_EarthConductor_Kfactor: any = '-';
  public ShortCircuitPerformance_EarthConductor_PhaseToEarthShort_cct: any = '-';
  public CircuitCurrentrating_Adequate: any;
  public VoltageDrop_Result_VoltageDrop_Acceptable: any;
  public EarthLoop_ok: any;
  public MaxAllowedDevice: any;
  public ConditSizeFound: any;
  public ConditSizeBasedOn: any;

  public NoofConduit: string = '1';
  public ConduitDiameter: any;
  public MinimumConduitDiameter: any;

  public ConditCableDiameter: any;
  public ConditCableDiameterActive: any;
  public Activeneutralshownseparately: any;

  public ConditCableDiameterNeutral: any;
  public ConditNoofCablesPerCondit: any;
  public ConditNoofCablesPerConditActive: any;
  public ConditNoofCablesPerConditNeutral: any;
  public ConditSpaceFactorActual: any;
  public ConditSpaceFactorStandard: any;
  public ConditSpaceFactorActualNeutral: any;

  public ConditRefrenceTable: any;
  public ConditNeutralRefrenceTable: any;
  @Input() newCalculationId: number;
  @Input() calculationName: string;
  @Input() projectId: number;
  @Input() projectName: string;
  @Input() isFromWebfacing: boolean = false;
  public cableproXmlInput: CableproXmlInput = new CableproXmlInput();
  public dc_Voltage: string;
  public onePhase_Voltage: string;
  public threePhase_Voltage: string;
  public voltage_txt: string;
  public flag = false;
  public Spare_current_capacity_of_circuit: any = '-';
  public active_NoOf_circuit: any = '1';
  public neutral_NoOf_circuit: any = '1';
  public earth_NoOf_circuit: any = '1';
  public PrevEarthConductorId = 0;

  public faultloop1: any;
  public faultloop2: any;
  public faultloop3: any;
  public faultloop4: any;
  public faultloop5: any;
  public faultloop6: any;
  public faultloop7: any;

  public CalculationReportInput: CalculationReportInput = new CalculationReportInput();
  public OriDrfWizard: DRFWizrd;
  //report fileds
  public vdrop: any;
  public vdroppecent: any;
  public vdropPermissibale: any;
  public referencetempdegCReport: any;
  public standardCountryReport: any;
  public calculation_type: string = "9";
  public activeCondz1Report: any;
  public Earthcondz2Report: any;
  public settingOutput: SettingOutput = new SettingOutput();
  public companyLogo_ShowLogo: boolean;
  public isOldCalculation: boolean = false;
  public customeReportFields_ShowCustomField: boolean;
  public companyLogo_FileName: string;
  public customFields: CustomereportFieldsInput[] = [];
  public VoltageDrop_Data_NeutralConductor_Resistance: any;
  public VoltageDrop_Data_NeutralConductor_Reactance: any;
  public validProjectName = false;
  public validJobName = false;
  public Three_phaseShort_circuitCurrent: any;
  public Active_to_EarthShort_circuitCurrent: any;
  public tempDeracting: string;
  public currentUnit: string = "1";
  public tempRating: string;
  public showEarthButton = true;
  public showEfficency = false;
  public user!: UserLoginInfoDto | undefined;
  public calcCount: number = 0;
  public premiumUser!: boolean;
  private isPlanAddedManually: boolean = false;
  public planLevel: string | number = '';

  public drInstallType: number | 1;
  public drBunchingType: number | 1;
  public drBunchingCore: number | 1;

  public table22model: Table22Model;
  public drTable22output: any;
  public drTable271output: any;
  public drTable25output: any;
  public drTable22ArrangementValues: any;
  public drTable22CircuitValues: any;

  public table271model: Table271Model;
  public conductorTempValues: any;

  public table25model: Table25Model;
  public table25NoOfCircuitValues: any;
  public table25CableTypeValues: any;
  public table25ArrangementValues: any;

  public table28model: Table28Model;
  public table28output: any;
  public table28ConductorSizeValues: any;
  public displayCurrentError!: boolean;
  public displayShortCircuitPerformance!: boolean;

  public wizard: any;

  public table29model: Table29Model;
  public table29output: any;
  public table29InstallationValues: any;

  public table23model: Table23Model;
  public table23output: any;
  public table23RowValues: any;
  public table23CableValues: any;
  public loading: boolean;
  public isCalculating: boolean;
  public CalculationResult: any;
  public finalDrf: number;
  public UserWizard: boolean;
  public voltageSupplyLabel: string = '';
  public lblcurrent: string = 'Current';
  public prevVoltageSupplyLabel: string = '';
  public toRemoveData: any;
  private SelectInstallTableMethodIndex: any;
  private SelectInstallTableTableId: any;
  private SelectInstallTableName: string;
  private SelectInstallTableDescription: string;
  public powerunit: string = '0';
  public efficiency: number = 100;
  public cableCalcProtectiveDeviceSource: string = '0';
  public RCD: boolean = false;
  public protectiveUnknown: boolean = true;
  public Isfromunknownchk: boolean = false;

  protectiveImgSrc = 'assets/cablepro/logo/a.png';
  protectiveIncomerImgSrc = 'assets/cablepro/logo/a.png';
  protectiveImgSrc2 = 'assets/cablepro/logo/a.png';

  public txtrating: string = '';
  public txtmodal: string = '';
  public txtfamily: string = '';
  public txtTripUnit: string = '';
  discriminatedData: any = null;


  public txtratingfuse: string = '';
  public txtmodalfuse: string = '';
  public txtfamilyfuse: string = '';
  public txtTripUnitfuse: string = '';
  public txtratingprotection: string = '';
  public txtmodalprotection: string = '';
  public txtfamilyprotection: string = '';
  public txtTripUnitprotection: string = '';
  public selectedModalId: number = 0;

  // protection variables
  public loadProtectiveXmlInput: ProtectiveXmlInput = new ProtectiveXmlInput();
  public defaultManId: number = 104;
  public defaultFamilyId: string = "";
  public defaultModelId: number = 0;
  public FilterBreaking: number = 5;
  public xmlData: string = "";
  public xmlData_Original: string = "";
  public xmlData_Tripping: string = "";
  public Tripping_Xml_Original: string = "<Cluster><Name>Tripping calculations</Name><NumElts>2</NumElts><Cluster><Name>Tripping time calculation</Name><NumElts>1</NumElts><DBL><Name>Current (A)</Name><Val>0</Val></DBL></Cluster><Cluster><Name>Tripping current calculation</Name><NumElts>1</NumElts><DBL><Name>Time (s)</Name><Val>[Tripping_time]</Val></DBL></Cluster></Cluster>";
  public defaultRatingId: string = "";
  public defaultCurveId: string = "";
  public defaultModelName: string | undefined;
  public model: string;
  public isloadedfirst: boolean = true;
  public isloadfirsttime: boolean = true;
  public rpcaption: string = "Rating plug";
  public outputXmlData: string = "";
  public trippingCurrentAtSpecifiedTime: string = "";
  public trippingCurrentAtSpecifiedTime_Original: string = "";
  public chartData: any;
  public dimSizeData: any;
  public selectListFive: string = 'Curve Class';
  public curveClassOrTripUnit: string = 'Curve Class';
  public curveClassOrTripUnitProtection: string = 'Curve Class';
  public IsGeneric: boolean = true;

  public gmanufacturerId: number = 0;
  public gmodelId: number = 0;
  public modifyindex: number = -1;
  public cindex: number = 0;
  public crownumber: number = 0;
  public showFilter: boolean = false;
  public gfamilyId: string = "";

  displayErrorBtn: boolean = false;
  warningErrorStrData: string = '';
  warningErrorBtnText: string = "Warnings";
  warningErrorHeader: string = "Errors";
  warningErrorList: ErrorWarningModel[] = [];
  paginationConfig = {
    id: 'error-pagination-cablepro',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 4
  };
  public earthConductorData: any = [
    { "id": 0, "text": "Same as phase conductor" },
    { "id": 1, "text": "Copper" },
    { "id": 2, "text": "Aluminium" }
  ]
  public devices: any = [
    { "id": '0', "text": "Unknown" },
    { "id": '1', "text": "MCB" },
    { "id": '2', "text": "MCCB" },
    { "id": '3', "text": "ACB" },
    { "id": '4', "text": "HRC Fuse" },
    { "id": '5', "text": "Custom" }
  ]
  public device: string = "0";
  public NeutralDisabled: boolean = false;

  public earthList: any = [
    { "id": '1', "text": "1 mm²" },
    { "id": '1.5', "text": "1.5 mm²" },
    { "id": '2.5', "text": "2.5 mm²" },
    { "id": '4', "text": "4 mm²" },
    { "id": '6', "text": "6 mm²" },
    { "id": '10', "text": "10 mm²" },
    { "id": '16', "text": "16 mm²" },
    { "id": '25', "text": "25 mm²" },
    { "id": '35', "text": "35 mm²" },
    { "id": '50', "text": "50 mm²" },
    { "id": '70', "text": "70 mm²" },
    { "id": '95', "text": "95 mm²" },
    { "id": '120', "text": "120 mm²" },
    { "id": '150', "text": "150 mm²" },
    { "id": '185', "text": "185 mm²" },
    { "id": '240', "text": "240 mm²" },
    { "id": '300', "text": "300 mm²" },
    { "id": '400', "text": "400 mm²" },
    { "id": '500', "text": "500 mm²" },
    { "id": '630', "text": "630 mm²" },

  ]

  public conduitSizesPristine: any = [
    { "id": '16', "text": "1 x 16 mm" },
    { "id": '20', "text": "1 x 20 mm" },
    { "id": '25', "text": "1 x 25 mm" },
    { "id": '32', "text": "1 x 32 mm" },
    { "id": '40', "text": "1 x 40 mm" },
    { "id": '50', "text": "1 x 50 mm" },
    { "id": '63', "text": "1 x 63 mm" },
    { "id": '65', "text": "1 x 65 mm" },
    { "id": '80', "text": "1 x 80 mm" },
    { "id": '100', "text": "1 x 100 mm" },
    { "id": '125', "text": "1 x 125 mm" },
    { "id": '150', "text": "1 x 150 mm" },
    { "id": '175', "text": "1 x 175 mm" },
    { "id": '225', "text": "1 x 225 mm" },
    { "id": '300', "text": "1 x 300 mm" },
    { "id": '375', "text": "1 x 375 mm" },
    { "id": '475', "text": "1 x 475 mm" },
    { "id": '600', "text": "1 x 600 mm" }
  ]

  public conduitSizes: any = [
    { "id": '16', "text": "1 x 16 mm" },
    { "id": '20', "text": "1 x 20 mm" },
    { "id": '25', "text": "1 x 25 mm" },
    { "id": '32', "text": "1 x 32 mm" },
    { "id": '40', "text": "1 x 40 mm" },
    { "id": '50', "text": "1 x 50 mm" },
    { "id": '63', "text": "1 x 63 mm" },
    { "id": '65', "text": "1 x 65 mm" },
    { "id": '80', "text": "1 x 80 mm" },
    { "id": '100', "text": "1 x 100 mm" },
    { "id": '125', "text": "1 x 125 mm" },
    { "id": '150', "text": "1 x 150 mm" },
    { "id": '175', "text": "1 x 175 mm" },
    { "id": '225', "text": "1 x 225 mm" },
    { "id": '300', "text": "1 x 300 mm" },
    { "id": '375', "text": "1 x 375 mm" },
    { "id": '475', "text": "1 x 475 mm" },
    { "id": '600', "text": "1 x 600 mm" }
  ]

  public powerUnits: any = [
    { "id": '0', "text": "Amps" },
    { "id": '1', "text": "Watts" },
    { "id": '2', "text": "kW" },
    { "id": '3', "text": "h.p." }
  ]

  public earthfaulttime: number;
  public protection_curve: number;
  public rcd_chk: boolean = false;

  constructor(
    injector: Injector,
    private route: ActivatedRoute,
    private _CableproService: CableproServiceProxy,
    private _CableproCalc: CableproCalculationServiceProxy,
    private _settingService: SettingService,
    private loaderService: LoaderService,
    private _appSessionService: AppSessionService,
    private ref: ChangeDetectorRef,
    private drfBSDService: BSDRFServiceServiceProxy,
    private _pdfReportSerivceProxy: PdfReportServiceProxy,
    private drfGetService: DRFService,
    private _calculationService: CalculationService,
    private _wizardService: WizardServiceProxy,
    private _router: Router,
    private _projectService: ProductService,
    private _subscriptionService: SubscriptionServiceProxy,
    private sharedService: SharedService,
    private http: HttpClient,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Optional() @Inject(API_BASE_URL2) baseUrl?: string
  ) {
    super(injector);
    (window as any).cablePro = this;
    this.baseUrl = baseUrl ? baseUrl : "";
    this.toRemoveData = this.route.params.subscribe((params) => {
      this.newCalculationId = parseInt(params.cid);
      this.projectId = parseInt(params.pid);
      this.calculationName = this.route.snapshot.queryParamMap.get('cname');
      this.projectName = this.route.snapshot.queryParamMap.get('name');
      this.CalculationReportInput.projectname = this.projectName;
      this.CalculationReportInput.jobNo = this.calculationName;
      this._calculationService.getVoltageDrop().subscribe(result => {
        this.voltageSupplyLabel = result;
        this.prevVoltageSupplyLabel = result;

        if (this.voltageSupplyLabel === undefined || this.voltageSupplyLabel === null) {
          this.voltageSupplyLabel = 'drop';
          this.prevVoltageSupplyLabel = 'drop';
        }
        if (this.voltageSupplyLabel == 'rise') {

          if (this.currentUnit == "1") {
            this.lblcurrent = 'Output current';
          }
          else {
            this.lblcurrent = 'Output power';
          }
        }
        this.CableSize["isVoltageDrop"] = this.voltageSupplyLabel == "drop";
      });
    });

    this.protectiveModelChanged
      .pipe(
        debounceTime(300))
      .subscribe(() => {
        this.GetModelGroupByManufacturerIdnew(this.gmanufacturerId, this.gfamilyId, this.FilterBreaking);
      })
    this.ddlmodelChanged
      .pipe(
        debounceTime(300))
      .subscribe(() => {
        this.GetRatingByManufacturerId(this.gmanufacturerId, this.gfamilyId, this.gmodelId, true);
      })
  }
  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  private actionSubscription!: Subscription;
  @ViewChild('searchInput', { static: true }) searchInput!: ElementRef;
  ngOnInit(): void {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(
        map((event: Event) => (event.target as HTMLInputElement).value),
        debounceTime(500), // Adjust debounce time as needed
        tap(() => { this.loadingSearch = true; this.resetSearch() }),
        distinctUntilChanged(),
        switchMap((term) =>
          this.searchItems(term, this.startAt).pipe()
        )
      )
      .subscribe((result) => {
        this.filteredOptions = result;
        if (result && result.length > 0) {
          this.totalDeviceCount = result[0].total_count;
        }
        else {
          this.totalDeviceCount = 0;
        }
        this.showDropdown = true;
        this.loadingSearch = false;
      });


    this.slidertmiroptions = {
      floor: "0",
      ceil: "1", step: "1"
    }


    this.slidertmimoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    // this.slidermim ="-";
    this.slidermimoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidercurrenttolerance = "-";
    this.slidercurrenttoleranceoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidertimetolerance = "-";
    this.slidertimetoleranceoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidereio = "-";
    this.slidereiooptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidereir = "-";
    this.slidereiroptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slideridmtl = "-";
    this.slideridmtloptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slideretr = "-";
    this.slideretroptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidereisd = "-";
    this.slidereisdoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slideretsd1 = "1";
    this.slideretsdoptions = {
      showTicks: true,
      stepsArray: [
        { value: "1" }, { value: "2" }

      ]
    };
    this.slidereli = "-";
    this.sliderelioptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.slidertimetobreakoptions = {
      showTicks: true,
      stepsArray: [
        { value: "-" }

      ]
    };
    this.actionSubscription = this.sharedService.action$.subscribe((action: string) => {
      if (action === 'report') {
        this.company_Logo_LogoPresignedUrl = this.defaultLogoImagePath;
        this.companyLogo_FileName = undefined;
        this.CalculationReportInput.eamilList = '';
        this.deleteVisible = false;
        if (this.isFromWebfacing) {
          $('#chkEmailReport').prop("checked", true);
          this.CalculationReportInput.sendEmail = true;
          $('#chkPrintName').prop("checked", true);
          $('#chkCompanyLogo').prop("checked", false);
          this.companyLogo_ShowLogo = false;
        }
        $("#reportDlg").modal('show');
      }
    });
    this.inputSubject
      .pipe(debounceTime(1000)) // Adjust the debounce time (in milliseconds) as needed
      .subscribe((value: any) => {
        this.GetTable271Dr(value.e, value.checkdecimalplaces);
      });
    this.CableSize = {
      insulation: '0',
      conductor: '0',
      earthconductor: '0',
      core: '0',
      phase: '0',
      faultlevel: '3',
      supplyvoltage: '230',
      voltagedrop: '2.5',
      powerunit: '0',
      efficiency: '100',
      lengthofrun: '50',
      current: '100',
      powerfactor: '0.9',
      unit: '0',
      deratingfactor: '1',
      device: '0',
      usevd: '1',
      protection: {
        shortcircuittime: '0.1',
        MCBrating: '0',
        ACBrating: '0',
        HRCFuserating: '0',
        MCCBrating: '0',
        curve: '0',
        earthfaulttime: '0',
        rcd: '0',
        tripcurrent: '0',
        tripmultiplier: '0',
        thermalsetting: '0',
        customrating: '0',
        description: '0',
        IsUnknown: true,
        Xml: undefined,
        IncomerXml: undefined,
        IncomerName: "Device 01",
        hasIncomer: false,
        TrippingXml: undefined,
        IncomerTrippingXml: undefined,
        protectionConfigurationModel: {}
      },
      installtablewind: { wind: '' },
      specifyconductor: {
        phase: {
          mode: '0',
          size: '0',
          circuits: '1'
        },
        neutral: {
          mode: '0',
          size: '0',
          circuits: '1'
        },
        earth: {
          mode: '1',
          size: '0',
          circuits: '1'
        }
      },
      tableno: 'B.52.2',
      columnno: '2',
      startingrowindex: '0',
      endingrowindex: '15',
      description: 'A1 Insulated conductors in conduit in a thermally insulated wall',
      tablectrlvalue: '0',
      voltagefactor: '1.1',
      calculationstandard: '3',
      cableCalcProtectiveDeviceSource: this.cableCalcProtectiveDeviceSource,
      isderatingwiz: '0',
      deratingtemp: '40',
      conduitsize: {
        mode: '0',
        size: '0'
      },
      isVoltageDrop: true
    };
    this.drInstallType = 1;
    this.table271model = new Table271Model();
    this.table271model.UseStandard = true;
    this.CalculationReportInput.printName = true;

    this.ShowNameChanged();
    this._settingService.getSettings().subscribe((result) => {
      if (result.standards_CableSizing !== undefined) {
        this.CableSize['calculationstandard'] = "3";
        this.CableSize['voltagefactor'] = result.short_Circuit_VoltageFactor_C.toString();
        this.CableSize['dcvoltage'] = result.deafaultVoltages_DcVoltage.toString();
        this.CableSize['onephasevoltage'] = result.deafaultVoltages_OnePhaseAVoltage.toString();
        this.CableSize['threephasevoltage'] = result.deafaultVoltages_ThreePhaseAcvoltage.toString();
        this.dc_Voltage = result.deafaultVoltages_DcVoltage.toString();
        this.onePhase_Voltage = result.deafaultVoltages_OnePhaseAVoltage.toString();
        this.voltage_txt = this.onePhase_Voltage;
        this.CableSize['supplyvoltage'] = this.onePhase_Voltage;
        this.threePhase_Voltage = result.deafaultVoltages_ThreePhaseAcvoltage.toString();

        this.standardCountryReport = "3";
        //report fields
        this.companyLogo_ShowLogo = result.companyLogo_ShowLogo;
        this.customeReportFields_ShowCustomField = result.customeReportFields_ShowCustomField;
        this.companyLogo_FileName = result.companyLogo_LogoUrl;
        this.customFields = result.customFields;
      } else {
        this.CableSize['calculationstandard'] = "3";
        this.CableSize['voltagefactor'] = '1.1';
        this.CableSize['dcvoltage'] = '1500';
        this.CableSize['onephasevoltage'] = '230';
        this.CableSize['threephasevoltage'] = '400';
        this.dc_Voltage = '1500';
        this.onePhase_Voltage = '230';
        this.threePhase_Voltage = '400';
        this.standardCountryReport = "3";
        this.companyLogo_ShowLogo = false;
        this.customeReportFields_ShowCustomField = false;
        this.companyLogo_FileName = '';
        this.customFields = null;
      }
      this.GetData('Load', '', 0, 0, 0, 0, 0, 0, 0, '', '', this.newCalculationId, 0, 0, 0);
    });
    setTimeout(() => {
      this.specifyConductorChange();
      this.onDropDownChange();
      this.onCheckBoxChange();
      this.onNoEarthChange();
      document.getElementById('defaultOpen').click();

      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });
    });

    this.onretrySave();
    this.premiumUser = false;
    this.isPlanAddedManually = false;
    this.displayCurrentError = false;
    this.displayShortCircuitPerformance = false;
    this.getCurrentLoginInformations();

    this.drBunchingType = 1;
    this.drBunchingCore = 1;
    this.wizard = undefined;
    this.UserWizard = false;
    this.table22model = new Table22Model();
    this.table22model.Arrangement = 1;
    this.table22model.NoOfCircuits = 1
    this.table22model.drf = 1;
    this.drTable22output = null;
    this.drTable22ArrangementValues = [
      { "name": "Bunched in air, on a surface, embedded or enclosed - Reference Methods A to F", "value": 1 },
      { "name": "Single layer on wall, floor or unperforated cable tray systems - Reference Method C", "value": 2 },
      { "name": "Single layer fixed directly under a wooden ceiling - Reference Method C", "value": 3 },
      { "name": "Single layer on a perforated horizontal or vertical cable tray systems - Reference Methods E and F", "value": 4 },
      { "name": "Single layer on cable ladder systems or cleats - Reference Methods E and F", "value": 5 }
    ];
    this.drTable22CircuitValues = [{ "name": 1, "value": 1 },
    { "name": 2, "value": 2 },
    { "name": 3, "value": 3 },
    { "name": 4, "value": 4 },
    { "name": 5, "value": 5 },
    { "name": 6, "value": 6 },
    { "name": 7, "value": 7 },
    { "name": 8, "value": 8 },
    { "name": 9, "value": 9 },
    { "name": 12, "value": 12 },
    { "name": 16, "value": 16 },
    { "name": 20, "value": 20 }];

    this.table25model = new Table25Model();
    this.table25model.NoOfCircuits = 1;
    this.table25model.CableType = 2;
    this.table25model.TouchingType = 1;
    this.table25model.InstallType = 1;
    this.table25model.Distance = 0;
    this.table25model.drf = 1;
    this.table25model.Arrangement = 1;
    this.table25NoOfCircuitValues = [
      { "name": "No derating (1 group)", "value": 1 },
      { "name": "2 groups", "value": 2 },
      { "name": "3 groups", "value": 3 },
      { "name": "4 groups", "value": 4 },
      { "name": "5 groups", "value": 5 },
      { "name": "6 groups", "value": 6 },
      { "name": "7 groups", "value": 7 },
      { "name": "8 groups", "value": 8 },
      { "name": "9 groups", "value": 9 },
      { "name": "12 groups", "value": 12 },
      { "name": "16 groups", "value": 16 },
      { "name": "20 groups", "value": 20 },
    ];
    this.table25ArrangementValues = [
      { "name": "Nil (cables touching)", "value": 1 },
      { "name": "One cable diameter", "value": 2 },
      { "name": "Spaced 0.125 m", "value": 3 },
      { "name": "Spaced 0.25 m", "value": 4 },
      { "name": "Spaced 0.5 m", "value": 5 },
    ];
    /* Soil installation - step 1 - Group of buried circuits */

    this.table271model = new Table271Model();
    this.table271model.UseStandard = true;
    this.table271model.AmbientTemp = 30;
    this.table271model.Insulation = 2;
    this.table271model.drf = 1;
    if (this.drInstallType == 1) {
      this.insulationValues = [
        { "name": "PVC", "value": 2 },
        { "name": "XLPE and EPR", "value": 3 },
        { "name": "PVC covered or bare and exposed to touch 70 &#176;C", "value": 4 },
        { "name": "Bare not exposed to touch 105 &#176;C", "value": 5 },
      ];
    } else {
      this.insulationValues = [
        { "name": "PVC", "value": 2 },
        { "name": "XLPE and EPR", "value": 3 },
      ];
    }

    /* Soil installation - step 2 - Depth of Burial (m) */
    this.table28model = new Table28Model();
    this.table28model.UseStandard = true;
    this.table28model.Depth = 0.7;
    this.table28model.Buried = 1;
    this.table28model.drf = 1;
    /* Soil installation - step 2 - Depth of Burial (m) */

    /* Soil installation - step 3 - Soil thermal resitivity C.m/W */
    this.table29model = new Table29Model();
    this.table29model.UseStandard = true;
    $('#inputUseStandard').attr('disabled', 'true');
    this.table29model.Resitivity = 2.5;
    this.table29model.Buried = 1;
    this.table29model.drf = 1;
    /* Soil installation - step 3 - Soil thermal resitivity C.m/W */

    /* Soil installation - step 4 - Soil ambient temperature */
    $('#inputUseStandardSoil').attr('disabled', 'true');
    $('#inputUseStandardAir1').attr('disabled', 'true');
    $('#inputUseStandardAir2').attr('disabled', 'true');
    if (this.drInstallType == 2) {
      this.conductorTempValues = [
        // { "name": "150 &#176;C", "value": 150 },
        { "name": "110 &#176;C", "value": 110 },
        { "name": "90 &#176;C", "value": 90 },
        { "name": "80 &#176;C", "value": 80 },
        { "name": "75 &#176;C", "value": 75 },
      ];
    }
    else {
      this.conductorTempValues = [
        { "name": "150 &#176;C", "value": 150 },
        { "name": "110 &#176;C", "value": 110 },
        { "name": "90 &#176;C", "value": 90 },
        { "name": "80 &#176;C", "value": 80 },
        { "name": "75 &#176;C", "value": 75 },
      ];
    }
    /* Soil installation - step 4 - Soil ambient temperature */

    this.table23model = new Table23Model();
    this.table23model.CableType = this.drBunchingCore;
    this.table23model.Row = 1;
    this.table23model.Cables = 1;
    this.table23model.Installation = 1;
    this.table23model.drf = this.drBunchingCore == 1 ? 0.98 : 1;
    if (this.drBunchingCore == 1) {
      this.GetTable23Values();
      this.table23CableValues = [
        { "name": "1 cct", "value": 1 },
        { "name": "2 ccts", "value": 2 },
        { "name": "3 ccts", "value": 3 },
      ];
    }
    else {
      this.GetTable24Values();
      this.table23CableValues = [
        { "name": "1", "value": 1 },
        { "name": "2", "value": 2 },
        { "name": "3", "value": 3 },
        { "name": "4", "value": 4 },
        { "name": "5", "value": 5 },
        { "name": "6", "value": 6 },
        { "name": "9", "value": 9 },
      ];
    }
    this.table23RowValues = [
      { "name": "1 tray", "value": 1 },
      { "name": "2 trays", "value": 2 },
      { "name": "3 trays", "value": 3 },
      { "name": "6 trays", "value": 6 },
    ];
    $('#divBunchingType2').css('display', 'none');
    $('#divBunchingType3').css('display', 'none');
    $('#divburiedGroupArrangement').css('display', 'none');
    //this.onSelectInstall(1);

    if (localStorage.getItem("ReportSettingEmails") && localStorage.getItem("ReportSettingEmails") != undefined && localStorage.getItem("ReportSettingEmails") != '') {
      this.CalculationReportInput.eamilList = localStorage.getItem("ReportSettingEmails");
    }
    else {
      this.CalculationReportInput.eamilList = '';
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes && changes.projectName && changes.projectName.currentValue) {
    //     this.CalculationReportInput.projectname = changes.projectName.currentValue;
    // }
    // if (changes && changes.calculationName && changes.calculationName.currentValue) {
    //     this.CalculationReportInput.jobNo = changes.calculationName.currentValue;
    // }

  }

  ngDoCheck() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
  }

  getCurrentLoginInformations(): void {
    this.user = this._appSessionService.user;
    this.premiumUser = this.user.premiumUser;
    this.planLevel = this.user.userStripePlanLevel;
    this.isPlanAddedManually = this.user.isPlanAddedManually;
  }
  GetData(mode: string, value: string, insulationId: number, conductorId: number, coreId: number, phaseId: number, methodIndex: number, installTableId: number, windSpeedId: number, load: string, protection: string, calculationId: number, ConductorIndex: number, CoreIndex: number, earthConductorId: number) {
    this.showLoader();
    var armourId = 0;
    this._CableproService.getCableproes(3, mode, value, insulationId, conductorId, armourId, coreId, phaseId, methodIndex, installTableId, windSpeedId, load, protection, calculationId, ConductorIndex, CoreIndex).subscribe((result) => {
      if (mode === 'Load') {
        if (result.cableproXmlInputOpen === null || result.cableproXmlInputOpen === undefined) {
          this.insulationData = result.insulationDto;
          this.conductorData = result.conductorDto;
          this.coreData = result.coreDto;
          this.phaseData = result.phaseDto;
          this.installTableData = result.installTableDto;
          //
          this.specifyConductorData = result.specifyConductorDto;
          this.uiControlsLookUpData = result.uiControlsLookupDto;
          this.windSpeedData = result.windSpeedDto;
          // 
          if (this.windSpeedData.length > 0) {
            this.hasWind = true;
            this.CableproInput.WindSpeedId = this.windSpeedData[0].id;
            this.CableSize['installtablewind']['wind'] = this.windSpeedData[0].xmlValue; // ak change
          } else {
            this.hasWind = false;
          }
          if ($('#neutral-toggle').val() !== 'on') {
            $('#neutral-toggle').click();
          }
          this.NeutralDisabled = true;
          $('#Neutral_c').attr('disabled', 'true');
          $('#neutral-toggle').attr('disabled', 'true');

          $('#Active_c').attr('disabled', 'true');
          $('#Earth_c').attr('disabled', 'true');
          this.voltageSupplyLabel = 'drop';
          this.CableSize["isVoltageDrop"] = true;
          this.prevVoltageSupplyLabel = 'drop';
          this.lblcurrent = 'Current';

          this.CableproInput.InsulationId = this.insulationData[0].id;
          this.CableproInput.ConductorId = this.conductorData[0].id;
          this.CableproInput.EarthConductorId = 0;
          this.CableproInput.CoreId = this.coreData[0].id;
          this.CableproInput.PhaseId = this.phaseData[0].id;
          this.CableproInput.ActiveId = this.specifyConductorData[0].id;
          this.PrevActiveValue = this.specifyConductorData[0].value.replace(' mm²', '');
          this.CableproInput.EarthId = this.earthList[0].id;
          this.CableproInput.NeutralId = this.specifyConductorData[0].id;
          this.CableproInput.InstallTableId = this.installTableData[0].id;
          this.SelectInstallTableTableId = this.CableproInput.InstallTableId;
          this.CableproInput.MethodIndex = this.installTableData[0].images[0].index;
          this.CableproInput.ConduitSizeId = this.conduitSizes[0].id;
          this.drBunchingCore = 1;


          if (result.installTableReference !== null && result.installTableReference !== undefined) {
            this.CableSize["tableno"] = result.installTableReference.curTable;
            this.CableSize["columnno"] = result.installTableReference.curColNo;
            this.CableSize["startingrowindex"] = result.installTableReference.curStartRowIndex;
            this.CableSize["endingrowindex"] = result.installTableReference.curEndRowIndex;
          }

        }
        else {


          this._projectService.refreshSidebarProjects();

          this.flag = true;
          this.calculation_type = result.cableproXmlInputOpen.calculationType;
          this.cableCalcProtectiveDeviceSource = result.cableproXmlInputOpen.protectiveDevicesSetting.toString();
          this.CableSize['cableCalcProtectiveDeviceSource'] = this.cableCalcProtectiveDeviceSource;

          this.xmlData = result.cableproXmlInputOpen.iecProtectiveInputXML;
          this.CableSize['protection']['Xml'] = this.xmlData;
          this.CableSize['xml'] = this.xmlData;

          if (this.cableCalcProtectiveDeviceSource == "1") {
            $('#protection-toggle').prop('checked', true);
          }
          else {
            $('#protection-toggle').prop('checked', false);
          }
          if (result.cableproXmlInputOpen.phaseXmlVal == '0') {
            if ($('#neutral-toggle').val() !== 'on') {
              $('#neutral-toggle').click();
            }
            this.NeutralDisabled = true;
            $('#Neutral_c').attr('disabled', 'true');
            $('#neutral-toggle').attr('disabled', 'true');
          }
          else if (result.cableproXmlInputOpen.phaseXmlVal == '1') {
            this.NeutralDisabled = false;
            $('#Neutral_c').removeAttr('disabled');
          }

          else if (result.cableproXmlInputOpen.phaseXmlVal == '2') {
            if ($('#neutral-toggle').prop('checked')) {
              $('#neutral-toggle').click();
            }
            this.NeutralDisabled = true;
            $('#Neutral_c').attr('disabled', 'true');
            $('#neutral-toggle').attr('disabled', 'true');
          }
          else if (result.cableproXmlInputOpen.phaseXmlVal == '3' || result.cableproXmlInputOpen.phaseXmlVal == '4') {
            this.NeutralDisabled = false;
            $('#Neutral_c').removeAttr('disabled');
          }
          // 

          $('#Active_c').attr('disabled', 'true');
          $('#Earth_c').attr('disabled', 'true');
          this.device = result.cableproXmlInputOpen.protection_device ? result.cableproXmlInputOpen.protection_device : '0';
          $('input[name="current"]').val(result.cableproXmlInputOpen.load_current);
          $('input[name="Derating factor"]').val(result.cableproXmlInputOpen.load_deratingFactor);
          if (result.cableproXmlInputOpen.efficiency != 0)
            this.efficiency = result.cableproXmlInputOpen.efficiency;

          //  $('input[name="Efficiency"]').val(result.cableproXmlInputOpen.efficiency);
          this.tempDeracting = result.cableproXmlInputOpen.load_deratingFactor;
          $('input[name="power-factor"]').val(result.cableproXmlInputOpen.load_powerFactor);
          $('input[name="Voltage Drop"]').val(result.cableproXmlInputOpen.supply_voltageDrop);
          this.voltage_txt = result.cableproXmlInputOpen.supply_voltage;
          // $('input[name="Voltage-Supply"]').val(result.cableproXmlInputOpen.supply_voltage);
          $('input[name="fault-level"]').val(result.cableproXmlInputOpen.supply_faultLevel);
          $('input[name="length-of-run"]').val(result.cableproXmlInputOpen.supply_lengthOfrun);
          // alert(result.cableproXmlInputOpen.powerunit);
          if (result.cableproXmlInputOpen.powerunit != null) {
            this.powerunit = result.cableproXmlInputOpen.powerunit;
            this.onddlPowerUnitChange(this.powerunit, "true");
            // $("#ddlunit").val(this.powerunit).trigger('change', "true");
            // $("#ddlunit").val(this.powerunit);

          }
          else {
            this.powerunit = "0";
            this.onddlPowerUnitChange(this.powerunit, "true");
            // $("#ddlunit").val(this.powerunit).trigger('change', "true");
            // $("#ddlunit").val(this.powerunit);
          }
          if (result.cableproXmlInputOpen.supply_useVd == '1') {
            $('#use-vd').prop('checked', true);
          } else {
            $('#use-vd').prop('checked', false);
          }
          if (result.cableproXmlInputOpen.earthconductorXmlVal != null && result.cableproXmlInputOpen.earthconductorXmlVal != undefined)
            this.PrevEarthConductorId = parseInt(result.cableproXmlInputOpen.earthconductorXmlVal);
          else
            this.PrevEarthConductorId = 0;
          this.insulationData = result.insulationDto;
          this.conductorData = result.conductorDto;
          this.coreData = result.coreDto;
          this.phaseData = result.phaseDto;
          this.installTableData = result.installTableDto;
          this.specifyConductorData = result.specifyConductorDto;
          this.uiControlsLookUpData = result.uiControlsLookupDto;
          this.windSpeedData = result.windSpeedDto;
          if (this.windSpeedData.length > 0) {
            this.hasWind = true;
            if (result.cableproXmlInputOpen != undefined && result.cableproXmlInputOpen != null) {
              this.CableproInput.WindSpeedId = this.windSpeedData[result.cableproXmlInputOpen.windSpeedId].id;
              this.CableSize['installtablewind']['wind'] = this.windSpeedData[result.cableproXmlInputOpen.windSpeedId].xmlValue;// ak change


            }
            else {
              this.CableproInput.WindSpeedId = this.windSpeedData[0].id;
              this.CableSize['installtablewind']['wind'] = this.windSpeedData[0].xmlValue;// ak change

              //this.onWindChange();

            }
          } else {
            this.hasWind = false;
          }
          if (result.installTableReference !== null && result.installTableReference !== undefined) {
            this.CableSize["tableno"] = result.installTableReference.curTable;
            this.CableSize["columnno"] = result.installTableReference.curColNo;
            this.CableSize["startingrowindex"] = result.installTableReference.curStartRowIndex;
            this.CableSize["endingrowindex"] = result.installTableReference.curEndRowIndex;
          }
          this.CableproInput.InsulationId = result.cableproXmlInputOpen.insulationId;
          this.CableproInput.ConductorId = result.cableproXmlInputOpen.conductorId;
          this.CableproInput.EarthConductorId = this.PrevEarthConductorId;
          this.protectiveUnknown = result.cableproXmlInputOpen.protection_isunknown == "1" ? true : false;
          this.CableSize['protection']['IsUnknown'] = this.protectiveUnknown;
          if (this.cableCalcProtectiveDeviceSource == "0") {
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.RCD = result.cableproXmlInputOpen.protection_rcd == "1";
          }
          if (result.cableproXmlInputOpen.isVoltageDrop == false) {
            this.voltageSupplyLabel = 'rise';
            this.prevVoltageSupplyLabel = 'rise';
          }
          else {
            this.voltageSupplyLabel = 'drop';
            this.prevVoltageSupplyLabel = 'drop';
          }
          if (this.voltageSupplyLabel == 'rise') {
            if (this.currentUnit == "1") {
              this.lblcurrent = 'Output current';
            }
            else {
              this.lblcurrent = 'Output power';
            }
          }
          this.CableSize["isVoltageDrop"] = this.voltageSupplyLabel == "drop";
          this.CableproInput.CoreId = result.cableproXmlInputOpen.coreId;
          this.CableproInput.PhaseId = result.cableproXmlInputOpen.phaseId;
          this.CableproInput.MethodIndex = result.cableproXmlInputOpen.methodIndex;
          this.CableproInput.InstallTableId = result.cableproXmlInputOpen.installTableId;
          this.SelectInstallTableTableId = this.CableproInput.InstallTableId;
          this.PrevConductorId = parseInt(result.cableproXmlInputOpen.conductorXmlVal);
          this.PrevCoreId = parseInt(result.cableproXmlInputOpen.coreXmlVal);
          if (this.PrevCoreId == 0)
            this.drBunchingCore = 1;
          else
            this.drBunchingCore = 2;
          this.OnChangeCore(null);
          this.PrevImageIndex = this.CableproInput.MethodIndex;
          this.onResetControlValues();

          if (this.device == '0') {
            result.cableproXmlInputOpen.protection_short_c_time = result.cableproXmlInputOpen.protection_short_c_time ? result.cableproXmlInputOpen.protection_short_c_time : "0.1";
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;
            setTimeout(() => {
              $('#protection input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);
            }, 1000);
          }
          else if (this.device == '1') {
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;

            this.CableSize['protection']['MCBrating'] = result.cableproXmlInputOpen.protection_MCBrating;
            this.CableSize['protection']['curve'] = result.cableproXmlInputOpen.protection_curve;
            this.protection_curve = parseInt(result.cableproXmlInputOpen.protection_curve);
            this.CableSize['protection']['earthfaulttime'] = result.cableproXmlInputOpen.protection_earthFault;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.rcd_chk = result.cableproXmlInputOpen.protection_rcd == "1";
            this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
            this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
            setTimeout(() => {
              $('input[caption="Trip Multiplier"]').val(result.cableproXmlInputOpen.protection_tr_multiplier);
              $('input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);
              $('#select_MCB').val(result.cableproXmlInputOpen.protection_MCBrating).trigger('change');
              if (result.cableproXmlInputOpen.protection_rcd == '1') {
                this.rcd_chk = true;
                // $('#rcd').prop('checked', true);
              } else {
                this.rcd_chk = false;
                // $('#rcd').prop('checked', false);
              }
              var currValue = parseFloat(result.cableproXmlInputOpen.protection_tr_current);
              if (currValue > 0) {
                $('input[caption="Trip current"]').val(currValue);
              }
              else {
                currValue = parseFloat(result.cableproXmlInputOpen.protection_tr_multiplier) * parseInt(result.cableproXmlInputOpen.protection_MCBrating);
                $('input[caption="Trip current"]').val(currValue);
              }
              this.select2Dropdown();
            }, 1000);
          } else if (this.device == '2') {
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;
            this.CableSize['protection']['MCCBrating'] = result.cableproXmlInputOpen.protection_MCCBrating;
            this.CableSize['protection']['earthfaulttime'] = result.cableproXmlInputOpen.protection_earthFault;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.rcd_chk = result.cableproXmlInputOpen.protection_rcd == "1";
            this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
            this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;

            this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            setTimeout(() => {
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              $('input[caption="Trip Multiplier"]').val(result.cableproXmlInputOpen.protection_tr_multiplier);
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              $('input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);

              let max = $('#select_MCCB option:selected')[0].innerText.split(" ")[1];
              $('input[caption="Thermal setting"]').attr('max', max);

              $('#select_MCCB').val(result.cableproXmlInputOpen.protection_MCCBrating).trigger('change');

              if (result.cableproXmlInputOpen.protection_rcd == '1') {
                this.rcd_chk = true;
                // $('#rcd').prop('checked', true);
              } else {
                this.rcd_chk = false;
                // $('#rcd').prop('checked', false);
              }
              /* code added on 29-11-2019 */
              this.CableSize['protection']['MCCBrating'] = result.cableproXmlInputOpen.protection_MCCBrating;
              this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
              this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
              this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              /* code added on 29-11-2019 */

              var currValue = parseFloat(result.cableproXmlInputOpen.protection_tr_current);
              if (currValue > 0) {
                $('input[caption="Trip current"]').val(currValue);
              }
              else {
                currValue = parseFloat(result.cableproXmlInputOpen.protection_tr_multiplier) * parseInt(result.cableproXmlInputOpen.protection_MCCBrating);
                $('input[caption="Trip current"]').val(currValue);
              }
              this.select2Dropdown();
            }, 1000);
          } else if (this.device == '3') {
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;
            this.CableSize['protection']['ACBrating'] = result.cableproXmlInputOpen.protection_ACBrating;
            this.CableSize['protection']['earthfaulttime'] = result.cableproXmlInputOpen.protection_earthFault;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.rcd_chk = result.cableproXmlInputOpen.protection_rcd == "1";
            this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
            this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
            this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            setTimeout(() => {
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              $('input[caption="Trip Multiplier"]').val(result.cableproXmlInputOpen.protection_tr_multiplier);
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              $('input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);
              let max = $('#select_ACB option:selected')[0].innerText.split(" ")[1];
              $('input[caption="Thermal setting"]').attr('max', max);
              $('#select_ACB').val(result.cableproXmlInputOpen.protection_ACBrating).trigger('change');
              if (result.cableproXmlInputOpen.protection_rcd == '1') {
                this.rcd_chk = true;
                // $('#rcd').prop('checked', true);
              } else {
                this.rcd_chk = false;
                // $('#rcd').prop('checked', false);
              }
              /* code added on 29-11-2019 */
              this.CableSize['protection']['ACBrating'] = result.cableproXmlInputOpen.protection_MCCBrating;
              this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
              this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
              this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              /* code added on 29-11-2019 */
              this.select2Dropdown();
            }, 1000);
          } else if (this.device == '4') {
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;
            this.CableSize['protection']['HRCFuserating'] = result.cableproXmlInputOpen.protection_HRCrating;
            this.CableSize['protection']['earthfaulttime'] = result.cableproXmlInputOpen.protection_earthFault;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.rcd_chk = result.cableproXmlInputOpen.protection_rcd == "1";
            this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
            this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            setTimeout(() => {
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              $('input[caption="Trip Multiplier"]').val(result.cableproXmlInputOpen.protection_tr_multiplier);
              $('input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);
              $('#select_HRCFuse').val(result.cableproXmlInputOpen.protection_HRCrating).trigger('change');
              if (result.cableproXmlInputOpen.protection_rcd == '1') {
                this.rcd_chk = true;
                // $('#rcd').prop('checked', true);
              } else {
                this.rcd_chk = false;
                // $('#rcd').prop('checked', false);
              }
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              this.select2Dropdown();
            }, 1000);
          } else if (this.device == '5') {
            this.CableSize['protection']['shortcircuittime'] = result.cableproXmlInputOpen.protection_short_c_time;
            this.CableSize['protection']['customrating'] = result.cableproXmlInputOpen.protection_Customrating;
            this.CableSize['protection']['earthfaulttime'] = result.cableproXmlInputOpen.protection_earthFault;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            this.CableSize['protection']['rcd'] = result.cableproXmlInputOpen.protection_rcd;
            this.rcd_chk = result.cableproXmlInputOpen.protection_rcd == "1";
            this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
            this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
            this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
            this.CableSize['protection']['description'] = result.cableproXmlInputOpen.protection_description;
            this.earthfaulttime = parseInt(result.cableproXmlInputOpen.protection_earthFault);
            setTimeout(() => {
              $('input[caption="Custom Rating"]').val(result.cableproXmlInputOpen.protection_Customrating);
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
              $('input[caption="Trip Multiplier"]').val(result.cableproXmlInputOpen.protection_tr_multiplier);
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              $('input[caption="Short-circuit time"]').val(result.cableproXmlInputOpen.protection_short_c_time);
              $('input[caption="Description"]').val(result.cableproXmlInputOpen.protection_description);
              if (result.cableproXmlInputOpen.protection_rcd == '1') {
                this.rcd_chk = true;
                // $('#rcd').prop('checked', true);
              } else {
                this.rcd_chk = false;
                // $('#rcd').prop('checked', false);
              }

              /* code added on 29-11-2019 */
              this.CableSize['protection']['Custom Rating'] = result.cableproXmlInputOpen.protection_MCCBrating;
              this.CableSize['protection']['tripcurrent'] = result.cableproXmlInputOpen.protection_tr_current;
              this.CableSize['protection']['tripmultiplier'] = result.cableproXmlInputOpen.protection_tr_multiplier;
              this.CableSize['protection']['thermalsetting'] = result.cableproXmlInputOpen.protection_thermal;
              $('input[caption="Thermal setting"]').val(result.cableproXmlInputOpen.protection_thermal);
              /* code added on 29-11-2019 */
              $('input[caption="Trip current"]').val(result.cableproXmlInputOpen.protection_tr_current);
            }, 1000);
          }
          this.CableSize['insulation'] = result.cableproXmlInputOpen.insulationXmlVal;
          this.CableSize['conductor'] = result.cableproXmlInputOpen.conductorXmlVal;
          this.CableSize['earthconductor'] = result.cableproXmlInputOpen.earthconductorXmlVal;
          this.CableSize['core'] = result.cableproXmlInputOpen.coreXmlVal;
          this.CableSize['phase'] = result.cableproXmlInputOpen.phaseXmlVal;
          this.CableSize['faultlevel'] = result.cableproXmlInputOpen.supply_faultLevel;
          this.CableSize['voltagedrop'] = result.cableproXmlInputOpen.supply_voltageDrop;
          this.CableSize['powerunit'] = result.cableproXmlInputOpen.powerunit;
          if (result.cableproXmlInputOpen.efficiency != 0)
            this.CableSize['efficiency'] = result.cableproXmlInputOpen.efficiency.toString();
          else
            this.CableSize['efficiency'] = this.efficiency.toString();

          this.CableSize['supplyvoltage'] = result.cableproXmlInputOpen.supply_voltage;
          this.CableSize['lengthofrun'] = result.cableproXmlInputOpen.supply_lengthOfrun;
          this.CableSize['usevd'] = result.cableproXmlInputOpen.supply_useVd;
          this.CableSize['isderatingwiz'] = result.cableproXmlInputOpen.isderatingwiz;
          this.CableSize['deratingtemp'] = result.cableproXmlInputOpen.deratingtemp;
          // if(result.cableproXmlInputOpen.supply_useVd =='0')
          // {
          //     $(".lblcurrent").text('Output current (A)');
          // }
          // else{
          //     $(".lblcurrent").text('Current (A)');

          // } 

          this.CableSize['current'] = result.cableproXmlInputOpen.load_current;
          // this.CableSize['currentamp'] = result.cableproXmlInputOpen.load_currentamp;
          this.CableSize['powerfactor'] = result.cableproXmlInputOpen.load_powerFactor;
          this.CableSize['deratingfactor'] = parseFloat(result.cableproXmlInputOpen.load_deratingFactor).toFixed(2);
          this.CableSize['device'] = this.device;

          // alert(result.cableproXmlInputOpen.specify_Phaseconductor_circuit + "getdata");
          if (result.cableproXmlInputOpen.specify_Phaseconductor_mode == '1') {
            $('#active-toggle').prop('checked', true);
            this.showActiveLab = false;
            this.ShowActive = true;
            $('#Active_c').removeAttr('disabled');
            $('#Active_c').val(result.cableproXmlInputOpen.specify_Phaseconductor_circuit);
            this.CableSize['specifyconductor']['phase']['mode'] = '1';
            this.CableSize['specifyconductor']['phase']['circuits'] = result.cableproXmlInputOpen.specify_Phaseconductor_circuit;
            this.CableSize['specifyconductor']['phase']['size'] = result.cableproXmlInputOpen.specify_Phaseconductor_size;
            //alert(result.cableproXmlInputOpen.specify_Phaseconductor_size);
            var selectedItem = result.specifyConductorDto.find(x => x.value === result.cableproXmlInputOpen.specify_Phaseconductor_size + ' mm²');
            if (selectedItem) {
              this.CableproInput.ActiveId = selectedItem.id;
              this.PrevActiveValue = selectedItem.value.replace(' mm²', '');
            }
          }
          else {
            this.ShowActive = false;
            this.showActiveLab = true;
          }
          if (result.cableproXmlInputOpen.conduit_Mode == '1') {
            $('#conduit-size-toggle').prop('checked', true);
            this.ShowConduitSizeLab = false;
            this.ShowConduitSize = true;
            this.CableproInput.ConduitSizeId = parseInt(result.cableproXmlInputOpen.conduit_Size);
            this.CableSize['conduitsize']['mode'] = '1';
            this.CableSize['conduitsize']['size'] = parseFloat(result.cableproXmlInputOpen.conduit_Size);

            this.PrevConduitSize = result.cableproXmlInputOpen.conduit_Size;
          }
          else {
            this.ShowConduitSize = false;
            this.CableSize['conduitsize']['mode'] = '0';
            $('#conduit-size-toggle').prop('checked', false);
            this.ShowConduitSizeLab = true;
          }

          if (this.PrevConduitSize !== undefined) {
            let val = this.conduitSizes.filter(x => x.id === this.PrevConduitSize.trim());
            if (val.length > 0) {
              this.CableproInput.ConduitSizeId = val[0].id;
              this.PrevConduitSize = val[0].id;
            } else {
              this.CableproInput.ConduitSizeId = this.conduitSizes[0].id;
            }
          } else {
            this.CableproInput.ConduitSizeId = this.conduitSizes[0].id;
            this.PrevConduitSize = this.conduitSizes[0].id;
          }

          if (result.cableproXmlInputOpen.specify_Neutralconductor_mode == '1') {
            $('#neutral-toggle').prop('checked', true);
            $('#Neutral_c').val(result.cableproXmlInputOpen.specify_Neutralconductor_circuit);
            this.CableSize['specifyconductor']['neutral']['circuits'] = result.cableproXmlInputOpen.specify_Neutralconductor_circuit;
            this.CableSize['specifyconductor']['neutral']['size'] = result.cableproXmlInputOpen.specify_Neutralconductor_size;
            this.CableSize['specifyconductor']['neutral']['mode'] = 1
            this.ShowNeutral = true;
            this.ShowNeutralLab = false
            var selectedItem = result.specifyConductorDto.find(x => x.value === result.cableproXmlInputOpen.specify_Neutralconductor_size || x.value === result.cableproXmlInputOpen.specify_Neutralconductor_size + ' mm²');
            if (selectedItem) {
              this.CableproInput.NeutralId = selectedItem.id;
              this.PrevNeutralValue = selectedItem.value.replace(' mm²', '');
            }
          }
          else {
            this.ShowNeutral = false;
            this.ShowNeutralLab = true;
            $('#neutral-toggle').prop('checked', false);
            $('#Neutral_c').attr('disabled', 'true');
          }
          if (result.cableproXmlInputOpen.specify_Earthconductor_mode == '0') {
            $('#earth-chk').prop('checked', true);
            this.CableSize['specifyconductor']['earth']['circuits'] = "0";
            this.CableSize['specifyconductor']['earth']['size'] = '0'
            this.CableSize['specifyconductor']['earth']['mode'] = '0';
            $('#earth-toggle').attr('disabled', 'true');
            this.ShowEarth = false;
            $('#Earth_c').attr('disabled', 'true');
            $('#Earth_c').val(1);
            this.ShowEarthLab = true;
            this.showEarthButton = false;

          } else if (result.cableproXmlInputOpen.specify_Earthconductor_mode == '2') {
            $('#earth-toggle').prop('checked', true);
            $('#Earth_c').removeAttr('disabled');
            $('#Earth_c').val(result.cableproXmlInputOpen.specify_Earthconductor_circuit);
            this.CableSize['specifyconductor']['earth']['circuits'] = result.cableproXmlInputOpen.specify_Earthconductor_circuit;
            this.CableSize['specifyconductor']['earth']['mode'] = '2';
            this.CableSize['specifyconductor']['earth']['size'] = parseFloat(result.cableproXmlInputOpen.specify_Earthconductor_size);
            var obj = this.earthList.find(x => x.id == result.cableproXmlInputOpen.specify_Earthconductor_size);
            if (obj) {
              this.CableproInput.EarthId = obj.id;
            }
            this.ShowEarth = true;
            this.ShowEarthLab = false;
          }
          //
          //this.CableSize['tableno'] = result.cableproXmlInputOpen.installTable;
          this.CableSize['tablectrlvalue'] = result.cableproXmlInputOpen.methodIndex;
          this.CableSize['description'] = result.cableproXmlInputOpen.installTable_description;
          this.onResetControlValues();
          this.onCancel();
          if (result.cableproXmlInputOpen.deratingFactorData) {
            this.finalDrf = parseFloat(result.cableproXmlInputOpen.deratingFactorData.finalDrf.toFixed(2));
            this.CalculationReportInput.wizardValues = result.cableproXmlInputOpen.deratingFactorData;
            // $('#checkboxUseWizard').attr('checked', 'true');
            $('#deratingFactor').val(this.finalDrf);
            this.UserWizard = true;
            this.CableSize['isderatingwiz'] = "1";
            this.OriDrfWizard = result.cableproXmlInputOpen.deratingFactorData;
          }
          this.setWizardFactorValues();
        }
        this.loading = false;
        this.flag = false;
        this.GetIECProtectiveDataByCalculationId(this.newCalculationId);
      }
      else {
        if (result.insulationDto !== null && result.insulationDto !== undefined) {
          this.insulationData = result.insulationDto;
          this.CableproInput.InsulationId = this.insulationData[0].id;
          this.CableSize['insulation'] = this.insulationData[0].xmlValue.toString();
        }
        if (result.conductorDto !== null && result.conductorDto !== undefined) {
          this.conductorData = result.conductorDto;
          this.CableproInput.ConductorId = this.conductorData[this.PrevConductorId].id;
          this.CableSize['conductor'] = this.conductorData[this.PrevConductorId].xmlValue.toString();
        }
        if (result.installTableReference !== null && result.installTableReference !== undefined) {
          this.CableSize["tableno"] = result.installTableReference.curTable;
          this.CableSize["columnno"] = result.installTableReference.curColNo;
          this.CableSize["startingrowindex"] = result.installTableReference.curStartRowIndex;
          this.CableSize["endingrowindex"] = result.installTableReference.curEndRowIndex;
        }

        if (this.earthConductorData && this.earthConductorData.length > 0) {
          if (this.PrevEarthConductorId == -1) {
            this.PrevEarthConductorId = 1;
          }
          this.CableSize['earthconductor'] = this.PrevEarthConductorId;
          this.CableproInput.EarthConductorId = this.PrevEarthConductorId;
        }
        if (result.coreDto !== null && result.coreDto !== undefined) {
          this.coreData = result.coreDto;
          this.CableproInput.CoreId = this.coreData[this.PrevCoreId].id;
          this.CableSize['core'] = this.coreData[this.PrevCoreId].xmlValue.toString();
        }

        if (result.phaseDto !== null && result.phaseDto !== undefined) {
          this.phaseData = result.phaseDto;
          this.CableproInput.PhaseId = this.phaseData[0].id;
          this.CableSize['phase'] = this.phaseData[0].xmlValue.toString();
          if (this.CableproInput.PhaseId.toString() == '108') {
            this.CableSize['supplyvoltage'] = this.onePhase_Voltage;
          }
          else if (this.CableproInput.PhaseId.toString() == '109') {
            this.CableSize['supplyvoltage'] = this.threePhase_Voltage;
          }
          else if (this.CableproInput.PhaseId.toString() == '110') {
            this.CableSize['supplyvoltage'] = this.dc_Voltage;
          }
        }

        if (result.installTableDto !== null && result.installTableDto !== undefined) {
          this.installTableData = result.installTableDto;
          this.CableproInput.InstallTableId = this.installTableData[0].id;
          this.SelectInstallTableTableId = this.CableproInput.InstallTableId;

          //this.CableSize['tableno'] = this.installTableData[0].name;
          var installTableImageName = '', installTableImageDesc = '';


          if (this.installTableData[0].images.length - 1 < this.PrevImageIndex) {
            this.CableproInput.MethodIndex = this.installTableData[0].images[0].index;
            this.CableSize['tablectrlvalue'] = this.CableproInput.MethodIndex.toString();
            this.CableSize['description'] = this.installTableData[0].images[0].name + ' ' + this.installTableData[0].images[0].description;
            installTableImageName = this.installTableData[0].images[0].name;
            installTableImageDesc = this.installTableData[0].images[0].description;
          } else {
            this.CableproInput.MethodIndex = this.installTableData[0].images[this.PrevImageIndex].index;
            this.CableSize['tablectrlvalue'] = this.CableproInput.MethodIndex.toString();
            this.CableSize['description'] = this.installTableData[0].images[this.PrevImageIndex].name + ' ' + this.installTableData[0].images[this.PrevImageIndex].description;
            installTableImageName = this.installTableData[0].images[this.PrevImageIndex].name;
            installTableImageDesc = this.installTableData[0].images[this.PrevImageIndex].description;
          }
          this.showWarningOnInstallationChange(this.CableproInput.MethodIndex, this.CableproInput.InstallTableId, installTableImageName, installTableImageDesc, 'getdata');
          if (this.CableproInput.PhaseId.toString() !== '100' && this.CableproInput.PhaseId.toString() !== '102') {
            if (this.CableSize['tableno'] == '17') {
              setTimeout(() => {
                // $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img2.png');
                // $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img3.png');
              }, 1000);
            } else if (this.CableSize['tableno'] == '18') {
              setTimeout(() => {
                $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img3.png');
                $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img4.png');
                $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img5.png');
              }, 1000);
            }
          }
          if (this.CableSize['tableno'] == '16') {
            setTimeout(() => {
              $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('title', 'Derating factor: 0.76');
              $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('title', 'Derating factor: 0.58');
              $('#divInstallTbl table tr:nth-child(4) img')[0].setAttribute('title', 'Derating factor: 0.47');
              $('#divInstallTbl table tr:nth-child(5) img')[0].setAttribute('title', 'Derating factor: 0.4');
            }, 1000);
          }
        }
        if (result.specifyConductorDto !== null && result.specifyConductorDto !== undefined && result.specifyConductorDto.length > 0) {
          this.specifyConductorData = result.specifyConductorDto;

          if (this.PrevActiveValue !== undefined) {
            let val = this.specifyConductorData.filter(x => x.value === this.PrevActiveValue.trim() || x.value === this.PrevActiveValue.trim() + ' mm²');
            if (val.length > 0) {
              this.CableproInput.ActiveId = val[0].id;
              this.PrevActiveValue = val[0].value.replace(' mm²', '');
            } else {
              this.CableproInput.ActiveId = this.specifyConductorData[0].id;
            }
          } else {
            this.CableproInput.ActiveId = this.specifyConductorData[0].id;
            this.PrevActiveValue = this.specifyConductorData[0].value.replace(' mm²', '');
          }
          if (this.PrevNeutralValue !== undefined) {
            let val = this.specifyConductorData.filter(x => x.value === this.PrevNeutralValue.trim() || x.value === this.PrevNeutralValue.trim() + ' mm²');
            if (val.length > 0) {
              this.CableproInput.NeutralId = val[0].id;
            } else {
              this.CableproInput.NeutralId = this.specifyConductorData[0].id;
            }
          } else {
            this.CableproInput.NeutralId = this.specifyConductorData[0].id;
          }
        }
        if (result.windSpeedDto !== null && result.windSpeedDto !== undefined) {
          this.windSpeedData = result.windSpeedDto;
          if (this.windSpeedData.length > 0) {
            this.hasWind = true;
            // 
            if (result.cableproXmlInputOpen != undefined && result.cableproXmlInputOpen != null) {
              this.CableproInput.WindSpeedId = this.windSpeedData[result.cableproXmlInputOpen.windSpeedId].id;
              this.CableSize['installtablewind']['wind'] = this.windSpeedData[result.cableproXmlInputOpen.windSpeedId].xmlValue; // ak change
            }
            else {
              this.CableproInput.WindSpeedId = this.windSpeedData[0].id;
              this.CableSize['installtablewind']['wind'] = this.windSpeedData[0].xmlValue;
              //    this.onWindChange();


            }

          } else {
            this.hasWind = false;
          }
        }
        if (result.uiControlsLookupDto !== null && result.uiControlsLookupDto !== undefined) {
          this.uiControlsLookUpData = result.uiControlsLookupDto;
          this.CableSize['protection'] = {};
          this.CableSize['protection']['IsUnknown'] = this.protectiveUnknown;
          this.CableSize['protection']['Xml'] = this.xmlData;
          for (let i = 0; i < result.uiControlsLookupDto.length; i++) {
            if (result.uiControlsLookupDto[i].type === 'Protection' && protection !== '') {
              if (result.uiControlsLookupDto[i].uiControlsValues === protection) {
                for (let j = 0; j < result.uiControlsLookupDto[i].controles.length; j++) {
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Short-circuit time') {
                    this.CableSize['protection']['shortcircuittime'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Earth fault time') {
                    this.CableSize['protection']['earthfaulttime'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                    this.earthfaulttime = parseInt(result.uiControlsLookupDto[i].controles[j].fDefaultValue);
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Rating') {
                    for (let k = 0; k < result.uiControlsLookupDto[i].controles[j].cValue.length; k++) {
                      if (result.uiControlsLookupDto[i].controles[j].cValue[k].name === result.uiControlsLookupDto[i].controles[j].fDefaultValue) {
                        if (protection === 'HRC Fuse') {
                          this.CableSize['protection']['HRCFuserating'] = result.uiControlsLookupDto[i].controles[j].cValue[k].value;
                        }
                        else {
                          this.CableSize['protection']['' + protection + 'rating'] = result.uiControlsLookupDto[i].controles[j].cValue[k].value;
                        }
                      }
                    }
                    setTimeout(() => {
                      if (protection === 'MCB') {
                        if (this.PrevMCBVal === '') {
                          this.PrevMCBVal = $('#select_MCB').prop("selectedIndex");
                        }
                        if (this.PrevMCBVal !== '') {
                          $('#select_' + protection)[0][this.PrevMCBVal].selected = true;
                          this.CableSize['protection']['' + protection + 'rating'] = $('#select_' + protection)[0][this.PrevMCBVal.toString()].value;

                          this.ProtectionCalcDropdown('', $('#select_' + protection)[0][this.PrevMCBVal]);
                        }
                      } else if (protection === 'MCCB') {
                        if (this.PrevMCCBVal === '') {
                          this.PrevMCCBVal = $('#select_MCCB').prop("selectedIndex");
                        }
                        if (this.PrevMCCBVal !== '') {
                          $('#select_' + protection)[0][this.PrevMCCBVal].selected = true;
                          this.CableSize['protection']['' + protection + 'rating'] = $('#select_' + protection)[0][this.PrevMCCBVal].value;
                          this.ProtectionCalcDropdown('', $('#select_' + protection)[0][this.PrevMCCBVal]);
                          let max = $('#select_MCCB option:selected')[0].innerText.split(" ")[1];
                          $('input[caption="Thermal setting"]').attr('max', max);
                        }
                      } else if (protection === 'ACB') {
                        if (this.PrevACBVal === '') {
                          this.PrevACBVal = $('#select_ACB').prop("selectedIndex");
                        }
                        if (this.PrevACBVal !== '') {
                          $('#select_' + protection)[0][this.PrevACBVal].selected = true;
                          this.CableSize['protection']['' + protection + 'rating'] = $('#select_' + protection)[0][this.PrevACBVal].value;
                          this.ProtectionCalcDropdown('', $('#select_' + protection)[0][this.PrevACBVal]);
                          let max = $('#select_ACB option:selected')[0].innerText.split(" ")[1];

                          $('input[caption="Thermal setting"]').attr('max', max);
                        }
                      } else if (protection === 'HRC Fuse') {
                        if (this.PrevHRCVal === '') {
                          this.PrevHRCVal = $('#select_HRCFuse').prop("selectedIndex");
                        }
                        if (this.PrevHRCVal !== '') {
                          $('#select_HRCFuse')[0][this.PrevHRCVal].selected = true;
                          this.CableSize['protection']['HRCFuserating'] = $('#select_HRCFuse')[0][this.PrevHRCVal].value;
                          this.ProtectionCalcDropdown('', $('#select_HRCFuse')[0][this.PrevHRCVal]);
                        }
                      }
                      this.forceCalc = true;
                      this.select2Dropdown();
                      this.getAllControlsValue();
                    }, 100);
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Curve') {
                    for (let k = 0; k < result.uiControlsLookupDto[i].controles[j].cValue.length; k++) {
                      if (result.uiControlsLookupDto[i].controles[j].cValue[k].name === result.uiControlsLookupDto[i].controles[j].fDefaultValue) {
                        this.CableSize['protection']['curve'] = result.uiControlsLookupDto[i].controles[j].cValue[k].value;
                        this.protection_curve = result.uiControlsLookupDto[i].controles[j].cValue[k].value;
                      }
                    }
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'RCD') {
                    this.CableSize['protection']['rcd'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                    this.rcd_chk = result.uiControlsLookupDto[i].controles[j].fDefaultValue == "1";
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Trip current') {
                    this.CableSize['protection']['tripcurrent'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Trip Multiplier') {
                    this.CableSize['protection']['tripmultiplier'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Thermal setting') {
                    this.CableSize['protection']['thermalsetting'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Custom Rating') {
                    this.CableSize['protection']['customrating'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                    setTimeout(() => {
                      if (this.PrevCustomeRatingVal === '') {
                        this.PrevCustomeRatingVal = $('input').filter("[caption='Custom Rating']").val();
                      }
                      if (this.PrevCustomeRatingVal !== '') {
                        $('input').filter("[caption='Custom Rating']").val(this.PrevCustomeRatingVal);
                        this.CableSize['protection']['customrating'] = $('input').filter("[caption='Custom Rating']").val();
                        this.ProtectionCalcForCustomRating();
                      }
                    }, 100);
                  }
                  if (result.uiControlsLookupDto[i].controles[j].fCaption === 'Description') {
                    this.CableSize['protection']['description'] = result.uiControlsLookupDto[i].controles[j].fDefaultValue;
                  }
                }
              }
            }
          }
        }
      }
      this.getAllControlsValue();
      $(".tooltip").hide();
      //this.hideLoader();
    },
      error => {
        this.hideLoader();
      });

  }
  highlighttext(txt: any) {
    $(".clscurrent").removeClass('highlightcontrol');
    $("#currentdiv").removeAttr("data-toggle");
    $("#currentdiv").removeAttr("data-original-title");

    $(".clsrating").removeClass('highlightcontrol');
    $("#ratingdiv").removeAttr("data-toggle");
    $("#ratingdiv").removeAttr("data-original-title");

    $(".clsfaultlevel").removeClass('highlightcontrol');
    $("#faultleveldiv").removeAttr("data-toggle");
    $("#faultleveldiv").removeAttr("data-original-title");
    $("#faultleveldiv").removeAttr("title");

    $(".clsvoltagedrop").removeClass('highlightcontrol');
    $("#voltagedropdiv").removeAttr("data-toggle");
    $("#voltagedropdiv").removeAttr("data-original-title");
    $("#voltagedropdiv").removeAttr("title");

    $(".clsthermal[caption='Thermal setting']").removeClass('highlightcontrol');
    $("#clsthermaldiv").removeAttr("data-original-title");
    $("#clsthermaldiv").removeAttr("data-toggle");

    $(".ddlmcb").removeAttr("data-original-title");
    $(".ddlmcb").removeAttr("data-toggle");

    $(".ddlhrcfuse").removeAttr("data-original-title");
    $(".ddlhrcfuse").removeAttr("data-toggle");

    var droporrise = this.voltageSupplyLabel;

    $(".ddlmcb").removeClass('borderdropdown');
    $(".ddlhrcfuse").removeClass('borderdropdown');

    //$("#clsthermaldiv[caption='Thermal setting']").removeAttr("data-original-title");


    if (txt == 'Current') {
      //this.clscurrent = true;
      $("#currentdiv").attr("data-toggle", "tooltip");
      $("#currentdiv").attr("data-original-title", "Current or device rating is dictating the active size");
      $(".clscurrent").addClass('highlightcontrol');

      $("#ratingdiv").attr("data-toggle", "tooltip");
      $("#ratingdiv").attr("data-original-title", "Current or device rating is dictating the active size");
      $(".clsrating").addClass('highlightcontrol');

      $(".clsthermal[caption='Thermal setting']").addClass('highlightcontrol');
      $("#clsthermaldiv").attr("data-toggle", "tooltip");
      $("#clsthermaldiv").attr("data-original-title", "Current or device rating is dictating the active size");

      //$("#clsthermaldiv[caption='Thermal setting']").attr("data-toggle","tooltip");
      $(".ddlmcb").addClass('borderdropdown');
      $(".ddlmcb").attr("data-toggle", "tooltip");
      $(".ddlmcb").attr("data-original-title", "Current or device rating is dictating the active size");

      $(".ddlhrcfuse").addClass('borderdropdown');
      $(".ddlhrcfuse").attr("data-toggle", "tooltip");
      $(".ddlhrcfuse").attr("data-original-title", "Current or device rating is dictating the active size");

      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });


    }
    else if (txt == 'Voltage drop') {

      $(".clsvoltagedrop").addClass('highlightcontrol');
      $("#voltagedropdiv").attr("data-toggle", "tooltip");
      $("#voltagedropdiv").attr("data-original-title", "Voltage " + droporrise + " is dictating the active size");
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });

    }
    else if (txt == 'Short-circuit') {
      $("#faultleveldiv").attr("data-toggle", "tooltip");
      $("#faultleveldiv").attr("data-original-title", "Short-circuit is dictating the active size");
      $(".clsfaultlevel").addClass('highlightcontrol');
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });

    }
    else if (txt == 'Voltage drop and Short-circuit') {

      $("#faultleveldiv").attr("data-toggle", "tooltip");
      $("#faultleveldiv").attr("data-original-title", "Voltage " + droporrise + " and/or short-circuit are dictating the active size");
      $("#voltagedropdiv").attr("data-toggle", "tooltip");
      $("#voltagedropdiv").attr("data-original-title", "Voltage " + droporrise + " and/or short-circuit are dictating the active size");

      $(".clsfaultlevel").addClass('highlightcontrol');
      $(".clsvoltagedrop").addClass('highlightcontrol');
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
      });

    }
    else if (txt == 'Manual') {

    }

  }
  getAllControlsValue() {
    this.flag = false;
    if (this.CableSizeValuesUpdate()) {
      this.isCalculating = true;
      this.CableSize['browsername'] = this.detectBrowserName();
      this.CableSize['calculationId'] = this.newCalculationId;
      this.CableSize['UserName'] = this.user.userName;
      if (!this.isOldCalculation) {
        this.showLoader();
        this._CableproCalc.IECCalculate(this.CableSize).subscribe((result) => {
          if (result && result.Result) {
            this.CalculationResult = JSON.parse(result.Result)

            if (result.errorstring) {
              this.warningErrorStrData = JSON.stringify(result.errorstring);
              this.generateErrorsModel(result.errorstring);
            }
            else {
              this.warningErrorStrData = "";
            }
            this.isCalculating = false;
            this.forceCalc = false;
            let res = new CalculationResult();
            res.Id = this.newCalculationId;
            res.resultValue = result.Result;

            this.resultXml = res.resultValue;
            // this.Xml = result;
            this.Dictatingfactorres = this.CalculationResult.Report["Cable Size Results"]["Dictating factor for active size:"];

            this.highlighttext(this.Dictatingfactorres);
            if (this.newCalculationId > 0) {
              this._CableproCalc.setCalculationOutput(res).subscribe((result) => {
              });
            }
            // if (!isNaN(this.Xml.neutral.Val) && this.Xml.neutral.Val.toString().indexOf('.') != -1) {
            //   this.neutral_res = parseFloat(this.Xml.neutral.Val);
            // } else {
            //   this.neutral_res = parseInt(this.Xml.neutral.Val);
            // }
            // this.active_NoOf_circuit = this.Xml.active1.Val;
            this.active_res = this.CalculationResult.Summary["Active"];
            let val = this.specifyConductorData.filter(x => x.value === this.active_res);
            if (val.length > 0) {
              this.CableproInput.ActiveId = val[0].id;
              this.PrevActiveValue = val[0].value.replace(' mm²', '');
            }
            this.neutral_res = this.CalculationResult.Summary["Neutral"];
            this.active_NoOf_circuit = this.CalculationResult.Summary["No. of active circuits"];
            $('#Active_c').val(this.active_NoOf_circuit);

            this.neutral_NoOf_circuit = this.CalculationResult.Summary["No. of neutral circuits"];
            $('#Neutral_c').val(this.neutral_NoOf_circuit);

            this.earth_NoOf_circuit = this.CalculationResult.Summary["No. of earth circuits"];
            $('#Earth_c').val(this.earth_NoOf_circuit);
            this.earth_res = this.CalculationResult.Summary["Earth"];
            if ($('#earth-chk').is(':checked') === true) {
              this.earth_NoOf_circuit = '-';
              $('#earth_lab').children().hide();
            } else {
              if (!isNaN(this.earth_NoOf_circuit) && this.earth_NoOf_circuit.toString().indexOf('.') != -1) {
                if ($('#earth_lab').children().length) {
                  $('#earth_lab').children().show();
                }
              } else {
                if ($('#earth_lab').children().length) {
                  $('#earth_lab').children().show();
                }
              }
            }

            this.voltage_res = this.CalculationResult.Summary["Voltage drop"];
            // this.voltage_res1 = this.Xml.voltageDrop ? this.RemoveTrailingZeros((Math.round(this.Xml.voltageDrop.Val * 100) / 100).toFixed(2)) : 0;
            this.faultLoop_res = this.CalculationResult.Summary["Fault loop impedance"];
            // //this.conduit_res = this.Xml.conduit.Val;
            // this.Circuitrating_drated = Math.round(this.Xml.Circuitrating_drated.Val);
            // this.Currentrating_cable_tabulated = Math.round(this.Xml.Currentrating_cable_tabulated.Val);

            // if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "61") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "6-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "91") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "9-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "121") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "12-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "151") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "15-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "51") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "5-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "81") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "8-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "111") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "11-1";
            // }
            // else if (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val == "141") {
            //   this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val = "14-1";
            // }


            // if (parseInt(this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val) == 341) {
            //   this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val = "34-1";
            // }
            // else if (parseInt(this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val) == 351) {
            //   this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val = "35-1";
            // }

            // this.Currentrating_cable_tabulated_Ref_Desc_TableNo = this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val != null && this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val != undefined ? (this.Xml.Currentrating_cable_tabulated_Ref_Desc_TableNo.Val).split('.')[0] : "";
            // this.Currentrating_cable_tabulated_Ref_Desc_ColumnNo = this.Xml.Currentrating_cable_tabulated_Ref_Desc_ColumnNo.Val;
            // this.CCC_Currentrating_cable_tabulated_Operating_temperature = Math.round(this.Xml.CCC_Currentrating_cable_tabulated_Operating_temperature.Val * 100) / 100;
            // this.VoltageDrop_RefAndDesc_Resistance_TableNo = this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val != null && this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val != undefined ? (this.Xml.VoltageDrop_RefAndDesc_Resistance_TableNo.Val).split('.')[0] : "";
            // this.VoltageDrop_RefAndDesc_Resistance_ColumnNo_MinTemp = this.Xml.VoltageDrop_RefAndDesc_Resistance_ColumnNo_MinTemp.Val;
            // this.VoltageDrop_RefAndDesc_Resistance_ColumnNo_MaxTemp = this.Xml.VoltageDrop_RefAndDesc_Resistance_ColumnNo_MaxTemp.Val;
            // this.VoltageDrop_RefAndDesc_Reactance_TableNo = this.Xml.VoltageDrop_RefAndDesc_Reactance_TableNo.Val;
            // this.VoltageDrop_RefAndDesc_Reactance_ColumnNo = this.Xml.VoltageDrop_RefAndDesc_Reactance_ColumnNo.Val;
            // this.VoltageDrop_Data_PhaseConductor_Resistance = Math.round(this.Xml.VoltageDrop_Data_PhaseConductor_Resistance.Val * 10000) / 10000;
            // this.VoltageDrop_Data_PhaseConductor_Reactance = Math.round(this.Xml.VoltageDrop_Data_PhaseConductor_Reactance.Val * 10000) / 10000;
            // this.VoltageDrop_Result_MaxLengthOfRun = Math.round(this.Xml.VoltageDrop_Result_MaxLengthOfRun.Val * 100) / 100;
            // this.CableSize['currentamp'] = this.Xml.currentamp ? this.Xml.currentamp : '';
            // this.ShortCircuitPerformance_PhaseConductor_MinActive_Cond_Size = Math.round(this.Xml.ShortCircuitPerformance_PhaseConductor_MinActive_Cond_Size.Val * 100) / 100;
            // this.ShortCircuitPerformance_PhaseConductor_kfactor = Math.round(this.Xml.ShortCircuitPerformance_PhaseConductor_kfactor.Val * 100) / 100;
            if (this.CalculationResult.Report["Short-circuit Performance:"]["Pass/Fail"].includes('FAIL')) {
              this.ShortCircuitPerformance_ok = "0";
            }
            else {
              this.ShortCircuitPerformance_ok = "1";
            }
            // this.ShortCircuitPerformance_EarthConductor_ok = this.Xml.ShortCircuitPerformance_EarthConductor_ok.Val;
            if (this.ShortCircuitPerformance_ok == '0')
              this.displayShortCircuitPerformance = true;
            else
              this.displayShortCircuitPerformance = false;

            // this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct.Val * 100) / 100;
            // this.ShortCircuitPerformance_NuetralConductor_MinNuetral_Cond_Size = Math.round(this.Xml.ShortCircuitPerformance_NuetralConductor_MinNuetral_Cond_Size.Val * 100) / 100;
            // this.ShortCircuitPerformance_NuetralConductor_Kfactor = Math.round(this.Xml.ShortCircuitPerformance_NuetralConductor_Kfactor.Val * 100) / 100;
            // this.ShortCircuitPerformance_EarthConductor_MinEarth_Cond_Size = Math.round(this.Xml.ShortCircuitPerformance_EarthConductor_MinEarth_Cond_Size.Val * 100) / 100;
            // this.ShortCircuitPerformance_EarthConductor_Kfactor = Math.round(this.Xml.ShortCircuitPerformance_EarthConductor_Kfactor.Val * 100) / 100;
            // this.ShortCircuitPerformance_EarthConductor_PhaseToEarthShort_cct = Math.round(this.Xml.ShortCircuitPerformance_EarthConductor_PhaseToEarthShort_cct.Val * 100) / 100;

            // this.CircuitCurrentrating_Adequate = this.Xml.CircuitCurrentrating_Adequate.Val;
            // this.VoltageDrop_Result_VoltageDrop_Acceptable = this.Xml.VoltageDrop_Result_VoltageDrop_Acceptable.Val;
            // this.EarthLoop_ok = this.Xml.EarthLoop_ok.Val;
            // this.MaxAllowedDevice = this.Xml.MaxAllowedDevice.Val;
            this.ConduitDiameter = this.CalculationResult["UI Controls"]["Active min. conduit diameter (mm)"];
            this.MinimumConduitDiameter = this.CalculationResult["UI Controls"]["Active min. conduit diameter (mm)"];
            if (this.CalculationResult.Summary["Conduit size"] == "-") {
              this.ConditSizeFound = this.CalculationResult.Summary["Conduit size"];
              this.ShowConduitSize = false;
              this.CableSize['conduitsize']['mode'] = '0';
              $('#conduit-size-toggle').prop('checked', false);
              this.ShowConduitSizeLab = true;
              //this.getAllControlsValue();
            }
            else {
              this.ConditSizeFound = this.CalculationResult.Summary["Conduit size"];
              //this.ConditSizeBasedOn = this.Xml.conduitsizebasedon;
              this.ConduitDiameter = this.CalculationResult["UI Controls"]["Active min. conduit diameter (mm)"];
              if (this.CableSize['conduitsize']['mode'] == '0') {
                this.CableSize['conduitsize']['size'] = this.ConduitDiameter;
                this.CableproInput.ConduitSizeId = this.ConduitDiameter;
              }
            }

            // this.NoofConduit = this.Xml.NoofConduit ? this.Xml.NoofConduit.Val : '1';
            // this.ConditCableDiameter = this.Xml.ConditCableDiameter ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditCableDiameter.Val * 100) / 100).toFixed(2)) : 0;
            // this.ConditCableDiameterActive = this.Xml.ConditCableDiameterActive ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditCableDiameterActive.Val * 100) / 100).toFixed(2)) : 0;
            // this.Activeneutralshownseparately = this.Xml.Activeneutralshownseparately;
            // this.ConditCableDiameterNeutral = this.Xml.ConditCableDiameterNeutral ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditCableDiameterNeutral.Val * 100) / 100).toFixed(2)) : 0;

            this.conduitSizes = this.conduitSizesPristine.filter(m => parseFloat(m.id) >= parseFloat(this.MinimumConduitDiameter));
            if (this.ShowConduitSize) {
              let selectedOption = this.conduitSizes.find(x => x.id == this.CableproInput.ConduitSizeId);
              if (!selectedOption) {
                this.CableproInput.ConduitSizeId = this.conduitSizes[0].id;
                this.CableSize['conduitsize']['size'] = this.CableproInput.ConduitSizeId;
                this.getAllControlsValue();
              }
            }
            // if (this.Activeneutralshownseparately == "1") {
            //   if (this.ShowConduitSize) {
            //     $('#conduit-size-toggle').click();
            //   }
            //   $('#conduit-size-toggle').attr('disabled', 'true');
            // } else {
            //   $('#conduit-size-toggle').removeAttr('disabled');
            // }

            // this.ConditSpaceFactorActual = this.Xml.ConditSpaceFactorActual ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditSpaceFactorActual.Val * 100) / 100).toFixed(2)) : 0;
            // this.ConditSpaceFactorStandard = this.Xml.ConditSpaceFactorStandard ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditSpaceFactorStandard.Val * 100) / 100).toFixed(2)) : 0;
            // this.ConditSpaceFactorActualNeutral = this.Xml.ConditSpaceFactorActualNeutral ? this.RemoveTrailingZeros((Math.round(this.Xml.ConditSpaceFactorActualNeutral.Val * 100) / 100).toFixed(2)) : 0;
            // this.ConditNoofCablesPerCondit = this.Xml.ConditNoofCablesPerCondit ? this.Xml.ConditNoofCablesPerCondit.Val : 0;
            // this.ConditNoofCablesPerConditActive = this.Xml.ConditNoofCablesPerConditActive ? this.Xml.ConditNoofCablesPerConditActive.Val : 0;
            // this.ConditNoofCablesPerConditNeutral = this.Xml.ConditNoofCablesPerConditNeutral ? this.Xml.ConditNoofCablesPerConditNeutral.Val : 0;
            // this.NoofConduit = this.Xml.NoofConduit ? this.RemoveTrailingZeros((Math.round(this.Xml.NoofConduit.Val * 100) / 100).toFixed(2)) : "0";
            // this.ConditRefrenceTable = this.Xml.ConditRefrenceTable ? this.Xml.ConditRefrenceTable.Val : '';
            // this.ConditNeutralRefrenceTable = this.Xml.ConditNeutralRefrenceTable ? this.Xml.ConditNeutralRefrenceTable.Val : '';

            // this.faultloop1 = parseFloat(this.Xml.faultloop1.Val).toFixed(4);
            // this.faultloop2 = parseFloat(this.Xml.faultloop2.Val).toFixed(4);
            // this.faultloop3 = parseFloat(this.Xml.faultloop3.Val).toFixed(4);
            // this.faultloop4 = parseFloat(this.Xml.faultloop4.Val).toFixed(4);
            // this.faultloop5 = parseFloat(this.Xml.faultloop5.Val).toFixed(4);
            // this.faultloop6 = parseFloat(this.Xml.faultloop6.Val).toFixed(4);
            // this.faultloop7 = parseFloat(this.Xml.faultloop7.Val).toFixed(2);

            // if (this.CircuitCurrentrating_Adequate == '0') {
            //   $("#active_lab").css("cssText", "color: red !important;");
            // } else {
            //   $("#active_lab").css("cssText", "color: rgba(0, 0, 0) !important;");
            // }          
            if (this.CalculationResult.Report["Voltage Drop:"]["Pass/Fail"].includes('PASS')) {
              $('.vda').css("cssText", "color: rgba(0, 0,0) !important;");
            } else {
              $('.vda').css("cssText", "color: red !important;");
            }
            if (this.CalculationResult.Report["Fault Loop Impedance:"]["Pass/Fail"] == 'PASS') {
              $('.fli').css("cssText", "color: rgba(0,0, 0) !important;");
            } else {
              $('.fli').css("cssText", "color: red !important;");
            }
            // // if (this.ConditSizeFound == "1") {
            // // this.ConditSizeFound = Math.round(this.Xml.conduit.Val) ;//+ ' ' + 'mm';
            // // }
            // //else {
            // //   this.ConditSizeFound = '-';

            // //}
            // /*if (this.ConditSizeFound === '0') {
            //     this.ConditSizeFound = '-';
            // } else {
            //     this.ConditSizeFound = Math.round(this.Xml.conduit.Val) + ' ' + 'mm';
            // }*/
            this.Spare_current_capacity_of_circuit = this.CalculationResult.Summary["Spare capacity"];
            if (parseInt(this.Spare_current_capacity_of_circuit) < 0) {
              $('.spr').css("cssText", "color: red !important;");
            } else {
              $('.spr').css("cssText", "color: rgba(0,0, 0) !important;");
            }

            if (this.newCalculationId) {
              this.cableproXmlInput.xmlValue = result.InputXml;
              this.cableproXmlInput.errorString = this.warningErrorStrData;
              this.cableproXmlInput.installId = this.SelectInstallTableTableId;
              this.cableproXmlInput.resultValue = this.resultXml;
              this.cableproXmlInput.id = this.newCalculationId;
              // this.vdrop = this.Xml.voltageDrop.Val;
              // this.vdroppecent = this.Xml.voltage.Val;
              // this.vdropPermissibale = this.Xml.PermissableVoltageDrop.Val;
              // this.referencetempdegCReport = this.Xml.ReferencetempdegCReport.Val;

              // this.activeCondz1Report = Math.round(this.Xml.ActiveCondz1Report.Val * 1000000) / 1000000;
              // this.Earthcondz2Report = Math.round(this.Xml.Earthcondz2Report.Val * 1000000) / 1000000;
              // this.VoltageDrop_Data_NeutralConductor_Resistance = Math.round(this.Xml.VoltageDrop_Data_NeutralConductor_Resistance.Val * 10000) / 10000;
              // this.VoltageDrop_Data_NeutralConductor_Reactance = Math.round(this.Xml.VoltageDrop_Data_NeutralConductor_Reactance.Val * 10000) / 10000;

              // this.Three_phaseShort_circuitCurrent = Math.round(this.Xml.Three_phaseShort_circuitCurrent.Val * 10) / 10;
              // this.Active_to_EarthShort_circuitCurrent = Math.round(this.Xml.Active_to_EarthShort_circuitCurrent.Val * 10) / 10;
              // this.tempDeracting = this.CableSize['deratingfactor'];
              if (navigator.onLine === true) {
                this.UpdateXmlValues(this.cableproXmlInput);
              } else {
                this.hideLoader();
                $('#popup-mask').show();
              }
              this.showHideProtectionWarning();
            }
          }
        }, error => {
          this.hideLoader();

        });
      }
      else {
        this.hideLoader();
      }
    }

  }

  onretrySave() {
    $('#retry-save').on('click', () => {
      if (navigator.onLine === true) {
        this.UpdateXmlValues(this.cableproXmlInput);
        $('#popup-mask').hide();
      }
    });
    $('#dismissAlert').on('click', () => {
      $('#popup-mask').hide();
    });
  }
  onSelectInstallTable() {

    let methodIndex = this.SelectInstallTableMethodIndex;
    let tableId = this.SelectInstallTableTableId;
    let name = this.SelectInstallTableName;
    let description = this.SelectInstallTableDescription;
    this.CableSize['conduitsize']['mode'] = '0';

    if (this.CableproInput.PhaseId.toString() !== '100' && this.CableproInput.PhaseId.toString() !== '102') {
      if (this.CableSize['tableno'] == '17') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img2.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img3.png');
        }, 100);
      } else if (this.CableSize['tableno'] == '18') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img3.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img4.png');
          $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img5.png');
        }, 100);
      }
    }
    if (this.CableSize['tableno'] == '16') {
      setTimeout(() => {
        $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('title', 'Derating factor: 0.76');
        $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('title', 'Derating factor: 0.58');
        $('#divInstallTbl table tr:nth-child(4) img')[0].setAttribute('title', 'Derating factor: 0.47');
        $('#divInstallTbl table tr:nth-child(5) img')[0].setAttribute('title', 'Derating factor: 0.4');
      }, 100);
    }
    this.CableproInput.MethodIndex = methodIndex;
    this.PrevImageIndex = methodIndex;
    $('#divInstallTbl').find('img').each(function (e) {
      if ($(this).attr('data-index') === methodIndex.toString()) {
        $(this).attr('style', 'border:2px #2ea1f8 solid').attr('style', 'width:100%');
      } else {
        $(this).attr('style', 'border:2px #fff solid').attr('style', 'width:100%');
      }
    });
    this.CableSize['tablectrlvalue'] = this.CableproInput.MethodIndex;
    this.CableSize['description'] = name + ' ' + description;
    this.GetData('installation', '', 0, this.CableproInput.ConductorId, 0, 0, this.CableproInput.MethodIndex, tableId, 0, '', '', this.newCalculationId, 0, 0, this.CableproInput.EarthConductorId);
  }
  specifyConductorChange() {
    $('#active-toggle').change((e) => {

      if ($(e.target).is(':checked') === true) {
        //console.log('checked');
        this.ShowActive = true;
        $('#Active_c').removeAttr('disabled');
        this.showActiveLab = false;
        // alert(this.PrevActiveValue);
        this.CableSize['specifyconductor']['phase']['mode'] = '1';
        this.CableSize['specifyconductor']['phase']['size'] = this.PrevActiveValue !== undefined ? parseFloat(this.PrevActiveValue.replace(' mm²', '')) : 1;
        this.CableSize['specifyconductor']['phase']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      } else {
        //console.log('not checked');
        this.ShowActive = false;
        $('#Active_c').attr('disabled', 'true');
        $('#Active_c').val(1);
        this.showActiveLab = true;
        this.CableSize['specifyconductor']['phase']['mode'] = '0';
        this.CableSize['specifyconductor']['phase']['size'] = '25';
        //    alert(this.CableSize['specifyconductor']['phase']['circuits']);
        this.CableSize['specifyconductor']['phase']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      }
    });
    $('#conduit-size-toggle').change((e) => {

      if ($(e.target).is(':checked') === true) {

        this.ShowConduitSize = true;
        this.ShowConduitSizeLab = false;
        this.CableSize['conduitsize']['mode'] = '1';

        this.getAllControlsValue();
      } else {
        //console.log('not checked');
        this.ShowConduitSize = false;

        this.ShowConduitSizeLab = true;
        this.CableSize['conduitsize']['mode'] = '0';
        this.getAllControlsValue();
      }
    });
    $('#neutral-toggle').change((e) => {
      if ($(e.target).is(':checked') === true) {
        this.ShowNeutral = true;
        $('#Neutral_c').removeAttr('disabled');
        this.ShowNeutralLab = false;
        this.CableSize['specifyconductor']['neutral']['mode'] = '1';
        this.CableSize['specifyconductor']['neutral']['size'] = this.PrevNeutralValue !== undefined ? parseFloat(this.PrevNeutralValue.replace(' mm²', '')) : 1;

        this.CableSize['specifyconductor']['neutral']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      } else {
        this.ShowNeutral = false;
        $('#Neutral_c').attr('disabled', 'true');
        $('#Neutral_c').val(1);
        this.ShowNeutralLab = true;
        this.CableSize['specifyconductor']['neutral']['mode'] = '0';
        this.CableSize['specifyconductor']['neutral']['size'] = '25';
        this.CableSize['specifyconductor']['neutral']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      }
    });
    $('#earth-toggle').change((e) => {
      if ($(e.target).is(':checked') === true) {
        this.ShowEarth = true;
        $('#Earth_c').removeAttr('disabled');
        this.ShowEarthLab = false;
        this.CableSize['specifyconductor']['earth']['mode'] = '2';
        let obj = this.earthList.find(m => m.id == this.CableproInput.EarthId);
        if (obj)
          this.CableSize['specifyconductor']['earth']['size'] = obj.text.split(" ")[0];
        this.CableSize['specifyconductor']['earth']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      } else {
        this.ShowEarth = false;
        $('#Earth_c').attr('disabled', 'true');
        $('#Earth_c').val(1);
        this.ShowEarthLab = true;
        this.CableSize['specifyconductor']['earth']['mode'] = '1';
        this.CableSize['specifyconductor']['earth']['size'] = '25';
        this.CableSize['specifyconductor']['earth']['circuits'] = '1';
        //console.log("specifyConductorChange-getAllControlsValue");
        this.getAllControlsValue();
      }
    });
    $('#protection-toggle').change((e) => {
      if ($(e.target).is(':checked') === true) {
        this.cableCalcProtectiveDeviceSource = '1';
        this.CableSize['cableCalcProtectiveDeviceSource'] = '1';
        // this.protectiveUnknown = false;
        // this.CableSize['protection']['IsUnknown'] = this.protectiveUnknown;
        this.getAllControlsValue();

      } else {
        //console.log('not checked');
        this.cableCalcProtectiveDeviceSource = '0';
        this.CableSize['cableCalcProtectiveDeviceSource'] = '0';
        // this.device = "0";
        // this.CableSize['device'] = this.device;
        this.getAllControlsValue();
      }
    });
  }
  ngAfterViewInit() {
    //console.log('ngAfterViewInit');
    this.loading = true;
    setTimeout(() => {
      $(document).off('change', '#ddlunit');

      $('#ddlunit').on('change', (e: any, isTriggered) => {

        this.currentUnit = (e.target.options[e.target.selectedIndex].value);
        if (this.currentUnit == "1") {
          if (this.voltageSupplyLabel == "rise") {
            this.lblcurrent = 'Output current';
          }
          else
            this.lblcurrent = 'Current';
        }
        else {
          if (this.voltageSupplyLabel == "rise") {
            this.lblcurrent = 'Output power';
          }
          else
            this.lblcurrent = 'Power';
        }


        if (this.currentUnit == "4") {
          this.showEfficency = true;
        }
        else {
          this.showEfficency = false;

        }

        if (this.currentUnit != null && this.currentUnit != "") {

          this.CableSize['powerunit'] = this.currentUnit;
          //console.log('onCurrentChange-getAllControlsValue');
          if (isTriggered != "true")
            this.getAllControlsValue();
        }

      });

      if ($('.c-select').length) {
        let $singleSelect = $('.c-select'),
          $singleSelectHasSearch = $('.c-select.has-search'),
          $multipleSelect = $('.c-select.c-select--multiple'),
          $disabledSelect = $('.c-select.is-disabled');

        $singleSelect.select2({
          width: '100%',
          minimumResultsForSearch: Infinity // disable search
        });

        // multiple select
        $multipleSelect.select2({
          width: '100%',
          multiple: true
        });

        // disabled select
        $disabledSelect.select2({
          width: '100%',
          disabled: true
        });
      }

      $('input[name=current]').change(this.showHideProtectionWarning);
      $('#gotopricing1, #gotopricing2, #spSubscribeNow').on('click', (e) => {
        this._router.navigate(['/app/main/projects/', 'subscriptionplans']);
      });


      $("#reportDlg").on('shown.bs.modal', () => {
        this.CalculationReportInput.jobNo = this.route.snapshot.queryParamMap.get('cname');
        this.calculationName = this.route.snapshot.queryParamMap.get('cname');

        this.CalculationReportInput.projectname = this.route.snapshot.queryParamMap.get('name');
        this.projectName = this.route.snapshot.queryParamMap.get('name');
      });

      $('#reportDlg').on('hidden.bs.modal', () => {
        this.ClearReport();
      });

      $('#okBtn').on('click', (e) => {

        this.onSelectInstallTable();
        $('#confrimation-model').modal('hide');
        this.UserWizard = false;
        this.CableSize['isderatingwiz'] = "0";
        // $('#checkboxUseWizard').removeAttr('checked');
        this.setInstallationType();
        this.onResetControlValues();
        this.updateDeratingFactorValue(false, this.CalculationReportInput.wizardValues);

      });
      $('#confrimation-model').modal({
        show: false,
        keyboard: false,
        backdrop: 'static'
      })
    });
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      $('.search-tooltip').tooltip({
        trigger: 'click',
        placement: 'auto'
      });
    } else {
      $('.search-tooltip').tooltip({
        trigger: 'hover',
        placement: 'auto'
      });
    }
    $('.search-tooltip').on('shown.bs.tooltip', function () {
      const tooltip = $(this).data('bs.tooltip');
      if (tooltip) {
        tooltip.update();
      }

      $('.tooltip-inner').css({
        'padding': '0.5rem',
        'line-height': '22px',
        'max-width': '365px'
      });
      $('.tooltip-inner em').css({
        'font-family': 'monospace',
        'padding': '0px 3px',
        'border': '2px solid #dc0',
        'background-color': '#fd0',
        'color': '#000',
        'display': '2px 3px',
        'margin': 'inline-block',
        'border-radius': '4px',
        'font-style': 'normal',
      });
    });
  }

  zoomScale() {
    let zoomLevel = 1;

    const resetZoom = () => {
      document.body.style.transform = 'scale(1)';
      document.body.style.transformOrigin = '0 0';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    };

    const adjustZoom = () => {
      // Check for scrollbars
      const hasVerticalScrollbar = document.documentElement.scrollHeight > window.innerHeight;
      const hasHorizontalScrollbar = document.documentElement.scrollWidth > window.innerWidth;

      if ((hasVerticalScrollbar || hasHorizontalScrollbar) && window.innerHeight > 500 && window.innerWidth > 992) {
        // Reduce the zoom level
        zoomLevel -= 0.01; // Decrease by 1% per iteration
        document.body.style.transform = `scale(${zoomLevel})`;
        document.body.style.transformOrigin = '0 0';

        // Compensate for scaled size
        document.body.style.width = `${100 / zoomLevel}%`;
        document.body.style.height = `${100 / zoomLevel}%`;

        // Continue adjusting
        requestAnimationFrame(adjustZoom);
      } else {
        // Send a message back to the parent to confirm
        //event.source.postMessage({ status: 'Zoom adjustment complete', zoomLevel }, event.origin);

        // Re-enable scrollbars if necessary
        document.body.style.overflow = 'auto';
      }
    };

    // Start adjusting zoom
    resetZoom();
    adjustZoom();
  }

  ngAfterContentInit() {
    $('#correctionWizard').on('hidden.bs.modal', () => {
      if (this.CableSize['isderatingwiz'] == "0")
        this.UserWizard = false;
    });
    $('#protectiveSelector').on('hidden.bs.modal', () => {
      // if (this.addingDeviceForUnknownDevice) {
      //     this.addingDeviceForUnknownDevice = false;
      //     this.unknownDeviceNode = undefined;
      //     this.unknownDeviceNodeHeader = undefined;
      //     this.protectiveImgSrc = 'assets/cablepro/logo/a.png';
      //     this.protectiveIncomerImgSrc = 'assets/cablepro/logo/a.png';
      //     this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';
      // }
      // this.checkingHVFuse = false;
      // this.defaultModelName = undefined;
      this.resetSearch();
    });

    $('#protectiveSelector').on('shown.bs.modal', () => {
      this.searchTerm = '';
    })

    $('#protectiveConfiguration').on('hidden.bs.modal', () => {
      this.protectiveConfigurationCancel();
      this.index = 0;
    });

  }

  onVoltageDrop(e: any) {
    //console.log('onVoltageDrop');
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 2);
    this.CableSize['voltagedrop'] = e.target.value;
    //console.log('onVoltageDrop-getAllControlsValue');
    this.getAllControlsValue();
  }
  onVoltageSupplyChange(e: any) {
    //console.log('onVoltageDrop');
    if (this.CableproInput.PhaseId.toString() == '110') /* DC */
      $('input[name="Voltage-Supply"]').attr('max', 1500);
    else
      $('input[name="Voltage-Supply"]').attr('max', 1000);

    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 2);

    this.CableSize['supplyvoltage'] = e.target.value;
    //console.log('supplyvoltage-getAllControlsValue');
    this.getAllControlsValue();
  }
  SetVoltageLabelValue(calledBy: string) {

    this.CableSize['usevd'] = '1';
    if (calledBy == 'rise') {
      // this.lblcurrent='Output current';

      if (this.currentUnit == "1") {
        this.lblcurrent = 'Output current';
      }
      else {
        this.lblcurrent = 'Output power';
      }
    }
    else {
      // this.lblcurrent='Current';

      if (this.currentUnit == "1") {
        this.lblcurrent = 'Current';
      }
      else {
        this.lblcurrent = 'Power';
      }

    }
    this.voltageSupplyLabel = calledBy;
    this.CableSize["isVoltageDrop"] = this.voltageSupplyLabel == "drop";

    if (this.voltageSupplyLabel !== this.prevVoltageSupplyLabel) {
      this.prevVoltageSupplyLabel = this.voltageSupplyLabel;
      this.UpdateVoltageLabelValue();
      this.getAllControlsValue();
    }
  }
  onFaultLevelChange(e: any) {
    //console.log('onFaultLevelChange');
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 4);

    this.CableSize['faultlevel'] = e.target.value;
    //console.log('onFaultLevelChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  onLengthOfRunChange(e: any) {
    //console.log('onLengthOfRunChange');
    // if (!this.premiumUser && e.target.value > 200) {
    //     $('#length-of-run-restriction-model').modal('show');
    //     e.target.value = this.CableSize['lengthofrun'];
    //     return false;
    // }
    // else {
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 2);

    this.CableSize['lengthofrun'] = e.target.value;
    //console.log('onLengthOfRunChange-getAllControlsValue');
    this.getAllControlsValue();
    // }
  }
  onActiveCircuitChange(e: any) {
    this.CommonValidationFn(e);
    let val = parseFloat(e.target.value);
    $(e.target).val(val.toFixed(0));
    this.CableSize['specifyconductor']['phase']['circuits'] = val.toFixed(0);
    //console.log('onActiveCircuitChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  onNeutralCircuitChange(e: any) {
    this.CommonValidationFn(e);
    let val = parseFloat(e.target.value);
    $(e.target).val(val.toFixed(0));
    this.CableSize['specifyconductor']['neutral']['circuits'] = val.toFixed(0);
    //console.log('onNeutralCircuitChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  onEarthCircuitChange(e: any) {
    this.CommonValidationFn(e);
    //console.log('onEarthCircuitChange');
    let val = parseFloat(e.target.value);
    $(e.target).val(val.toFixed(0));
    this.CableSize['specifyconductor']['earth']['circuits'] = val.toFixed(0);
    //console.log('onEarthCircuitChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  onCurrentChange(e: any) {
    //console.log('onCurrentChange');
    // if (!this.premiumUser && e.target.value > 200) {
    //     $('#current-restriction-model').modal('show');
    //     e.target.value = this.CableSize['current'];
    //     return false;
    // }
    // else {
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 4);
    this.CableSize['current'] = e.target.value;
    //console.log('onCurrentChange-getAllControlsValue');
    this.getAllControlsValue();
    //  }
  }
  onEfficiencyChange(e: any) {
    //console.log('onCurrentChange');
    this.CommonValidationFn(e);
    this.Allowdecimal(e);

    this.CableSize['efficiency'] = e.target.value;
    //console.log('onCurrentChange-getAllControlsValue');
    this.getAllControlsValue();

  }
  Allowdecimal(event: any) {
    var num = event.target.value;

    if (num.split('.').length > 0) {
      var beforezero = num.split('.')[0];
      if (beforezero == "") {
        num = "0" + num;
      }
    }
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : event.target.value;

    event.target.value = with2Decimals
    this.efficiency = event.target.value;
  }

  allowDecimalSetModal(event: any, type: string) {
    var num = event.target.value;
    if (num.split('.').length > 0) {
      var beforezero = num.split('.')[0];
      if (beforezero == "") {
        num = "0" + num;
      }
    }
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : event.target.value;

    event.target.value = with2Decimals
    if (type == "AmbientTemp") {
      this.table271model.AmbientTemp = event.target.value;
    }
    if (type == "AmbientTemp") {
      this.table271model.AmbientTemp = event.target.value;
    }
    if (type == "Depth") {
      this.table28model.Depth = event.target.value;
    }
  }
  allowDecimalSetModalThree(event: any, type: string) {
    var num = event.target.value;
    if (num.split('.').length > 0) {
      var beforezero = num.split('.')[0];
      if (beforezero == "") {
        num = "0" + num;
      }
    }
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,3})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0] : event.target.value;

    event.target.value = with2Decimals
    if (type == "Resitivity") {
      this.table29model.Resitivity = event.target.value;
    }
  }
  Allowdecimalwithplaces(event: any, places: number) {

    var num = event.target.value;
    var with2Decimals = 0;
    if (num.split('.').length > 0) {
      var beforezero = num.split('.')[0];
      if (beforezero == "") {
        num = "0" + num;
      }
    }
    if (places == 2) {
      with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] : event.target.value;

    }
    else if (places == 3) {
      with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,3})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0] : event.target.value;

    }
    else if (places == 4) {
      with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,4})?/) != null ? num.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0] : event.target.value;

    }

    event.target.value = with2Decimals
    //this.efficiency=event.target.value;
  }

  onPowerFactorChange(e: any) {
    //console.log('onPowerFactorChange');
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 3);
    //alert(e.target.value);
    this.CableSize['powerfactor'] = e.target.value;
    //console.log('onPowerFactorChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  onDeratingFactorChange(e: any) {
    //console.log('onDeratingFactorChange');
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 3);
    this.UserWizard = false;
    this.CableSize['isderatingwiz'] = "0";
    // $('#checkboxUseWizard').removeAttr('checked');

    this.CableSize['deratingfactor'] = e.target.value;
    this.getAllControlsValue();

    this.CalculationReportInput.wizardValues = new DRFWizrd();
    this.CalculationReportInput.wizardValues.finalDrf = Number(parseFloat(e.target.value).toFixed(2));
    this.CalculationReportInput.wizardValues.result = [];

    this.updateDeratingFactorValue(false, this.CalculationReportInput.wizardValues);
  }
  CommonValidationFn(event: any) {
    //console.log('CommonValidationFn');

    if (parseFloat(event.target.value) > parseFloat(event.target.max)) {
      event.target.value = event.target.max;
    }
    if (parseFloat(event.target.value) < parseFloat(event.target.min) || event.target.value === '') {
      event.target.value = event.target.min;
    }
    //this.getAllControlsValue();
  }
  ProtectionCalcDropdown(e: any, elem: any) {
    //console.log('ProtectionCalcDropdown');

    this._calculationService.getPrevValue().subscribe((result) => {
      let prevRatingValue = result;
      //console.log('prevRatingValue ' + prevRatingValue);
      const MultiplierValue = $('input').filter("[caption='Trip Multiplier']").val().toString();
      let RatingValue: any = '';
      if (e !== '') {
        RatingValue = e.target.options[e.target.selectedIndex].innerHTML.split(" ")[1];
        if (RatingValue < 100) {
          this.showLable = true;
        } else {
          this.showLable = false;
        }
      }
      if (elem !== '') {
        RatingValue = elem.innerHTML.split(" ")[1];
        if (RatingValue < 100) {
          this.showLable = true;
        } else {
          this.showLable = false;
        }
      }
      if (prevRatingValue == null || prevRatingValue == undefined || prevRatingValue == '') {
        prevRatingValue = RatingValue;
        this._calculationService.setPrevValue(RatingValue).subscribe((result) => { }, error => { });
      }

      if (prevRatingValue != RatingValue) {
        //console.log('RatingValue ' + RatingValue);
        this._calculationService.setPrevValue(RatingValue).subscribe((result) => {
          if ($('input').filter("[caption='Thermal setting']").length) {
            $('input').filter("[caption='Thermal setting']").val(RatingValue);
            //console.log('setting from here - ProtectionCalcDropdown ');
            this.CableSize['protection']['thermalsetting'] = RatingValue;
          }

          let currentValue: any = '';
          let Val1: any = '';
          let Val2: any = '';
          if (!isNaN(RatingValue) && RatingValue.toString().indexOf('.') != -1) {
            Val1 = parseFloat(RatingValue);
          } else {
            Val1 = parseInt(RatingValue);
          }
          if (!Number.isNaN(Number(MultiplierValue)) && MultiplierValue.toString().indexOf('.') != -1) {
            Val2 = parseFloat(MultiplierValue);
          } else {
            Val2 = parseInt(MultiplierValue);
          }
          currentValue = Val1 * Val2;
          currentValue = currentValue.toFixed(2);
          if ($('input').filter("[caption='Trip current']").length) {
            $('input').filter("[caption='Trip current']").val(currentValue);
            this.CableSize['protection']['tripcurrent'] = currentValue;
          }

          this.getAllControlsValue();
        });
      }
      //else {
      //    //console.log('ProtectionCalcDropdown-getAllControlsValue-Else');
      //    this.getAllControlsValue();
      //}
    });
  }
  ProtectionCalcForCustomRating() {
    //console.log('ProtectionCalcForCustomRating');
    const MultiplierValue = $('input').filter("[caption='Trip Multiplier']").val().toString();
    const RatingValue = $('input').filter("[caption='Custom Rating']").val().toString();
    $('input').filter("[caption='Thermal setting']").val(RatingValue);
    $('input[caption="Thermal setting"]').attr('max', RatingValue);
    //console.log('setting from here - ProtectionCalcForCustomRating ');
    this.CableSize['protection']['thermalsetting'] = RatingValue;
    let currentValue: any = '';
    let Val1: any = '';
    let Val2: any = '';
    if (RatingValue < (100).toString()) {
      this.showLable = true;
    } else {
      this.showLable = false;
    }
    if (!Number.isNaN(Number(RatingValue)) && RatingValue.toString().indexOf('.') != -1) {
      Val1 = parseFloat(RatingValue);
    } else {
      Val1 = parseInt(RatingValue);
    }
    if (!Number.isNaN(Number(MultiplierValue)) && MultiplierValue.toString().indexOf('.') != -1) {
      Val2 = parseFloat(MultiplierValue);
    } else {
      Val2 = parseInt(MultiplierValue);
    }
    currentValue = Val1 * Val2;
    currentValue = currentValue.toFixed(2);
    $('input').filter("[caption='Trip current']").val(currentValue);
    this.CableSize['protection']['tripcurrent'] = currentValue;
    //console.log('ProtectionCalcForCustomRating-getAllControlsValue');
    this.getAllControlsValue();
  }
  OnInputChange(e: any, numberofplaces: number) {
    //console.log('OnInputChange');
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, numberofplaces);
    const caption: string = e.target.getAttribute('caption');
    const device: string = e.target.getAttribute('device');
    if (caption === 'Short-circuit time') {
      this.CableSize['protection']['shortcircuittime'] = e.target.value;
    } else if (caption === 'Trip current') {
      this.CableSize['protection']['tripcurrent'] = e.target.value;
      this.ProtectionCalcForCurrentandMultiplier(e, device, caption);
    } else if (caption === 'Trip Multiplier') {
      this.CableSize['protection']['tripmultiplier'] = e.target.value;
      this.ProtectionCalcForCurrentandMultiplier(e, device, caption);
    } else if (caption === 'Thermal setting') {
      //console.log('OnInputChange-setting from here');
      this.CableSize['protection']['thermalsetting'] = e.target.value;
      this.ProtectionCalcForCurrentandMultiplier(e, device, caption);
    } else if (caption === 'Custom Rating') {
      this.CableSize['protection']['customrating'] = e.target.value;
      this.PrevCustomeRatingVal = e.target.value;
      this.ProtectionCalcForCustomRating();
    }
    //console.log('OnInputChange-getAllControlsValue');
    this.getAllControlsValue();
  }
  ProtectionCalcForCurrentandMultiplier(e: any, device: any, caption: any) {

    //console.log('ProtectionCalcForCurrentandMultiplier');
    let RatingValue: any = ''
    if (device === 'MCB') {
      RatingValue = $('#select_MCB')[0][this.PrevMCBVal].innerHTML.split(" ")[1];
    } else if (device === 'MCCB') {
      RatingValue = $('input').filter("[caption='Thermal setting']").val();
      // RatingValue = $('#select_MCCB')[0][this.PrevMCCBVal].innerHTML.split(" ")[1];
    } else if (device === 'ACB') {
      RatingValue = $('input').filter("[caption='Thermal setting']").val();
      // RatingValue = $('#select_ACB')[0][this.PrevACBVal].innerHTML.split(" ")[1];
    } else if (device === 'HRC Fuse') {
      RatingValue = $('#select_HRCFuse')[0][this.PrevHRCVal].innerHTML.split(" ")[1];
    } else if (device === 'Custom') {
      RatingValue = $('input').filter("[caption='Thermal setting']").val();
    }
    let currentValue: any = '';
    let Val1: any = '';
    let Val2: any = '';
    if (!isNaN(RatingValue) && RatingValue.toString().indexOf('.') != -1) {
      Val1 = parseFloat(RatingValue);
    } else {
      Val1 = parseInt(RatingValue);
    }
    if (!isNaN(e.target.value) && e.target.value.toString().indexOf('.') != -1) {
      Val2 = parseFloat(e.target.value);
    } else {
      Val2 = parseInt(e.target.value);
    }
    if (caption === 'Trip current') {
      currentValue = Math.round(Val2 / Val1 * 100) / 100;
      if ($('input').filter("[caption='Trip Multiplier']").length) {
        $('input').filter("[caption='Trip Multiplier']").val(currentValue);
        this.CableSize['protection']['tripmultiplier'] = currentValue;
      }
    } else if (caption === 'Trip Multiplier') {
      currentValue = Val1 * Val2;
      currentValue = currentValue.toFixed(2);
      if ($('input').filter("[caption='Trip current']").length) {
        $('input').filter("[caption='Trip current']").val(currentValue);
        this.CableSize['protection']['tripcurrent'] = currentValue;
      }
    } else if (caption === 'Thermal setting') {
      const MultiplierValue = $('input').filter("[caption='Trip Multiplier']").val().toString();
      if (e.target.value < 100) {
        this.showLable = true;
      } else {
        this.showLable = false;
      }
      if (!Number.isNaN(Number(MultiplierValue)) && MultiplierValue.toString().indexOf('.') != -1) {
        Val1 = parseFloat(MultiplierValue);
      } else {
        Val1 = parseInt(MultiplierValue);
      }
      if (!isNaN(e.target.value) && e.target.value.toString().indexOf('.') != -1) {
        Val2 = parseFloat(e.target.value);
      } else {
        Val2 = parseInt(e.target.value);
      }
      currentValue = Val1 * Val2;
      currentValue = currentValue.toFixed(2);
      $('input').filter("[caption='Trip current']").val(currentValue);
      this.CableSize['protection']['tripcurrent'] = currentValue;
    }
    //console.log('ProtectionCalcForCurrentandMultiplier-getAllControlsValue');
    this.getAllControlsValue();
  }
  onDescriptionChnage(e: any) {
    //console.log('onDescriptionChnage');
    this.CommonValidationFn(e);

    const caption: string = e.target.getAttribute('caption');
    if (caption === 'Description') {
      this.CableSize['protection']['description'] = e.target.value;
    }
    //console.log('onDescriptionChnage-getAllControlsValue');
    this.getAllControlsValue();
  }
  onDropDownChange() {
    $(document).off('change', '#select_HRCFuse');

    $(document).on('change', '#select_HRCFuse', (e: any) => {
      const caption: string = e.target.options[e.target.selectedIndex].getAttribute('caption');
      if (caption === 'Rating') {
        this.CableSize['protection']['HRCFuserating'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevHRCVal = e.target.selectedIndex;
        this.ProtectionCalcDropdown(e, '');
        //  this.getAllControlsValue();

      } else if (caption === 'Curve') {
        this.CableSize['protection']['curve'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevCurveVal = e.target.selectedIndex;
        this.getAllControlsValue();
      }
      //console.log('onDropDownChange-select_HRCFuse');
      //this.getAllControlsValue();
    });
    $(document).off('change', '#select_MCB');
    $(document).on('change', '#select_MCB', (e: any) => {
      const caption: string = e.target.options[e.target.selectedIndex].getAttribute('caption');
      if (caption === 'Rating') {
        this.CableSize['protection']['MCBrating'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevMCBVal = e.target.selectedIndex;

        this.ProtectionCalcDropdown(e, '');
        //  this.getAllControlsValue();
      } else if (caption === 'Curve') {
        this.CableSize['protection']['curve'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevCurveVal = e.target.selectedIndex;
        this.getAllControlsValue();
      }
      //console.log('onDropDownChange-select_MCB');
      //this.getAllControlsValue();
    });
    $(document).off('change', '#select_MCCB');

    $(document).on('change', '#select_MCCB', (e: any) => {
      const caption: string = e.target.options[e.target.selectedIndex].getAttribute('caption');
      if (caption === 'Rating') {
        this.CableSize['protection']['MCCBrating'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.tempRating = e.target.options[e.target.selectedIndex].innerText.split(" ")[1];
        $('input[caption="Thermal setting"]').attr('max', this.tempRating);
        this.CableSize['protection']['thermalsetting'] = this.tempRating;
        this.PrevMCCBVal = e.target.selectedIndex;
        this.ProtectionCalcDropdown(e, '');
        // this.getAllControlsValue();

      } else if (caption === 'Curve') {
        this.CableSize['protection']['curve'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevCurveVal = e.target.selectedIndex;
        this.getAllControlsValue();
      }
      //console.log('onDropDownChange-select_MCCB');
      //this.getAllControlsValue();
    });
    $(document).off('change', '#select_ACB');

    $(document).on('change', '#select_ACB', (e: any) => {
      const caption: string = e.target.options[e.target.selectedIndex].getAttribute('caption');
      if (caption === 'Rating') {
        this.tempRating = e.target.options[e.target.selectedIndex].innerText.split(" ")[1];
        $('input[caption="Thermal setting"]').attr('max', this.tempRating);
        this.CableSize['protection']['ACBrating'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevACBVal = e.target.selectedIndex;
        this.CableSize['protection']['thermalsetting'] = this.tempRating;
        this.ProtectionCalcDropdown(e, '');
        // this.getAllControlsValue();
      } else if (caption === 'Curve') {
        this.CableSize['protection']['curve'] = e.target.options[e.target.selectedIndex].getAttribute('xmlvalue');
        this.PrevCurveVal = e.target.selectedIndex;
        this.getAllControlsValue();
      }
      //console.log('onDropDownChange-select_ACB');
      //this.getAllControlsValue();
    });
  }
  onCheckBoxChange() {
    //console.log('onCheckBoxChange');
    $(document).off('change', '.chkGroup input:checkbox');
    $(document).on('change', '.chkGroup input:checkbox', (e: any) => {
      if ($(e.target).prop('checked') == true) {
        this.CableSize['protection']['rcd'] = '1';
      } else {
        this.CableSize['protection']['rcd'] = '0';
      }
      //console.log('onCheckBoxChange-getAllControlsValue');
      this.getAllControlsValue();
    });
  }

  onNoEarthChange() {
    //console.log('onNoEarthChange');
    $('#earth-chk').on('change', (e: any) => {
      if ($(e.target).is(':checked') === true) {
        this.CableSize['specifyconductor']['earth']['mode'] = '0';
        this.CableSize['specifyconductor']['earth']['size'] = '0'
        this.CableSize['specifyconductor']['earth']['circuits'] = '0';
        $('#earth-toggle').attr('disabled', 'true');
        this.ShowEarth = false;
        $('#Earth_c').attr('disabled', 'true');
        $('#Earth_c').val(1);
        this.ShowEarthLab = true;
        this.showEarthButton = false;
      } else {
        $('#earth-toggle').removeAttr('disabled');
        this.showEarthButton = true;
        if ($('#earth-toggle').is(':checked') === true) {
          this.ShowEarth = true;
          $('#Earth_c').removeAttr('disabled');
          this.ShowEarthLab = false;
          this.CableSize['specifyconductor']['earth']['mode'] = '2';
          let obj = this.earthList.find(m => m.id == this.CableproInput.EarthId);
          if (obj)
            this.CableSize['specifyconductor']['earth']['size'] = obj.text.split(" ")[0];
          this.CableSize['specifyconductor']['earth']['circuits'] = '1';
        } else {
          this.ShowEarth = false;
          $('#Earth_c').attr('disabled', 'true');
          $('#Earth_c').val(1);
          this.ShowEarthLab = true;
          this.CableSize['specifyconductor']['earth']['mode'] = '1';
          this.CableSize['specifyconductor']['earth']['circuits'] = '1';
        }
      }
      //console.log('onNoEarthChange-getAllControlsValue');
      this.getAllControlsValue();
    });
  }
  tabChange(evt, tabId) {
    //console.log('tabChange');
    //if (tabId === 'tab2' && !this.premiumUser) return false;
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
      tablinks[i].className = tablinks[i].className.replace(" activebold", "");
    }
    document.getElementById(tabId).style.display = "block";
    evt.currentTarget.className += " active activebold";
  }
  StoreDHROutput(data: DRFWizrd) {
    //console.log('StoreDHROutput');
    if (data === undefined) {
      return
    }
    if (data.finalDrf == 1 && data.result.length === 0) {
      return;
    }

    this.UserWizard = $('#checkboxUseWizard:checked').length > 0;
    if (this.UserWizard) {
      //this.CableSize['isderatingwiz'] = "1";
      this.getAllControlsValue();
    }
    else {
      this.CableSize['isderatingwiz'] = "0";
      this.getAllControlsValue();
    }
    this.updateDeratingFactorValue(this.UserWizard, data);
  }
  updateDeratingFactorValue(useWizard: boolean, data: DRFWizrd) {
    this.showLoader();
    this._CableproService.storeDHROutput(this.newCalculationId, useWizard, data).subscribe((result) => {
      this.hideLoader();
    }, error => {
      //console.log("There is no internet connection");
      this.hideLoader();
    });
  }
  ClearTrailOne(): void {
    $('#reportDlg').modal('hide');
  }
  SetUpgradeLink() {
    if (this.isPlanAddedManually === true)
      this._router.navigate(['/app/main/projects/', 'subscriptionplans']);
    else
      this.ManageSubscription(this.user, this.loaderService, this._subscriptionService);
    $('#reportDlg').modal('hide')
  }
  downloadTextFile(tabDelimitedContent, filename) {
    const blob = new Blob([tabDelimitedContent], { type: 'text/plain' });
    const link = document.createElement('a');
    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  DownloadErrorsAndWarning() {
    const rows = this.warningErrorList
      .map(error => {
        const modifiedIsError = error.IsError == '1' ? "Error" : "Warning";  // Modify the age by adding 5 years
        return `${modifiedIsError}\t${error.ErrorCode}\t${error.Message}`;  // Combine name, modified age, and city
      })
      .join('\n');
    const tabDelimitedContent = ["Type\tCode\t\Message\n", ...rows].join('');
    this.downloadTextFile(tabDelimitedContent, 'Errors and Warnings.txt')
  }
  GenerateReport(): void {
    if (!this.isFromWebfacing || this.IsReportFormValid()) {
      if (this.IsReportEmailValid()) {
        this.showreportloader = true;
        localStorage.setItem('ReportSettingEmails', this.CalculationReportInput.eamilList);
        this.CalculationReportInput.reportAttachmentName = 'Cable_Pro_Report_';


        this.CalculationReportInput.imgSrc = '';
        if ($("#selectedimage").length) {
          this.CalculationReportInput.imgSrc = $("#selectedimage").attr("src");
        }
      }

      this.CalculationReportInput.circuitrating_drated = this.Circuitrating_drated;
      this.CalculationReportInput.Dictatingfactor = this.Dictatingfactorres;
      this.CalculationReportInput.currentrating_cable_tabulated = this.Currentrating_cable_tabulated;
      this.CalculationReportInput.errordata = this.warningErrorStrData;
      this.CalculationReportInput.standardCountry = this.standardCountryReport;
      this.CalculationReportInput.calculation_type = this.calculation_type.toString();
      this.CalculationReportInput.rcd = this.CableSize['protection']['rcd'];

      this.CalculationReportInput.companyLogo_ShowLogo = this.companyLogo_ShowLogo;
      this.CalculationReportInput.customeReportFields_ShowCustomField = this.customeReportFields_ShowCustomField;
      this.CalculationReportInput.companyLogo_FileName = this.companyLogo_FileName;
      this.CalculationReportInput.customFields = this.customFields;
      this.CalculationReportInput.calculationName = this.calculationName;

      // this.CalculationReportInput.projectname = (this.CalculationReportInput.projectname || '').trim().replace(' ', '-');
      if (this.CalculationReportInput.jobNo != null && this.CalculationReportInput.jobNo.trim() == '')
        this.CalculationReportInput.jobNo = (this.CalculationReportInput.jobNo || '').trim().replace(' ', '-');

      if (this.CalculationReportInput.projectname != null && this.CalculationReportInput.projectname.trim() == '')
        this.CalculationReportInput.projectname = (this.CalculationReportInput.projectname || '').trim().replace(' ', '-');

      if (!this.CalculationReportInput.projectname && !this.CalculationReportInput.jobNo)
        this.CalculationReportInput.printName = false

      if (!this.isFromWebfacing) {
        this.CalculationReportInput.reportAttachmentName += '_' + this.projectName + '_';
        this.CalculationReportInput.reportAttachmentName += this.calculationName + '.pdf';
      }
      else {
        this.CalculationReportInput.reportAttachmentName += '.pdf';
      }
      this.CalculationReportInput.calculationId = this.newCalculationId;
      this.CalculationReportInput.reportHeaderDate = moment().format('DD-MMM-YYYY hh:mm A').toString();
      this.CalculationReportInput.isFromWebfacing = this.isFromWebfacing;
      this._pdfReportSerivceProxy.CustomGenerateReportIEC(this.CalculationReportInput).subscribe((result) => {
        if (!this.CalculationReportInput.sendEmail) {
          let blob = new Blob([result.body], { type: 'application/pdf' });
          saveAs(blob, this.CalculationReportInput.reportAttachmentName);
        }
        else {
          $('#EmailSent').modal('show');
        }
        this.ClearReport();
        this.showreportloader = false;
      });
    }
  }
  showLoader(): void {
    //console.log('showLoader');
    this.loaderService.showHeader();
  }
  hideLoader(): void {
    //console.log('hideLoader');
    this.loaderService.hideHeader();
  }
  ClearReport(): void {
    //console.log('ClearReport');
    this.CalculationReportInput.projectname = '';
    this.CalculationReportInput.jobNo = '';
    this.CalculationReportInput.sendEmail = false;
    this.CalculationReportInput.printName = true;
    $('#chkPrintName').prop('checked', true);

    this.CalculationReportInput.eamilList = '';
    $('#RptProjectName').css('display', 'none');
    $('#RptCalculationName').css('display', 'none');
    $('#chkEmailReport').prop('checked', false);
    $('#sendEmailError1').css('display', 'none');
    $('#sendEmailError2').css('display', 'none');
    $('#chkCompanyLogo').prop('checked', false);

    $('#reportDlg').modal('hide');
  }
  showHideProtectionWarning() {
    if (this.CableSize != undefined && (<any>this.CableSize).current != undefined) {
      switch (this.device) {
        case '0':
          this.displayCurrentError = false;
          break;
        case '1':

          var tempvalue = parseInt(this.CableSize['protection']['MCBrating']);

          if (parseFloat((<any>this.CableSize).current) > parseFloat($('option[device=MCB][value=' + tempvalue + ']').text())) {
            this.displayCurrentError = true;
          }
          else {
            this.displayCurrentError = false;
          }
          break;
        case '2':
          if (parseFloat((<any>this.CableSize).current) > parseFloat(this.CableSize['protection']['thermalsetting'])) {
            this.displayCurrentError = true;
          }
          else {
            this.displayCurrentError = false;
          }
          break;
        case '3':
          if (parseFloat((<any>this.CableSize).current) > parseFloat(this.CableSize['protection']['thermalsetting'])) {
            this.displayCurrentError = true;
          }
          else {
            this.displayCurrentError = false;
          }
          break;
        case '4':
          var tempvalue = parseInt(this.CableSize['protection']['HRCFuserating']);
          if (parseFloat((<any>this.CableSize).current) > parseFloat($('option[device="HRC Fuse"][value=' + tempvalue + ']').text())) {
            this.displayCurrentError = true;
          }
          else {
            this.displayCurrentError = false;
          }
          break;
        case '5':
          if (parseFloat((<any>this.CableSize).current) > parseFloat(this.CableSize['protection']['thermalsetting'])) {
            this.displayCurrentError = true;
          } else {
            this.displayCurrentError = false;
          }
          break;
      }
    }
  }
  UseWizardChange(e) {
    setTimeout(() => {
      this.UserWizard = $('#checkboxUseWizard:checked').length > 0;

      if (this.UserWizard) {
        //this.CableSize['isderatingwiz'] = "1";
        $('#showWizard').click();
      }
      else {
        this.CableSize['isderatingwiz'] = "0";
      }
      this.StoreDHROutput(this.CalculationReportInput.wizardValues);
    });
  }
  // bindWizard(startStep: number = 1) {
  //   this.SetFirstWizardScreen();
  // }

  bindWizard(startStep: number = 1) {
    this.finalDrf = 1;
    this.wizard = (<any>$('#m_wizard')).mWizard({
      startStep: startStep,
      manualNav: false,
    });
    if (this.drInstallType == 1) {
      this.insulationValues = [
        { "name": "PVC", "value": 2 },
        { "name": "XLPE and EPR", "value": 3 },
        { "name": "PVC covered or bare and exposed to touch 70 &#176;C", "value": 4 },
        { "name": "Bare not exposed to touch 105 &#176;C", "value": 5 },
      ];
    } else {
      this.insulationValues = [
        { "name": "PVC", "value": 2 },
        { "name": "XLPE and EPR", "value": 3 },
      ];
    }
    // $('#optDrInstallType1').click();
    $('input[name=optDrBunchingType],input[name=optDrInstallType]').on('click', (e) => {
      setTimeout((e) => {
        this.wizard.steps = (<any>$('#m_wizard')).find('.m-wizard__step');
        this.wizard.totalSteps = this.wizard.steps.length;
      }, 300);
      return true;
    });

    this.SetFirstWizardScreen();

  }

  /* In air - Bunched Circuits */

  GetTable22Dr(e: any) {
    setTimeout(() => {
      this.drfBSDService.getTable22(this.table22model.Arrangement, this.table22model.NoOfCircuits, true).subscribe(result => {
        this.table22model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
        this.drTable22output = result;
      });
    }, 500);

  }
  /* In air - Cable Trays */
  GetTable23Dr(e: any) {
    if (this.CableSize['core'] == 0)
      this.table23model.CableType = 1;
    else
      this.table23model.CableType = 2;

    this.drfBSDService.getTable23(this.table23model.CableType, this.table23model.Installation, this.table23model.Row, this.table23model.Cables, true).subscribe(result => {
      this.table23model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
      this.table23output = result;
    });
  }
  /* In air/soil  - ambient temperature */
  GetTable271Dr(e: any, checkdecimalplaces: boolean = false) {

    if (checkdecimalplaces)
      this.allowDecimalSetModal(e, 'AmbientTemp');
    setTimeout(() => {

      if (e) {
        if ($(e.target).is(':checked') === true)
          $('#inputUseStandard').attr('disabled', 'true');
        else
          $('#inputUseStandard').removeAttr('disabled');
      }
      else {
        // $("#drTable271UseStandard").prop("checked",true);
        if ($("#drTable271UseStandard").is(':checked') === true)
          $('#inputUseStandard').attr('disabled', 'true');
        else
          $('#inputUseStandard').removeAttr('disabled');
      }

      let standard: number = 3;
      let isCalledByInsulation: boolean = false;

      if (this.table271model.UseStandard == true) {
        if (this.drInstallType == 1) {
          this.table271model.AmbientTemp = 30;
          this.table271model.Insulation = 2;
        } else {
          this.table271model.AmbientTemp = 20;
          this.table271model.Insulation = 2;
        }

        // $('#drTable271Insulation').val(this.table271model.Insulation).trigger('change');
        //this.drTable271output = undefined;
        if (!isCalledByInsulation)
          this.SetMinMaxAmbientTemp();
        this.drfBSDService.getTable271(standard, this.table271model.Insulation, this.table271model.AmbientTemp, this.drInstallType, true).subscribe(result => {
          this.table271model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
          this.drTable271output = result;
          this.drTable271output["Type of Insulation:"] = "";
          // this.finalDrf = this.table271model.drf;
        });
        this.table271model.drf = 1;
        return false;
      } else {
        if (!isCalledByInsulation)
          this.SetMinMaxAmbientTemp();
        this.drfBSDService.getTable271(standard, this.table271model.Insulation, this.table271model.AmbientTemp, this.drInstallType, true).subscribe(result => {
          this.table271model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
          this.drTable271output = result;
          // this.finalDrf = this.table271model.drf;
        });
      }

      this.CableSize['deratingtemp'] = this.table271model.AmbientTemp.toString();

    }, 100);
  }
  /* Depth of Burial (m) */
  GetTable25Dr() {
    if (this.table25model.NoOfCircuits == 1) {
      this.table25model.drf = 1;
      //this.drTable25output = undefined;
      //return false;
    }

    if (this.table25model.InstallType == 1) {
      this.table25ArrangementValues = [
        { "name": "Nil (cables touching)", "value": 1 },
        { "name": "One cable diameter", "value": 2 },
        { "name": "Spaced 0.125 m", "value": 3 },
        { "name": "Spaced 0.25 m", "value": 4 },
        { "name": "Spaced 0.5 m", "value": 5 },
      ];
    }
    else if (this.table25model.InstallType == 2) {
      this.table25ArrangementValues = [
        { "name": "Nil (ducts touching)", "value": 1 },
        { "name": "Spaced 0.25 m", "value": 4 },
        { "name": "Spaced 0.5 m", "value": 5 },
        { "name": "Spaced 1.0 m", "value": 6 },
      ];

    }
    setTimeout(() => {
      let tempSelected = this.table25ArrangementValues.find(m => m.value == this.table25model.Arrangement);
      if (!tempSelected)
        this.table25model.Arrangement = this.table25ArrangementValues[0].value;
      else
        this.table25model.Arrangement = this.table25model.Arrangement;
      // $('#drTable25Arrangement').val(this.table25model.Arrangement).select2({
      //     width: '100%',
      //     minimumResultsForSearch: Infinity // disable search
      // }).trigger('change');
      // $('#drTable25Arrangement').trigger('select2:select');
      this.setTable25Values(this.table25model.Arrangement);
      // setTimeout(() => { $('#drTable25Arrangement').trigger('select2:select'); }, 500);
    });
  }
  /* Depth of Burial (m) */
  setTable25Dr() {
    if (this.CableSize['core'] == 0)
      this.table25model.CableType = 1;
    else
      this.table25model.CableType = 2;

    this.drfBSDService.getTable25(this.table25model.CableType, this.table25model.NoOfCircuits, this.table25model.TouchingType, this.table25model.Distance, this.table25model.InstallType, true).subscribe(result => {
      this.table25model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
      this.drTable25output = result;
    });
  }


  /* Depth of Burial (m) - arrangement values  */
  setTable25Values(arrangementValue: any) {
    switch (parseInt(arrangementValue)) {
      case 1:
        this.table25model.Distance = 0;
        this.table25model.TouchingType = 1;
        break;
      case 2:
        this.table25model.Distance = 0;
        this.table25model.TouchingType = 2;
        break;
      case 3:
        this.table25model.Distance = 0.125;
        this.table25model.TouchingType = 3;
        break;
      case 4:
        this.table25model.Distance = 0.25;
        this.table25model.TouchingType = 4;
        break;
      case 5:
        this.table25model.Distance = 0.5;
        this.table25model.TouchingType = 5;
        break;
      case 6:
        this.table25model.Distance = 1.0;
        this.table25model.TouchingType = 6;
        break;
    }
    this.setTable25Dr();
  }

  GetTable28Dr(e, type: any = '', checkdecimalplaces: boolean = false) {
    if (checkdecimalplaces && type == 'Depth')
      this.allowDecimalSetModal(e, 'Depth');
    setTimeout(() => {

      if (this.table28model.UseStandard)
        $('#txtdepthofburial').attr('disabled', 'true');
      else
        $('#txtdepthofburial').removeAttr('disabled');

      if (this.table28model.UseStandard) {
        //6  this.table28model.Buried = 1;

        this.table28model.Depth = 0.7;
        this.table28model.drf = 1;
        //this.table28output = undefined;
        //return false;
        this.setTable28Dr();

      }
      if (this.table28model.Depth < 0.5) {
        this.table28model.Depth = 0.5;
      }
      if (this.table28model.Depth > 3) {
        this.table28model.Depth = 3;
      }
      this.setTable28Dr();
    }, 800);
  }

  /* Depth of Burial (m) - set values   Conductor size:*/
  setTable28Dr() {
    this.drfBSDService.getTable28(this.table28model.Depth, 0, this.table28model.Buried, true).subscribe(result => {
      this.table28model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
      this.table28output = result;
    });
  }

  OnInstallationTypeChange(e: any) {
    setTimeout(() => {


      this.table271model.UseStandard = true;
      if (this.drInstallType == 1) {
        this.table271model.AmbientTemp = 30;
        this.table271model.Insulation = 2;
        this.insulationValues = [
          { "name": "PVC", "value": 2 },
          { "name": "XLPE and EPR", "value": 3 },
          { "name": "PVC covered or bare and exposed to touch 70 &#176;C", "value": 4 },
          { "name": "Bare not exposed to touch 105 &#176;C", "value": 5 },
        ];
      } else {
        this.table271model.AmbientTemp = 20;
        this.table271model.Insulation = 2;
        this.insulationValues = [
          { "name": "PVC", "value": 2 },
          { "name": "XLPE and EPR", "value": 3 },
        ];
      }
      // $('#drTable271Insulation').val(this.table271model.Insulation).trigger('change');
      this.GetTable271Dr(null);
    });
  }
  /* Soil thermal resitivity  (e: any , type : any ='', checkdecimalplaces : boolean =false)*/
  GetTable29Dr(e: any, checkdecimalplaces: boolean = false) {

    if (checkdecimalplaces)
      this.allowDecimalSetModalThree(e, 'Resitivity');
    setTimeout(() => {

      if (this.table29model.UseStandard)
        $('#txtresitivity').attr('disabled', 'true');
      else
        $('#txtresitivity').removeAttr('disabled');

      if (this.table29model.UseStandard) {
        this.table29model.Resitivity = 2.5;
        // this.table29model.Buried = 1;
        this.table29model.drf = 1;
        //    this.table29output = undefined;
        //  return false;
        this.drfBSDService.getTable29(this.table29model.Resitivity, this.table29model.Buried, true).subscribe(result => {
          this.table29model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
          this.table29output = result;
          this.table29output["Type of installation:"] = "";
        });
      }

      if (this.table29model.Resitivity > 3) {
        this.table29model.Resitivity = 3;
      }
      if (this.table29model.Resitivity < 0.5) {
        this.table29model.Resitivity = 0.5;
      }
      this.drfBSDService.getTable29(this.table29model.Resitivity, this.table29model.Buried, true).subscribe(result => {
        this.table29model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
        this.table29output = result;
      });
    }, 800);
  }
  public Table23InstallationValues: Table23InstallationModel[];
  public Table24InstallationValues: Table23InstallationModel[];
  GetTable23Values() {
    //console.log("setTable23Dr");
    this.drfGetService.getTable23Installations("3").subscribe(result => {
      this.Table23InstallationValues = result;
    });
  }
  GetTable24Values() {
    //console.log("setTable24Dr");
    this.drfGetService.getTable24Installations("3").subscribe(result => {
      this.Table24InstallationValues = result;
    });
  }
  onSelectInstall(value: number) {
    this.table23model.Installation = value;
    //
    // alert(this.CableSize['core']);

    //alert(this.CableSize['core']);
    /* Single Core - 1*/
    if (this.CableSize['core'] == "0") {
      if (value == 2 || value == 5) {
        if (this.table23model.Row > 2) {
          this.table23model.Row = 1;
        }
        this.table23RowValues = [
          { "name": "1 tray", "value": 1 },
          { "name": "2 trays", "value": 2 },
        ];

        if (value == 2) {
          if (this.table23model.Cables > 2) {
            this.table23model.Cables = 1;
          }
          this.table23CableValues = [
            { "name": "1 cct", "value": 1 },
            { "name": "2 ccts", "value": 2 },
          ];
        } else {
          this.table23CableValues = [
            { "name": "1 cct", "value": 1 },
            { "name": "2 ccts", "value": 2 },
            { "name": "3 ccts", "value": 3 },
          ];
        }
      }
      else {
        this.table23RowValues = [
          { "name": "1 tray", "value": 1 },
          { "name": "2 trays", "value": 2 },
          { "name": "3 trays", "value": 3 },
        ];
        this.table23CableValues = [
          { "name": "1 cct", "value": 1 },
          { "name": "2 ccts", "value": 2 },
          { "name": "3 ccts", "value": 3 },
        ];
      }
    }
    else {/* Multi Core - 1*/
      if (value == 1 || value == 5 || value == 6) {
        if (this.table23model.Row > 6) {
          this.table23model.Row = 1;
        }
        this.table23RowValues = [
          { "name": "1 tray", "value": 1 },
          { "name": "2 trays", "value": 2 },
          { "name": "3 trays", "value": 3 },
          { "name": "6 trays", "value": 6 },
        ];
        if (this.table23model.Cables > 9) {
          this.table23model.Cables = 1;
        }
        this.table23CableValues = [
          { "name": "1", "value": 1 },
          { "name": "2", "value": 2 },
          { "name": "3", "value": 3 },
          { "name": "4", "value": 4 },
          { "name": "6", "value": 6 },
          { "name": "9", "value": 9 },
        ];
      }
      else if (value == 2 || value == 7) {
        if (this.table23model.Row > 3) {
          this.table23model.Row = 1;
        }
        this.table23RowValues = [
          { "name": "1 tray", "value": 1 },
          { "name": "2 trays", "value": 2 },
          { "name": "3 trays", "value": 3 },
        ];
        if (this.table23model.Cables > 6) {
          this.table23model.Cables = 1;
        }
        this.table23CableValues = [
          { "name": "1", "value": 1 },
          { "name": "2", "value": 2 },
          { "name": "3", "value": 3 },
          { "name": "4", "value": 4 },
          { "name": "6", "value": 6 },
        ];
      }
      else if (value == 3 || value == 4) {
        if (this.table23model.Row > 2) {
          this.table23model.Row = 1;
        }
        this.table23RowValues = [
          { "name": "1 tray", "value": 1 },
          { "name": "2 trays", "value": 2 },
        ];
        if (value == 3) {
          if (this.table23model.Cables > 9) {
            this.table23model.Cables = 1;
          }
          this.table23CableValues = [
            { "name": "1", "value": 1 },
            { "name": "2", "value": 2 },
            { "name": "3", "value": 3 },
            { "name": "4", "value": 4 },
            { "name": "6", "value": 6 },
            { "name": "9", "value": 9 },
          ];
        } else {
          if (this.table23model.Cables > 6) {
            this.table23model.Cables = 1;
          }
          this.table23CableValues = [
            { "name": "1", "value": 1 },
            { "name": "2", "value": 2 },
            { "name": "3", "value": 3 },
            { "name": "4", "value": 4 },
            { "name": "6", "value": 6 },
          ];
        }
      }
    }
    this.GetTable23Dr(null);
  }
  updateWizardFactorValues() {
    this.wizardFactorInputList = [];
    var stepId = 1;
    var controlId = 1;
    var standardId = this.CableSize['calculationstandard'];
    this.CalculationReportInput.wizardValues = new DRFWizrd();
    this.CalculationReportInput.wizardValues.finalDrf = parseFloat(this.finalDrf.toFixed(2));
    this.CalculationReportInput.wizardValues.result = [];

    if (this.drInstallType == 1) {
      if (this.drBunchingType == 2) {
        /* control 1 */
        let arrangementName = this.drTable22ArrangementValues.find(x => x.value == this.table22model.Arrangement).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Bunched Circuits";
        this.wizardFactorInput.stepTitle = "Bunched in air on a surface or enclosure";
        this.wizardFactorInput.controlId = 1;
        this.wizardFactorInput.controlLabel = "Arrangement of Cables";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table22model.Arrangement.toString();
        this.wizardFactorInput.controlText = arrangementName;
        this.wizardFactorInput.defaultValue = "";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table22model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        /* control 2 */
        let circuitName = this.drTable22CircuitValues.find(x => x.value == this.table22model.NoOfCircuits).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 1;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Bunched Circuits";
        this.wizardFactorInput.stepTitle = "Bunched in air on a surface or enclosure";
        this.wizardFactorInput.controlId = 2;
        this.wizardFactorInput.controlLabel = "No of circuits";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table22model.NoOfCircuits.toString();
        this.wizardFactorInput.controlText = circuitName;
        this.wizardFactorInput.defaultValue = "";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = true;
        this.wizardFactorInput.overallWizardFactor = this.table22model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        stepId += 1;
      }
      else if (this.drBunchingType == 3) {
        /* control 1 */
        let rowName = this.table23RowValues.find(x => x.value == this.table23model.Row).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 1;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "In trays";
        this.wizardFactorInput.stepTitle = "Cable tray or support";
        this.wizardFactorInput.controlId = 1;
        this.wizardFactorInput.controlLabel = "Number of trays or ladders";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table23model.Row.toString();
        this.wizardFactorInput.controlText = rowName;
        this.wizardFactorInput.defaultValue = "";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        /* control 2 */
        let cableName = this.table23CableValues.find(x => x.value == this.table23model.Cables).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 1;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "In trays";
        this.wizardFactorInput.stepTitle = "Cable tray or support";
        this.wizardFactorInput.controlId = 2;
        this.wizardFactorInput.controlLabel = this.drBunchingCore == 1 ? "No. of three-phase circuits per tray or ladder" : "No. of cables per tray or ladder";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table23model.Cables.toString();
        this.wizardFactorInput.controlText = cableName;
        this.wizardFactorInput.defaultValue = "";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        /* control 3 */
        let imgNameandDescription: any;
        if (this.drBunchingCore == 1)
          imgNameandDescription = this.Table23InstallationValues.find(x => x.value == this.table23model.Installation);
        else
          imgNameandDescription = this.Table24InstallationValues.find(x => x.value == this.table23model.Installation);

        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 1;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "In trays";
        this.wizardFactorInput.stepTitle = "Cable tray or support";
        this.wizardFactorInput.controlId = 3;


        this.wizardFactorInput.controlLabel = this.drBunchingCore == 1 ? "Single core - In trays, racks, cleats or other supports in air" : "Multi-core - In trays, racks, cleats or other supports in air";
        this.wizardFactorInput.controlType = "img";
        this.wizardFactorInput.controlValue = this.table23model.Installation.toString();
        this.wizardFactorInput.controlText = imgNameandDescription.name + ' ' + imgNameandDescription.desc;
        this.wizardFactorInput.defaultValue = "";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = true;
        this.wizardFactorInput.imageName = imgNameandDescription.name;
        this.wizardFactorInput.imageDesc = imgNameandDescription.desc;
        this.wizardFactorInput.imageTitle = imgNameandDescription.desc2;
        this.wizardFactorInput.imageSrc = imgNameandDescription.img;
        this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        stepId += 1;
      }

      /* control 1 */
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = 1;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.drBunchingType;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Air temprature";
      this.wizardFactorInput.stepTitle = "Air ambient temprature (C)";
      this.wizardFactorInput.controlId = 1;
      this.wizardFactorInput.controlLabel = "Standard Temprature";
      this.wizardFactorInput.controlType = "textbox";
      if (this.table271model.UseStandard) {
        this.wizardFactorInput.controlValue = "30";
        this.wizardFactorInput.controlText = "Use standard 30 &#176;C";
        this.wizardFactorInput.defaultValue = "30";
        this.wizardFactorInput.useDefaultValue = true;
        this.wizardFactorInput.isLastControl = true;
      }
      else {
        this.wizardFactorInput.controlValue = this.table271model.AmbientTemp.toString();
        this.wizardFactorInput.controlText = "Use standard 30 &#176;C";
        this.wizardFactorInput.defaultValue = "30";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
      }
      this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

      /* control 2 */
      if (!this.table271model.UseStandard) {
        let insulationName = this.insulationValues.find(x => x.value == this.table271model.Insulation).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 1;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Air temprature";
        this.wizardFactorInput.stepTitle = "Air ambient temprature (C)";
        this.wizardFactorInput.controlId = 2;
        this.wizardFactorInput.controlLabel = "Insulation";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table271model.Insulation.toString();
        this.wizardFactorInput.controlText = insulationName;
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = true;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
      }
      stepId += 1;
      //// Storing results
      var controlId = 1;
      if (this.drBunchingType != 1) {
        if (this.drTable22output && this.drBunchingType == 2) {
          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Correction Factor:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.drTable22output["Correction Factor:"];
          this.wizardFactorInput.controlText = this.drTable22output["Correction Factor:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table22model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Arrangement of cables:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.drTable22output["Arrangement of cables:"];
          this.wizardFactorInput.controlText = this.drTable22output["Arrangement of cables:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table22model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Bunched arrangement:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.drTable22output["Bunched arrangement:"];
          this.wizardFactorInput.controlText = this.drTable22output["Bunched arrangement:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table22model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          var item = new TableItem();
          item.name = "Table22";
          item.summary = $('#table22').text();;
          this.CalculationReportInput.wizardValues.result.push(item);
        }
        else if (this.table23output && this.drBunchingType == 3) {
          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Correction Factor:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.table23output["Correction Factor:"];
          this.wizardFactorInput.controlText = this.table23output["Correction Factor:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Installation:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.table23output["Installation:"];
          this.wizardFactorInput.controlText = this.table23output["Installation:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "No. of tiers or rows of supports:";
          this.wizardFactorInput.controlType = "label";
          this.wizardFactorInput.controlValue = this.table23output["No. of tiers or rows of supports:"];
          this.wizardFactorInput.controlText = this.table23output["No. of tiers or rows of supports:"];
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          this.wizardFactorInput = new WizardFactorInput();
          this.wizardFactorInput.calculationId = this.newCalculationId;
          this.wizardFactorInput.calcStandardId = standardId
          this.wizardFactorInput.installationType = this.drInstallType;
          this.wizardFactorInput.cores = this.drBunchingCore;
          this.wizardFactorInput.buriedType = this.drBunchingType;
          this.wizardFactorInput.stepId = stepId;
          this.wizardFactorInput.stepName = "Results";
          this.wizardFactorInput.stepTitle = "Results";
          this.wizardFactorInput.controlId = controlId;
          this.wizardFactorInput.controlLabel = "Conductor size:";
          this.wizardFactorInput.controlType = "label";
          if (this.table23output['No.of circuits per tier or row:']) {
            this.wizardFactorInput.controlValue = this.table23output['No.of circuits per tier or row:'];
            this.wizardFactorInput.controlText = this.table23output['No.of circuits per tier or row:'];
          }
          if (this.table23output['No. of multi-core cables:']) {
            this.wizardFactorInput.controlValue = this.table23output['No. of multi-core cables:'];
            this.wizardFactorInput.controlText = this.table23output['No. of multi-core cables:'];
          }
          this.wizardFactorInput.defaultValue = null;
          this.wizardFactorInput.useDefaultValue = null;
          this.wizardFactorInput.isLastControl = false;
          this.wizardFactorInput.overallWizardFactor = this.table23model.drf.toString();
          this.wizardFactorInputList.push(this.wizardFactorInput);
          controlId += 1;

          var item = new TableItem();
          item.name = "Table23";
          item.summary = $('#table23').text();
          this.CalculationReportInput.wizardValues.result.push(item);
        }
      }
      if (this.drTable271output) {
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Correction Factor:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Correction Factor:"];
        this.wizardFactorInput.controlText = this.drTable271output["Correction Factor:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        controlId += 1;

        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Air ambient temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Air ambient temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Air ambient temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        controlId += 1;

        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Reference temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = false;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        controlId += 1;

        var item = new TableItem();
        item.name = "Table27";
        item.summary = $('#table27').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }

      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = this.drInstallType;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.drBunchingType;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Results";
      this.wizardFactorInput.stepTitle = "Results";
      this.wizardFactorInput.controlId = controlId;
      this.wizardFactorInput.controlLabel = "Overall Correction Factor:";
      this.wizardFactorInput.controlType = "label";
      this.wizardFactorInput.controlValue = this.finalDrf.toString();
      this.wizardFactorInput.controlText = this.finalDrf.toString();
      this.wizardFactorInput.defaultValue = null;
      this.wizardFactorInput.useDefaultValue = null;
      this.wizardFactorInput.isLastControl = true;
      this.wizardFactorInput.overallWizardFactor = this.finalDrf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

    }
    else if (this.drInstallType == 2) {
      stepId = 1;
      /* control 1 */
      let noOfCircuitsName = this.table25NoOfCircuitValues.find(x => x.value == this.table25model.NoOfCircuits).name;
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = 2;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.table25model.InstallType;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Buried groups";
      this.wizardFactorInput.stepTitle = "Groups of buried circuits";
      this.wizardFactorInput.controlId = 1;
      this.wizardFactorInput.controlLabel = "No. of circuits";
      this.wizardFactorInput.controlType = "dropdownlist";
      this.wizardFactorInput.controlValue = this.table25model.NoOfCircuits.toString();
      this.wizardFactorInput.controlText = noOfCircuitsName;
      this.wizardFactorInput.defaultValue = null;
      this.wizardFactorInput.useDefaultValue = null;
      this.wizardFactorInput.isLastControl = false;
      this.wizardFactorInput.overallWizardFactor = this.table25model.drf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

      /* control 2 */
      if (this.table25model.NoOfCircuits > 1) {
        let arrangementName = this.table25ArrangementValues.find(x => x.value == this.table25model.Arrangement).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 2;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.table25model.InstallType;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Buried groups";
        this.wizardFactorInput.stepTitle = "Groups of buried circuits";
        this.wizardFactorInput.controlId = 2;
        this.wizardFactorInput.controlLabel = "Arrangement";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table25model.Arrangement.toString();
        this.wizardFactorInput.controlText = arrangementName;
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = true;
        this.wizardFactorInput.overallWizardFactor = this.table25model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
      }

      stepId += 1;
      /* control 1 */
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = 2;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.table28model.Buried;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Depth of burial";
      this.wizardFactorInput.stepTitle = "Depth of Burial (m)";
      this.wizardFactorInput.controlId = 1;
      this.wizardFactorInput.controlLabel = "Depth";
      this.wizardFactorInput.controlType = "textbox";
      if (this.table28model.UseStandard) {
        this.wizardFactorInput.controlValue = "0.70";
        this.wizardFactorInput.controlText = "Use standard 0.7 m";
        this.wizardFactorInput.defaultValue = "Use standard 0.7 m";
        this.wizardFactorInput.useDefaultValue = true;
        this.wizardFactorInput.isLastControl = true;
      }
      else {
        this.wizardFactorInput.controlValue = this.table28model.Depth.toString();
        this.wizardFactorInput.controlText = this.table28model.Depth.toString();
        this.wizardFactorInput.defaultValue = "Use standard 0.7 m";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = true;
      }
      this.wizardFactorInput.overallWizardFactor = this.table28model.drf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

      stepId += 1;
      /* control 1 */
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = 2;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.table29model.Buried;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Soil resistivity";
      this.wizardFactorInput.stepTitle = "Soil thermal resistivity";
      this.wizardFactorInput.controlId = 1;
      this.wizardFactorInput.controlLabel = "Resistivity";
      this.wizardFactorInput.controlType = "textbox";
      if (this.table29model.UseStandard) {
        this.wizardFactorInput.controlValue = "2.5";
        this.wizardFactorInput.controlText = "Use standard 2.5 &#176;C.m/W";
        this.wizardFactorInput.defaultValue = "2.5";
        this.wizardFactorInput.useDefaultValue = true;
        this.wizardFactorInput.isLastControl = true;
      }
      else {
        this.wizardFactorInput.controlValue = this.table29model.Resitivity.toString();
        this.wizardFactorInput.controlText = "Use standard 2.5 &#176;C.m/W";
        this.wizardFactorInput.defaultValue = "2.5";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
      }
      this.wizardFactorInput.overallWizardFactor = this.table29model.drf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

      stepId += 1;
      /* control 1 */
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = 2;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = null;
      this.wizardFactorInput.stepId = stepId;
      this.wizardFactorInput.stepName = "Soil temprature";
      this.wizardFactorInput.stepTitle = "Soil ambient temprature (C)";
      this.wizardFactorInput.controlId = 1;
      this.wizardFactorInput.controlLabel = "Standard Temprature";
      this.wizardFactorInput.controlType = "textbox";
      if (this.table271model.UseStandard) {
        this.wizardFactorInput.controlValue = "20";
        this.wizardFactorInput.controlText = "Use standard 20 &#176;C";
        this.wizardFactorInput.defaultValue = "20";
        this.wizardFactorInput.useDefaultValue = true;
        this.wizardFactorInput.isLastControl = true;
      }
      else {
        this.wizardFactorInput.controlValue = this.table271model.AmbientTemp.toString();
        this.wizardFactorInput.controlText = "Use standard 20 &#176;C";
        this.wizardFactorInput.defaultValue = "20";
        this.wizardFactorInput.useDefaultValue = false;
        this.wizardFactorInput.isLastControl = false;
      }
      this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);

      /* control 2 */
      if (!this.table271model.UseStandard) {
        let conductorTempName = this.insulationValues.find(x => x.value == this.table271model.Insulation).name;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = 2;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = null;
        this.wizardFactorInput.stepId = stepId;
        this.wizardFactorInput.stepName = "Soil temprature";
        this.wizardFactorInput.stepTitle = "Soil ambient temprature (C)";
        this.wizardFactorInput.controlId = 2;
        this.wizardFactorInput.controlLabel = "Insulation";
        this.wizardFactorInput.controlType = "dropdownlist";
        this.wizardFactorInput.controlValue = this.table271model.Insulation.toString();
        this.wizardFactorInput.controlText = conductorTempName;
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.isLastControl = true;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
      }

      /* Storing Results */
      controlId = 1;
      if (this.drTable25output) {
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Correction Factor:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable25output["Correction Factor:"];
        this.wizardFactorInput.controlText = this.drTable25output["Correction Factor:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table25model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Spacing (m):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable25output["Spacing (m):"];
        this.wizardFactorInput.controlText = this.drTable25output["Spacing (m):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table25model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "No. of circuits:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable25output["No. of circuits:"];
        this.wizardFactorInput.controlText = this.drTable25output["No. of circuits:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table25model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        ////////////////////////////////////////////////////////
        var item = new TableItem();
        item.name = "Table25";
        item.summary = $('#table25').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.table28output) {
        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Correction Factor:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table28output["Correction Factor:"];
        this.wizardFactorInput.controlText = this.table28output["Correction Factor:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table28model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Depth of burial (m):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table28output["Depth of burial (m):"];
        this.wizardFactorInput.controlText = this.table28output["Depth of burial (m):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table28model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Reference depth (m):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table28output["Reference depth (m):"];
        this.wizardFactorInput.controlText = this.table28output["Reference depth (m):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table28model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Conductor size:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table28output["Conductor size:"];
        this.wizardFactorInput.controlText = this.table28output["Conductor size:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table28model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        /////////////////////////////////////////////////////////
        var item = new TableItem();
        item.name = "Table28";
        item.summary = $('#table28').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.table29output) {
        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Correction Factor:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table29output["Correction Factor:"];
        this.wizardFactorInput.controlText = this.table29output["Correction Factor:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table29model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Thermal resistivity of soil (&#176;C.m/W):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table29output["Thermal resistivity of soil (deg.C.m/W):"];
        this.wizardFactorInput.controlText = this.table29output["Thermal resistivity of soil (deg.C.m/W):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table29model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Reference resistivity (&#176;C.m/W):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table29output["Reference resistivity (deg.C.m/W):"];
        this.wizardFactorInput.controlText = this.table29output["Reference resistivity (deg.C.m/W):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table29model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Type of installation:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.table29output["Type of installation:"];
        this.wizardFactorInput.controlText = this.table29output["Type of installation:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table29model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);
        ////////////////////////////////////////////////////////
        var item = new TableItem();
        item.name = "Table29";
        item.summary = $('#table29').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.drTable271output) {
        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Correction Factor:";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Correction Factor:"];
        this.wizardFactorInput.controlText = this.drTable271output["Correction Factor:"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Conductor temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Conductor temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Conductor temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Soil ambient temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Soil ambient temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Soil ambient temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Reference temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        controlId += 1;
        this.wizardFactorInput = new WizardFactorInput();
        this.wizardFactorInput.calculationId = this.newCalculationId;
        this.wizardFactorInput.calcStandardId = standardId
        this.wizardFactorInput.installationType = this.drInstallType;
        this.wizardFactorInput.cores = this.drBunchingCore;
        this.wizardFactorInput.buriedType = this.drBunchingType;
        this.wizardFactorInput.stepId = 5;
        this.wizardFactorInput.stepName = "Results";
        this.wizardFactorInput.stepTitle = "Results";
        this.wizardFactorInput.controlId = controlId;
        this.wizardFactorInput.controlLabel = "Reference temperature (&#176;C):";
        this.wizardFactorInput.controlType = "label";
        this.wizardFactorInput.controlValue = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.controlText = this.drTable271output["Reference temperature (deg.C.):"];
        this.wizardFactorInput.defaultValue = null;
        this.wizardFactorInput.useDefaultValue = null;
        this.wizardFactorInput.overallWizardFactor = this.table271model.drf.toString();
        this.wizardFactorInputList.push(this.wizardFactorInput);

        var item = new TableItem();
        item.name = "Table27";
        item.summary = $('#table27').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      controlId += 1;
      this.wizardFactorInput = new WizardFactorInput();
      this.wizardFactorInput.calculationId = this.newCalculationId;
      this.wizardFactorInput.calcStandardId = standardId
      this.wizardFactorInput.installationType = this.drInstallType;
      this.wizardFactorInput.cores = this.drBunchingCore;
      this.wizardFactorInput.buriedType = this.drBunchingType;
      this.wizardFactorInput.stepId = 5;
      this.wizardFactorInput.stepName = "Results";
      this.wizardFactorInput.stepTitle = "Results";
      this.wizardFactorInput.controlId = controlId;
      this.wizardFactorInput.controlLabel = "Overall Correction Factor:";
      this.wizardFactorInput.controlType = "label";
      this.wizardFactorInput.controlValue = this.finalDrf.toString();
      this.wizardFactorInput.controlText = this.finalDrf.toString();
      this.wizardFactorInput.defaultValue = null;
      this.wizardFactorInput.useDefaultValue = null;
      this.wizardFactorInput.isLastControl = true;
      this.wizardFactorInput.overallWizardFactor = this.finalDrf.toString();
      this.wizardFactorInputList.push(this.wizardFactorInput);
    }
    this.OriDrfWizard = this.CalculationReportInput.wizardValues;
    this._wizardService.storeWizardFactor(this.wizardFactorInputList).subscribe((result) => {
      this.updateDeratingFactorValue(true, this.CalculationReportInput.wizardValues);
    }, error => { });
  }
  OnChangeCore(e: any) {
    setTimeout(() => {

      if (this.drBunchingCore == 1) {
        this.table23model.CableType = 1;
        this.table23model.drf = 0.98;
        this.GetTable23Values();
        this.table23CableValues = [
          { "name": "1 cct", "value": 1 },
          { "name": "2 ccts", "value": 2 },
          { "name": "3 ccts", "value": 3 },
        ];
      }
      else {
        this.table23model.CableType = 2;
        this.table23model.drf = 1;
        this.GetTable24Values();
        this.table23CableValues = [
          { "name": "1", "value": 1 },
          { "name": "2", "value": 2 },
          { "name": "3", "value": 3 },
          { "name": "4", "value": 4 },
          { "name": "6", "value": 6 },
          { "name": "9", "value": 9 },
        ];
      }

      this.onSelectInstall(this.table23model.Installation);
    }, 200);
  }
  OnNext() {
    this.setWizardFactorDefaultValues();
    setTimeout(() => {
      this.finalDrf = 1;

      if (this.drInstallType == 1) {
        if (this.drBunchingType != 1) {
          if (this.drTable22output && this.drBunchingType == 2)
            this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable22output["Correction Factor:"]).toFixed(2));
          else if (this.table23output && this.drBunchingType == 3)
            this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table23output["Correction Factor:"]).toFixed(2));
        }
        if (this.drTable271output) {
          this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable271output["Correction Factor:"]).toFixed(2));
          //$("#table27Air1").show();
        }
      }
      else if (this.drInstallType == 2) {
        if (this.drTable25output)
          this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable25output["Correction Factor:"]).toFixed(2));
        if (this.table28output)
          this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table28output["Correction Factor:"]).toFixed(2));
        if (this.table29output)
          this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table29output["Correction Factor:"]).toFixed(2));
        if (this.drTable271output)
          this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable271output["Correction Factor:"]).toFixed(2));
      }

      // if (this.drTable22output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable22output["Correction Factor:"]).toFixed(2));
      // }
      // if (this.table23output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table23output["Correction Factor:"]).toFixed(2));
      // }
      // if (this.drTable25output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable25output["Correction Factor:"]).toFixed(2));
      // }
      // if (this.drTable271output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.drTable271output["Correction Factor:"]).toFixed(2));
      // }
      // if (this.table28output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table28output["Correction Factor:"]).toFixed(2));
      // }
      // if (this.table29output) {
      //     this.finalDrf = this.finalDrf * parseFloat(parseFloat(this.table29output["Correction Factor:"]).toFixed(2));
      // }
      if (this.wizard.currentStep > 1 && this.wizard.currentStep <= 4 && this.drInstallType == 2) {
        if (this.wizard.currentStep == 2 && this.table25model.InstallType != 0) {
          this.table28model.Buried = this.table25model.InstallType;
          this.setTable28Dr();

        }
        if (this.wizard.currentStep == 3 && this.table28model.Buried != 0) {
          if (this.table28model.Buried != this.table25model.InstallType) {
            this.table25model.InstallType = this.table28model.Buried;
          }
          this.table29model.Buried = this.table28model.Buried;
          this.calltable29(this.table29model.Buried);
        } if (this.wizard.currentStep == 4 && this.table29model.Buried != 0) {
          if (this.table29model.Buried != this.table28model.Buried) {
            this.table25model.InstallType = this.table29model.Buried;
            this.table28model.Buried = this.table29model.Buried;
            this.setTable28Dr();
          }
        }
      }
    }, 250);
  }
  onCancel(fromSubmit: boolean = false) {
    if (!fromSubmit && this.OriDrfWizard) {
      this.CalculationReportInput.wizardValues = this.OriDrfWizard
    }
    else {
      this.CalculationReportInput.wizardValues = new DRFWizrd();
      if (this.finalDrf)
        this.CalculationReportInput.wizardValues.finalDrf = parseFloat(this.finalDrf.toFixed(2));
      else
        this.CalculationReportInput.wizardValues.finalDrf = 1;
      this.CalculationReportInput.wizardValues.result = [];
      if (this.drTable22output) {
        var item = new TableItem();
        item.name = "Table22";
        item.summary = $('#table22').text();;
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.table23output) {
        var item = new TableItem();
        item.name = "Table23";
        item.summary = $('#table23').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.drTable25output) {
        var item = new TableItem();
        item.name = "Table25";
        item.summary = $('#table25').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.drTable271output) {
        var item = new TableItem();
        item.name = "Table27";
        item.summary = $('#table27').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.table28output) {
        var item = new TableItem();
        item.name = "Table28";
        item.summary = $('#table28').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      if (this.table29output) {
        var item = new TableItem();
        item.name = "Table29";
        item.summary = $('#table29').text();
        this.CalculationReportInput.wizardValues.result.push(item);
      }
      this.OriDrfWizard = this.CalculationReportInput.wizardValues;
    }
    this.onResetControlValues();
    if (this.wizard)
      this.wizard.goTo(1);
  }
  onResetControlValues() {
    this.drTable22output = undefined;
    this.table23output = undefined;
    this.drTable25output = undefined;
    this.drTable271output = undefined;
    this.table28output = undefined;
    this.table29output = undefined;

    this.drInstallType = 1;
    this.drBunchingType = 1;
    this.drBunchingCore = 1;
    if (this.CableSize['core'] == "0")
      this.drBunchingCore = 1;
    else
      this.drBunchingCore = 2;


    var imageName = (this.CableSize['description'] != null && this.CableSize['description'] != undefined) ? this.CableSize['description'].toLowerCase().trim() : "";

    this.table271model.UseStandard = true;
    this.table271model.AmbientTemp = 30;
    this.table271model.Insulation = 2;
    this.table271model.drf = 1;
    if (imageName.search('ground') == -1) {

      this.table22model.Arrangement = 1;
      // (<any>$('#drTable22Arrangement')).select2('val', '1');
      this.table22model.NoOfCircuits = 1;
      // (<any>$('#drTable22NoOfCircuits')).select2('val', '1');
      this.table22model.drf = 1;

      this.table23model.CableType = this.drBunchingCore;
      this.table23model.Row = 1;
      (<any>$('#table23Row')).select2('val', '1');
      this.table23model.Cables = 1;
      this.table23model.Installation = 1;
      this.table23model.drf = 0.98;
    }
    else {
      this.drInstallType = 2;
      this.table25model.NoOfCircuits = 1;
      // (<any>$('#drTable25NoOfCicruits')).select2('val', '1');
      this.table25model.CableType = this.drBunchingCore;
      this.table25model.TouchingType = 1;
      this.table25model.InstallType = 1;
      this.table25model.Distance = 0;
      this.table25model.drf = 1;
      this.table25model.Arrangement = 1;
      // (<any>$('#drTable25Arrangement')).select2('val', '1');

      this.table28model.UseStandard = true;
      this.table28model.Depth = 0.7;
      this.table28model.Buried = 1;
      this.table28model.drf = 1;

      this.table29model.UseStandard = true;
      this.table29model.Resitivity = 2.50;
      this.table29model.Buried = 1;
      this.table29model.drf = 1;
    }
  }


  OnSubmit() {
    this.UserWizard = true;
    this.CableSize['isderatingwiz'] = "1";
    $('.chkUW').prop('checked', 'true');
    $('#deratingFactor').val(this.finalDrf.toFixed(2)).change();
    $('#correctionWizard').modal('toggle');
    if (this.drInstallType == 1)
      $('#startStepAir').click();
    else
      $('#startStepGround').click();
    this.CableSize['deratingfactor'] = this.finalDrf.toFixed(2);
    this.getAllControlsValue();
    //this.onCancel(true);
    this.updateWizardFactorValues();
    //this.StoreDHROutput(this.CalculationReportInput.wizardValues);
    this.SetFirstWizardScreen();
  }

  onClose() {
    //if (this.wizardFactorOutput.length == 0 && this.wizardFactorInputList.length == 0) {
    //    this.UserWizard = false;
    //    $('#checkboxUseWizard').removeAttr('checked');
    //}
    this.SetFirstWizardScreen();
  }
  // setInstallationType() {
  //   let newImageName = this.CableSize['description'].toLowerCase().trim();

  //   if (newImageName.search('buried') === -1)
  //     this.drInstallType = 1;
  //   else
  //     this.drInstallType = 2;
  // }

  setInstallationType() {
    let newImageName = (this.CableSize['description'] != null && this.CableSize['description'] != undefined) ? this.CableSize['description'].toLowerCase().trim() : "";

    if (newImageName.search('ground') == -1)
      this.drInstallType = 1;
    else
      this.drInstallType = 2;
  }

  SetFirstWizardScreen() {
    this.GetTable271Dr(null);
    this.setInstallationType();

    setTimeout(() => {
      if (this.drInstallType == 1) {
        this.wizard = (<any>$('#m_wizard')).mWizard({
          startStep: 1,
        });
        //  $('#m_wizard_soil').css('display', 'none');
        $('#m_wizard').css('display', 'block');

        $("#m_wizard_form_step_2").addClass('m-wizard__form-step--current');
        //  $(".typetwo").removeClass('m-wizard__step--current');
        if (!$(".typeone").hasClass("ng-star-inserted m-wizard__step--done"))
          $(".typeone .m-wizard__step-number span").css("background-color", '#34bfa3');

        $("#m_wizard_form_step_3").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_4").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_5").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_6").removeClass('m-wizard__form-step--current');

        // type 2
        $("#m_wizard_form_step_7").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_8").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_9").removeClass('m-wizard__form-step--current');

        this.wizard.steps = (<any>$('#m_wizard')).find('.m-wizard__step');
        this.wizard.totalSteps = this.wizard.steps.length;
      }
      else if (this.drInstallType == 2) {
        this.wizard = (<any>$('#m_wizard')).mWizard({
          startStep: 1,
        });

        $('#m_wizard').css('display', 'block');
        //   $('#m_wizard_soil').css('display', 'block');
        //$(".typeone").removeClass('m-wizard__step--current');
        if (!$(".typetwo").hasClass("ng-star-inserted m-wizard__step--done"))
          $(".typetwo .m-wizard__step-number span").css("background-color", '#34bfa3');

        $("#m_wizard_form_step_7").addClass('m-wizard__form-step--current');
        //            $(".typetwo").addClass('m-wizard__step--current');

        $("#m_wizard_form_step_4").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_5").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_soil_8").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_soil_9").removeClass('m-wizard__form-step--current');

        // type 1
        $("#m_wizard_form_step_2").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_3").removeClass('m-wizard__form-step--current');
        $("#m_wizard_form_step_6").removeClass('m-wizard__form-step--current');


        this.wizard.steps = (<any>$('#m_wizard')).find('.m-wizard__step');
        this.wizard.totalSteps = this.wizard.steps.length;
      }
      this.wizard.goTo(1);
    });
  }

  onddldrTable271InsulationChange(e) {
    this.table271model.Insulation = parseInt(e.value);
    this.SetMinMaxAmbientTemp();
    this.drfBSDService.getTable271(3, this.table271model.Insulation, this.table271model.AmbientTemp, this.drInstallType, true).subscribe(result => {
      this.table271model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
      if (this.table271model.UseStandard != true) {
        this.drTable271output = result;
      }
    });
  }

  SetMinMaxAmbientTemp(): void {
    if (this.drInstallType == 1) {
      if (this.table271model.AmbientTemp > 55 && this.table271model.Insulation == 1) { this.table271model.AmbientTemp = 55; }
      else if (this.table271model.AmbientTemp > 60 && (this.table271model.Insulation == 2 || this.table271model.Insulation == 4)) { this.table271model.AmbientTemp = 60; }
      else if (this.table271model.AmbientTemp > 80 && this.table271model.Insulation == 3) { this.table271model.AmbientTemp = 80; }
      else if (this.table271model.AmbientTemp > 95 && this.table271model.Insulation == 5) { this.table271model.AmbientTemp = 95; }
      else if (this.table271model.AmbientTemp < 10) { this.table271model.AmbientTemp = 10; }
    }
    if (this.drInstallType == 2) {
      if (this.table271model.AmbientTemp > 60 && this.table271model.Insulation == 2) {
        this.table271model.AmbientTemp = 60;
      }
      else if (this.table271model.AmbientTemp > 80 && this.table271model.Insulation == 3) {
        this.table271model.AmbientTemp = 80;
      }
      else if (this.table271model.AmbientTemp < 10) {
        this.table271model.AmbientTemp = 10;
      }
    }
  }


  OnChangeBunchingType(bunchingType: number) {

    if (bunchingType == 1)
      this.wizard.totalSteps = 3;
    else
      this.wizard.totalSteps = 4;

    $('#divBunchingType2').css('display', 'none');
    $('#divBunchingType3').css('display', 'none');

    if (bunchingType == 2)
      $('#divBunchingType2').css('display', 'block');
    else if (bunchingType == 3)
      $('#divBunchingType3').css('display', 'block');
  }
  EmailReportChanged() {
    setTimeout(() => {
      if (this.CalculationReportInput.sendEmail) {
        $('#chkEmailReport').attr('checked', 'true');
      } else {
        $('#chkEmailReport').removeAttr('checked');
      }
    }, 100);
  }

  ShowNameChanged() {
    setTimeout(() => {
      if (this.CalculationReportInput.printName) {
        $('#chkPrintName').attr('checked', 'true');
      } else {
        $('#chkPrintName').removeAttr('checked');
      }
    }, 100);
  }
  rebind() {
    //setTimeout(() => {
    //    this.calculationName = this.route.snapshot.queryParamMap.get('cname');
    //    this.projectName = this.route.snapshot.queryParamMap.get('name');
    //    this.route.params.subscribe((params) => {
    //        
    //        this.newCalculationId = parseInt(params.cid);
    //        this.projectId = parseInt(params.pid);
    //        this.GetData('Load', '', 0, 0, 0, 0, 0, 0, 0, '', '', this.newCalculationId, 0, 0);
    //    });            
    //}, 250);
  }
  UpdateXmlValues(data: CableproXmlInput) {
    //console.log('UpdateXmlValues');
    this.showLoader();
    this._CableproService.storeXml(data).subscribe((result) => {
      this.hideLoader();
    }, error => {
      //console.log("There is no internet connection");
      this.hideLoader();
    });
  }
  UpdateVoltageLabelValue() {
    //  
    //console.log('UpdateVoltageStatus');
    if (this.voltageSupplyLabel === undefined || this.voltageSupplyLabel === null || this.voltageSupplyLabel.trim() == '')
      return false;

    if (this.newCalculationId === undefined || this.newCalculationId === null || this.newCalculationId == 0)
      return false;

    let isVoltageDrop: boolean = (this.voltageSupplyLabel == 'drop');

    this.highlighttext(this.Dictatingfactorres);

    this._calculationService.updateVoltageStatus(this.newCalculationId, isVoltageDrop).subscribe((result) => {

    }, error => {
      //console.log("There is no internet connection");
    });
  }
  CableSizeValuesUpdate(): boolean {
    if (this.PrevCableSize === null) {
      this.PrevCableSize = {
        insulation: '0',
        conductor: '0',
        earthconductor: '0',
        core: '0',
        phase: '0',
        faultlevel: '3',
        supplyvoltage: '230',
        voltagedrop: '2.5',
        powerunit: '1',
        efficiency: '100',
        lengthofrun: '50',
        current: '100',
        powerfactor: '0.9',
        unit: '0',
        deratingfactor: '1',
        device: '0',
        usevd: '1',
        protection: {
          shortcircuittime: '0.1',
          MCBrating: '0',
          ACBrating: '0',
          HRCFuserating: '0',
          MCCBrating: '0',
          curve: '0',
          earthfaulttime: '0',
          rcd: '0',
          tripcurrent: '0',
          tripmultiplier: '0',
          thermalsetting: '0',
          customrating: '0',
          description: '0',
          IsUnknown: true,
          Xml: undefined,
          TrippingXml: undefined,
          protectionConfigurationModel: {}
        },
        installtablewind: { wind: '' },
        specifyconductor: {
          phase: {
            mode: '0',
            size: '0',
            circuits: '1'
          },
          neutral: {
            mode: '0',
            size: '0',
            circuits: '1'
          },
          earth: {
            mode: '1',
            size: '0',
            circuits: '1'
          }
        },
        tableno: 'B.52.2',
        columnno: '2',
        startingrowindex: '0',
        endingrowindex: '15',
        description: 'A1 Insulated conductors in conduit in a thermally insulated wall',
        tablectrlvalue: '0',
        voltagefactor: '1.1',
        calculationstandard: '3',
        conduitsize: {
          mode: '0',
          size: '0'
        },
        cableCalcProtectiveDeviceSource: this.cableCalcProtectiveDeviceSource,
        isVoltageDrop: true
      };

      this.PrevCableSize['dcvoltage'] = this.CableSize['dcvoltage'];
      this.PrevCableSize['onephasevoltage'] = this.CableSize['onephasevoltage'];
      this.PrevCableSize['threephasevoltage'] = this.CableSize['threephasevoltage'];
      this.PrevCableSize['insulation'] = this.CableSize['insulation'];
      this.PrevCableSize['conductor'] = this.CableSize['conductor'];
      this.PrevCableSize['earthconductor'] = this.CableSize['earthconductor'];
      this.PrevCableSize['core'] = this.CableSize['core'];
      this.PrevCableSize['phase'] = this.CableSize['phase'];
      this.PrevCableSize['faultlevel'] = this.CableSize['faultlevel'];
      this.PrevCableSize['supplyvoltage'] = this.CableSize['supplyvoltage'];
      this.PrevCableSize['voltagedrop'] = this.CableSize['voltagedrop'];
      this.PrevCableSize['powerunit'] = this.CableSize['powerunit'];
      this.PrevCableSize['efficiency'] = this.CableSize['efficiency'];

      this.PrevCableSize['lengthofrun'] = this.CableSize['lengthofrun'];
      this.PrevCableSize['current'] = this.CableSize['current'];
      this.PrevCableSize['powerfactor'] = this.CableSize['powerfactor'];
      this.PrevCableSize['unit'] = this.CableSize['unit'];
      this.PrevCableSize['deratingfactor'] = this.CableSize['deratingfactor'];
      this.PrevCableSize['device'] = this.CableSize['device'];
      this.PrevCableSize['usevd'] = this.CableSize['usevd'];
      this.PrevCableSize['isVoltageDrop'] = this.CableSize['isVoltageDrop'];
      //
      this.PrevCableSize['protection']['shortcircuittime'] = this.CableSize['protection']['shortcircuittime'];
      this.PrevCableSize['protection']['MCBrating'] = this.CableSize['protection']['MCBrating'];
      this.PrevCableSize['protection']['ACBrating'] = this.CableSize['protection']['ACBrating'];
      this.PrevCableSize['protection']['HRCFuserating'] = this.CableSize['protection']['HRCFuserating'];
      this.PrevCableSize['protection']['MCCBrating'] = this.CableSize['protection']['MCCBrating'];
      this.PrevCableSize['protection']['curve'] = this.CableSize['protection']['curve'];
      this.PrevCableSize['protection']['earthfaulttime'] = this.CableSize['protection']['earthfaulttime'];
      this.PrevCableSize['protection']['rcd'] = this.CableSize['protection']['rcd'];
      this.PrevCableSize['protection']['tripcurrent'] = this.CableSize['protection']['tripcurrent'];
      this.PrevCableSize['protection']['tripmultiplier'] = this.CableSize['protection']['tripmultiplier'];
      this.PrevCableSize['protection']['thermalsetting'] = this.CableSize['protection']['thermalsetting'];
      this.PrevCableSize['protection']['customrating'] = this.CableSize['protection']['customrating'];
      this.PrevCableSize['protection']['description'] = this.CableSize['protection']['description'];
      this.PrevCableSize['protection']['Xml'] = this.CableSize['protection']['Xml'];
      this.PrevCableSize['protection']['IsUnknown'] = this.CableSize['protection']['IsUnknown'];
      this.PrevCableSize['protection']['TrippingXml'] = this.CableSize['protection']['TrippingXml'];
      this.PrevCableSize['installtablewind']['wind'] = this.CableSize['installtablewind']['wind'];

      this.PrevCableSize['specifyconductor']['phase']['mode'] = this.CableSize['specifyconductor']['phase']['mode'];
      this.PrevCableSize['specifyconductor']['phase']['circuits'] = this.CableSize['specifyconductor']['phase']['circuits'];
      this.PrevCableSize['specifyconductor']['phase']['size'] = this.CableSize['specifyconductor']['phase']['size'];

      this.PrevCableSize['specifyconductor']['neutral']['circuits'] = this.CableSize['specifyconductor']['neutral']['circuits'];
      this.PrevCableSize['specifyconductor']['neutral']['size'] = this.CableSize['specifyconductor']['neutral']['size'];
      this.PrevCableSize['specifyconductor']['neutral']['mode'] = this.CableSize['specifyconductor']['neutral']['mode'];

      this.PrevCableSize['specifyconductor']['earth']['mode'] = this.CableSize['specifyconductor']['earth']['mode'];
      this.PrevCableSize['specifyconductor']['earth']['size'] = this.CableSize['specifyconductor']['earth']['size'];
      this.PrevCableSize['specifyconductor']['earth']['circuits'] = this.CableSize['specifyconductor']['earth']['circuits'];

      this.PrevCableSize['tableno'] = this.CableSize['tableno'];
      this.PrevCableSize['columnno'] = this.CableSize['columnno'];
      this.PrevCableSize['startingrowindex'] = this.CableSize['startingrowindex'];
      this.PrevCableSize['endingrowindex'] = this.CableSize['endingrowindex'];
      this.PrevCableSize['description'] = this.CableSize['description'];
      this.PrevCableSize['tablectrlvalue'] = this.CableSize['tablectrlvalue'];
      this.PrevCableSize['voltagefactor'] = this.CableSize['voltagefactor'];
      this.PrevCableSize['calculationstandard'] = this.CableSize['calculationstandard'];
      this.PrevCableSize['isderatingwiz'] = this.CableSize['isderatingwiz'];
      this.PrevCableSize['deratingtemp'] = this.CableSize['deratingtemp'];
      this.PrevCableSize['conduitsize']['mode'] = this.CableSize['conduitsize']['mode'];
      this.PrevCableSize['conduitsize']['size'] = this.CableSize['conduitsize']['size'];
      this.PrevCableSize['cableCalcProtectiveDeviceSource'] = this.CableSize['cableCalcProtectiveDeviceSource'];
      //console.log(this.PrevCableSize['protection']['thermalsetting'] + this.CableSize['protection']['thermalsetting'] + 'isnull');
      return true;
    }
    else {
      if (this.forceCalc == true) {
        return true;
      }
      //console.log(this.PrevCableSize['protection']['thermalsetting'] + this.CableSize['protection']['thermalsetting'] + 'before');
      if (this.PrevCableSize['cableCalcProtectiveDeviceSource'] != this.CableSize['cableCalcProtectiveDeviceSource']) {
        this.PrevCableSize['cableCalcProtectiveDeviceSource'] = this.CableSize['cableCalcProtectiveDeviceSource'];
        return true;
      }

      if (this.PrevCableSize['dcvoltage'] != this.CableSize['dcvoltage']) {
        this.PrevCableSize['dcvoltage'] = this.CableSize['dcvoltage'];
        return true;
      }

      if (this.PrevCableSize['onephasevoltage'] != this.CableSize['onephasevoltage']) {
        this.PrevCableSize['onephasevoltage'] = this.CableSize['onephasevoltage'];
        return true;
      }

      if (this.PrevCableSize['threephasevoltage'] != this.CableSize['threephasevoltage']) {
        this.PrevCableSize['threephasevoltage'] = this.CableSize['threephasevoltage'];
        return true;
      }

      if (this.PrevCableSize['insulation'] != this.CableSize['insulation']) {
        this.PrevCableSize['insulation'] = this.CableSize['insulation'];
        return true;
      }

      if (this.PrevCableSize['conductor'] != this.CableSize['conductor']) {
        this.PrevCableSize['conductor'] = this.CableSize['conductor'];
        return true;
      }
      if (this.PrevCableSize['earthconductor'] != this.CableSize['earthconductor']) {
        this.PrevCableSize['earthconductor'] = this.CableSize['earthconductor'];
        return true;
      }

      if (this.PrevCableSize['core'] != this.CableSize['core']) {
        this.PrevCableSize['core'] = this.CableSize['core'];
        return true;
      }

      if (this.PrevCableSize['phase'] != this.CableSize['phase']) {
        this.PrevCableSize['phase'] = this.CableSize['phase'];
        return true;
      }

      if (this.PrevCableSize['faultlevel'] != this.CableSize['faultlevel']) {
        this.PrevCableSize['faultlevel'] = this.CableSize['faultlevel'];
        return true;
      }

      if (this.PrevCableSize['supplyvoltage'] != this.CableSize['supplyvoltage']) {
        this.PrevCableSize['supplyvoltage'] = this.CableSize['supplyvoltage'];
        return true;
      }

      if (this.PrevCableSize['voltagedrop'] != this.CableSize['voltagedrop']) {
        this.PrevCableSize['voltagedrop'] = this.CableSize['voltagedrop'];
        return true;
      }
      if (this.PrevCableSize['powerunit'] != this.CableSize['powerunit']) {
        this.PrevCableSize['powerunit'] = this.CableSize['powerunit'];
        return true;
      }
      if (this.PrevCableSize['efficiency'] != this.CableSize['efficiency']) {
        this.PrevCableSize['efficiency'] = this.CableSize['efficiency'];
        return true;
      }

      if (this.PrevCableSize['lengthofrun'] != this.CableSize['lengthofrun']) {
        this.PrevCableSize['lengthofrun'] = this.CableSize['lengthofrun'];
        return true;
      }

      if (this.PrevCableSize['current'] != this.CableSize['current']) {
        this.PrevCableSize['current'] = this.CableSize['current'];
        return true;
      }

      if (this.PrevCableSize['powerfactor'] != this.CableSize['powerfactor']) {
        this.PrevCableSize['powerfactor'] = this.CableSize['powerfactor'];
        return true;
      }

      if (this.PrevCableSize['unit'] != this.CableSize['unit']) {
        this.PrevCableSize['unit'] = this.CableSize['unit'];
        return true;
      }

      if (this.PrevCableSize['deratingfactor'] != this.CableSize['deratingfactor']) {
        this.PrevCableSize['deratingfactor'] = this.CableSize['deratingfactor'];
        return true;
      }

      if (this.PrevCableSize['device'] != this.CableSize['device']) {
        this.PrevCableSize['device'] = this.CableSize['device'];
        return true;
      }

      if (this.PrevCableSize['usevd'] != this.CableSize['usevd']) {
        this.PrevCableSize['usevd'] = this.CableSize['usevd'];
        return true;
      }

      if (this.PrevCableSize['isVoltageDrop'] != this.CableSize['isVoltageDrop']) {
        this.PrevCableSize['isVoltageDrop'] = this.CableSize['isVoltageDrop'];
        return true;
      }

      let protectionValuesUpdateCount: number = 0;

      if (this.PrevCableSize['protection']['shortcircuittime'] != this.CableSize['protection']['shortcircuittime']) {
        this.PrevCableSize['protection']['shortcircuittime'] = this.CableSize['protection']['shortcircuittime'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['MCBrating'] != this.CableSize['protection']['MCBrating']) {
        this.PrevCableSize['protection']['MCBrating'] = this.CableSize['protection']['MCBrating'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['ACBrating'] != this.CableSize['protection']['ACBrating']) {
        this.PrevCableSize['protection']['ACBrating'] = this.CableSize['protection']['ACBrating'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['HRCFuserating'] != this.CableSize['protection']['HRCFuserating']) {
        this.PrevCableSize['protection']['HRCFuserating'] = this.CableSize['protection']['HRCFuserating'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['MCCBrating'] != this.CableSize['protection']['MCCBrating']) {
        this.PrevCableSize['protection']['MCCBrating'] = this.CableSize['protection']['MCCBrating'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['curve'] != this.CableSize['protection']['curve']) {
        this.PrevCableSize['protection']['curve'] = this.CableSize['protection']['curve'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['earthfaulttime'] != this.CableSize['protection']['earthfaulttime']) {
        this.PrevCableSize['protection']['earthfaulttime'] = this.CableSize['protection']['earthfaulttime'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['rcd'] != this.CableSize['protection']['rcd']) {
        this.PrevCableSize['protection']['rcd'] = this.CableSize['protection']['rcd'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['tripcurrent'] != this.CableSize['protection']['tripcurrent']) {
        this.PrevCableSize['protection']['tripcurrent'] = this.CableSize['protection']['tripcurrent'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['tripmultiplier'] != this.CableSize['protection']['tripmultiplier']) {
        this.PrevCableSize['protection']['tripmultiplier'] = this.CableSize['protection']['tripmultiplier'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['thermalsetting'] != this.CableSize['protection']['thermalsetting']) {
        this.PrevCableSize['protection']['thermalsetting'] = this.CableSize['protection']['thermalsetting'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['customrating'] != this.CableSize['protection']['customrating']) {
        this.PrevCableSize['protection']['customrating'] = this.CableSize['protection']['customrating'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['description'] != this.CableSize['protection']['description']) {
        this.PrevCableSize['protection']['description'] = this.CableSize['protection']['description'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['Xml'] != this.CableSize['protection']['Xml']) {
        this.PrevCableSize['protection']['Xml'] = this.CableSize['protection']['Xml'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['TrippingXml'] != this.CableSize['protection']['TrippingXml']) {
        this.PrevCableSize['protection']['TrippingXml'] = this.CableSize['protection']['TrippingXml'];
        protectionValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['protection']['IsUnknown'] != this.CableSize['protection']['IsUnknown']) {
        this.PrevCableSize['protection']['IsUnknown'] = this.CableSize['protection']['IsUnknown'];
        protectionValuesUpdateCount += 1;
      }

      let specifyConductorValuesUpdateCount: number = 0;

      if (this.PrevCableSize['specifyconductor']['phase']['mode'] != this.CableSize['specifyconductor']['phase']['mode']) {
        this.PrevCableSize['specifyconductor']['phase']['mode'] = this.CableSize['specifyconductor']['phase']['mode'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['phase']['circuits'] != this.CableSize['specifyconductor']['phase']['circuits']) {
        this.PrevCableSize['specifyconductor']['phase']['circuits'] = this.CableSize['specifyconductor']['phase']['circuits'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['phase']['size'] != this.CableSize['specifyconductor']['phase']['size']) {
        this.PrevCableSize['specifyconductor']['phase']['size'] = this.CableSize['specifyconductor']['phase']['size'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['neutral']['circuits'] != this.CableSize['specifyconductor']['neutral']['circuits']) {
        this.PrevCableSize['specifyconductor']['neutral']['circuits'] = this.CableSize['specifyconductor']['neutral']['circuits']
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['neutral']['size'] != this.CableSize['specifyconductor']['neutral']['size']) {
        this.PrevCableSize['specifyconductor']['neutral']['size'] = this.CableSize['specifyconductor']['neutral']['size'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['neutral']['mode'] != this.CableSize['specifyconductor']['neutral']['mode']) {
        this.PrevCableSize['specifyconductor']['neutral']['mode'] = this.CableSize['specifyconductor']['neutral']['mode'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['earth']['mode'] != this.CableSize['specifyconductor']['earth']['mode']) {
        this.PrevCableSize['specifyconductor']['earth']['mode'] = this.CableSize['specifyconductor']['earth']['mode'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['earth']['size'] != this.CableSize['specifyconductor']['earth']['size']) {
        this.PrevCableSize['specifyconductor']['earth']['size'] = this.CableSize['specifyconductor']['earth']['size'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['specifyconductor']['earth']['circuits'] != this.CableSize['specifyconductor']['earth']['circuits']) {
        this.PrevCableSize['specifyconductor']['earth']['circuits'] = this.CableSize['specifyconductor']['earth']['circuits'];
        specifyConductorValuesUpdateCount += 1;
      }

      if (this.PrevCableSize['installtablewind']['wind'] != this.CableSize['installtablewind']['wind']) {
        this.PrevCableSize['installtablewind']['wind'] = this.CableSize['installtablewind']['wind'];
        return true;
      }

      if (this.PrevCableSize['tableno'] != this.CableSize['tableno']) {
        this.PrevCableSize['tableno'] = this.CableSize['tableno'];
        return true;
      }

      if (this.PrevCableSize['columnno'] != this.CableSize['columnno']) {
        this.PrevCableSize['columnno'] = this.CableSize['columnno'];
        return true;
      }

      if (this.PrevCableSize['startingrowindex'] != this.CableSize['startingrowindex']) {
        this.PrevCableSize['startingrowindex'] = this.CableSize['startingrowindex'];
        return true;
      }

      if (this.PrevCableSize['endingrowindex'] != this.CableSize['endingrowindex']) {
        this.PrevCableSize['endingrowindex'] = this.CableSize['endingrowindex']
        return true;
      }

      if (this.PrevCableSize['description'] != this.CableSize['description']) {
        this.PrevCableSize['description'] = this.CableSize['description']
        return true;
      }

      if (this.PrevCableSize['tablectrlvalue'] != this.CableSize['tablectrlvalue']) {
        this.PrevCableSize['tablectrlvalue'] = this.CableSize['tablectrlvalue']
        return true;
      }

      if (this.PrevCableSize['voltagefactor'] != this.CableSize['voltagefactor']) {
        this.PrevCableSize['voltagefactor'] = this.CableSize['voltagefactor']
        return true;
      }

      if (this.PrevCableSize['calculationstandard'] != this.CableSize['calculationstandard']) {
        this.PrevCableSize['calculationstandard'] = this.CableSize['calculationstandard'];
        return true;
      }
      if (this.PrevCableSize['isderatingwiz'] != this.CableSize['isderatingwiz']) {
        this.PrevCableSize['isderatingwiz'] = this.CableSize['isderatingwiz'];
        return true;
      }
      if (this.PrevCableSize['deratingtemp'] != this.CableSize['deratingtemp']) {
        this.PrevCableSize['deratingtemp'] = this.CableSize['deratingtemp'];
        return true;
      }

      if (this.PrevCableSize['conduitsize']['mode'] != this.CableSize['conduitsize']['mode']) {
        this.PrevCableSize['conduitsize']['mode'] = this.CableSize['conduitsize']['mode'];
        return true;
      }

      if (this.PrevCableSize['conduitsize']['size'] != this.CableSize['conduitsize']['size']) {
        this.PrevCableSize['conduitsize']['size'] = this.CableSize['conduitsize']['size'];
        return true;
      }

      //this.hideLoader();
      //console.log(this.PrevCableSize['protection']['thermalsetting'] + this.CableSize['protection']['thermalsetting'] + 'after');
      if (specifyConductorValuesUpdateCount > 0 || protectionValuesUpdateCount > 0)
        return true;
      else
        return false;
    }
  }
  onddlEarthConductorChange(value, isTriggered: any = "false") {
    this.CableproInput.EarthConductorId = value;

    if (isTriggered === "true") {
      this.CableSize['earthconductor'] = this.PrevEarthConductorId.toString();
      setTimeout(function () {
        $('#windspeed').select2({
          width: '100%',
          minimumResultsForSearch: Infinity // disable search
        });
      }, 800);
    }
    else {
      this.PrevEarthConductorId = value;
      this.CableSize['earthconductor'] = value;
      this.getAllControlsValue();

    }
  }
  IsReportEmailValid(): boolean {

    let isValidFlag: boolean = true;

    $('#sendEmailError1').css('display', 'none');
    $('#sendEmailError2').css('display', 'none');

    if ($('#chkEmailReport').is(':checked')) {

      let reportEmailAddress: string = $('#sendEmail').val().toString().trim();
      let reportEmailAddressArray: string[] = reportEmailAddress.split(',');

      let emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,13}\b$/i;

      if (reportEmailAddress.length === 0) {
        isValidFlag = false;
        $('#sendEmailError1').css('display', '');
      }
      else if (reportEmailAddressArray.length > 0) {
        for (let i = 0; i < reportEmailAddressArray.length; i++) {
          if (reportEmailAddressArray[i].trim().length > 0 && !emailPattern.test(reportEmailAddressArray[i].trim())) {
            isValidFlag = false;
            $('#sendEmailError2').css('display', '');
            break;
          }
        }
      }
      else if (!emailPattern.test(reportEmailAddress)) {
        isValidFlag = false;
        $('#sendEmailError2').css('display', '');
      }

      $('#sendEmail').focus();
    }
    return isValidFlag;
  }

  IsReportFormValid(): boolean {

    let isValidFlag: boolean = true;

    $('#RptProjectName').css('display', 'none');
    $('#RptCalculationName').css('display', 'none');

    if ($('#chkPrintName').is(':checked')) {

      let rptProjectName: string = $('#project-name').val().toString().trim();

      if (rptProjectName.length === 0) {
        isValidFlag = false;
        $('#RptProjectName').css('display', '');
        $('#project-name').focus();
        return isValidFlag;
      }

      let rptCalculationName: string = $('#job-number').val().toString().trim();

      if (rptCalculationName.length === 0) {
        isValidFlag = false;
        $('#RptCalculationName').css('display', '');
        $('#job-number').focus();
      }

    }
    return isValidFlag;
  }

  ngOnDestroy() {
    this.toRemoveData.unsubscribe();
    this.newCalculationId = null;
    this._calculationService.setPrevValue('').subscribe((result) => { }, error => { });
    if (this.actionSubscription) {
      this.actionSubscription.unsubscribe();
    }
  }
  /* to copy object and avoid global value passing*/
  copy(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  RemoveTrailingZeros(numberWithZero: string): string {
    try {
      if (numberWithZero.indexOf('.') != -1) {
        var splitnumberList = numberWithZero.split('.');

        let afterDecimalValue = parseInt(splitnumberList[1]);

        if (afterDecimalValue < 10)
          return parseFloat(numberWithZero).toString();
        else {
          let modulusValue = afterDecimalValue % 10;

          if (modulusValue == 0)
            return parseFloat(numberWithZero).toFixed(1);
          else
            return parseFloat(numberWithZero).toFixed(2);
        }
      }
      else
        return parseInt(numberWithZero).toString();
    } catch (e) {
      return numberWithZero;

    }
  }
  setWizardFactorDefaultValues() {
    // this._wizardService.getWizardFactors(this.bsCalculationId, this.drInstallType).subscribe(result => {
    //     if (result.items.length > 0) {
    //         this.wizardFactorOutput = result.items;
    //         for (let wizardFactor of this.wizardFactorOutput) {
    let stepId = this.wizard.currentStep;
    let callby = ($('.m-wizard__step--current')).find('.m-wizard__step-label').text().trim().toLowerCase();
    switch (stepId) {
      case 1:
        //  this.drBunchingType = 1;
        if (callby === 'bunched circuits') {/* In air - Bunched Circuits */
          //    this.drBunchingType = 2;
          //if (wizardFactor.controlId == 1) {/* control 1 */
          //   this.table22model.Arrangement = parseInt(wizardFactor.controlValue);
          // $('#drTable22Arrangement').trigger('change');
          //}
          //if (wizardFactor.controlId == 2) {/* control 2 */
          //  this.table22model.NoOfCircuits = parseInt(wizardFactor.controlValue);
          // $('#drTable22NoOfCircuits').trigger('change');
          //}
          //if (wizardFactor.isLastControl)
          this.GetTable22Dr(null);
        }
        else if (callby === 'in trays') { /* In air - Cable Trays */
          // this.drBunchingType = 3;
          //if (wizardFactor.controlId == 1) {/* control 1 */
          //   this.table23model.Row = parseInt(wizardFactor.controlValue);
          // $('#drTable23Row').trigger('change');
          //}
          //  else if (wizardFactor.controlId == 2) {/* control 2 */
          //  this.table23model.Cables = parseInt(wizardFactor.controlValue);
          // $('#drTable23Cable').trigger('change');
          //}
          // else if (wizardFactor.controlId == 3) {/* control 3 */
          //     this.table23model.Installation = parseInt(wizardFactor.controlValue);
          // }
          //if (wizardFactor.isLastControl) {
          //  this.table23model.CableType = this.drBunchingCore;
          this.GetTable23Dr(null);
          //}
        }
        else if (callby === 'buried groups' || callby === 'arrangement  buried groups' || (callby === '' && this.drInstallType == 2)) { /* In ground - Buried Circuits */
          //if (wizardFactor.controlId == 1) {/* control 1 */
          //  this.table25model.NoOfCircuits = parseInt(wizardFactor.controlValue);
          // $('#drTable25NoOfCicruits').trigger('change');
          //}
          //if (this.table25model.NoOfCircuits > 1 && wizardFactor.controlId == 2) {/* control 2 */
          //  this.table25model.Arrangement = parseInt(wizardFactor.controlValue);
          // $('#drTable25Arrangement').trigger('change');
          //}
          // if (wizardFactor.isLastControl) {
          //     this.drInstallType = 2;
          //     this.table25model.CableType = this.drBunchingCore;
          //     this.table25model.InstallType = wizardFactor.buriedType;
          this.GetTable25Dr();
          this.setTable25Values(this.table25model.Arrangement);
          //}
        }
        else if (this.drInstallType == 1 && (callby === 'air temprature' || callby === 'air temperature')) {/* In air */
          //if (wizardFactor.controlId == 1) {/* control 1 */
          //  this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
          // this.table271model.UseStandard = wizardFactor.useDefaultValue;
          $('#inputUseStandard').trigger('change');
          $('#drTable271UseStandard').trigger('change');
          //}
          if (!this.table271model.UseStandard) {/* control 2 */
            // this.table271model.Insulation = parseInt(wizardFactor.controlValue);
            // $('#drTable271Insulation').trigger('change');
          }
          //if (wizardFactor.isLastControl)
          this.GetTable271Dr(null);
        }
        break;
      case 2:
      case 4:
        if (stepId == 2) {
          if (this.drInstallType == 1 && (callby === 'air temprature' || callby === 'air temperature')) {/* In air */
            // if (wizardFactor.controlId == 1) {/* control 1 */
            //  this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
            // this.table271model.UseStandard = wizardFactor.useDefaultValue;
            $('#inputUseStandard').trigger('change');
            $('#drTable271UseStandard').trigger('change');
            // }
            if (!this.table271model.UseStandard) {/* control 2 */
              //   this.table271model.Insulation = parseInt(wizardFactor.controlValue);
              // $('#drTable271Insulation').trigger('change');
            }
            //if (wizardFactor.isLastControl)
            this.GetTable271Dr(null);
          }
          if (callby === 'bunched circuits') {/* In air - Bunched Circuits */
            // $('#drTable22Arrangement').trigger('change');

            // $('#drTable22NoOfCircuits').trigger('change');

            this.GetTable22Dr(null);
          }

          if (callby === 'in trays') { /* In air - Cable Trays */
            //this.drBunchingType = 3;
            //if (wizardFactor.controlId == 1) {/* control 1 */
            //   this.table23model.Row = parseInt(wizardFactor.controlValue);
            // $('#drTable23Row').trigger('change');
            //}
            //else if (wizardFactor.controlId == 2) {/* control 2 */
            //  this.table23model.Cables = parseInt(wizardFactor.controlValue);
            // $('#drTable23Cable').trigger('change');
            //}
            //else if (wizardFactor.controlId == 3) {/* control 3 */
            //   this.table23model.Installation = parseInt(wizardFactor.controlValue);
            // }
            // if (wizardFactor.isLastControl) {
            //     this.table23model.CableType = this.drBunchingCore;
            this.GetTable23Dr(null);
            // }
          }
          else if (this.drInstallType == 2 && callby === 'depth of burial') {/* In ground */

            //   if (wizardFactor.controlId == 1) {/* control 1 */
            // this.table28model.Depth = parseFloat(wizardFactor.controlValue);
            // this.table28model.UseStandard = wizardFactor.useDefaultValue;
            // this.table28model.Buried = wizardFactor.buriedType;
            $('#inputDepth').trigger('change');
            //  }
            //if (wizardFactor.isLastControl)
            this.GetTable28Dr(null);
          }
        }
        else if (stepId == 4 && this.drInstallType == 2 && (callby === 'soil temprature' || callby === 'soil temperature')) {/* In ground */
          // if (wizardFactor.controlId == 1) {/* control 1 */
          //     this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
          //     this.table271model.UseStandard = wizardFactor.useDefaultValue;
          // }
          //  if (!this.table271model.UseStandard) {/* control 2 */
          //     this.table271model.Insulation = parseInt(wizardFactor.controlValue);
          // }
          // if (wizardFactor.isLastControl)
          this.GetTable271Dr(null);
        }
        break;
      case 3:
        if (this.drInstallType == 2 && callby === 'soil resistivity') {/* In ground */
          // if (wizardFactor.controlId == 1) {/* control 1 */
          //     this.table29model.Resitivity = parseFloat(wizardFactor.controlValue);
          //     this.table29model.UseStandard = wizardFactor.useDefaultValue;
          // }                    
          //if (wizardFactor.isLastControl)
          this.GetTable29Dr(null);
        }
        break;
    }
    //         }
    //     }
    // });
  }

  setWizardFactorValues() {
    if (this.newCalculationId != null && this.newCalculationId != undefined) {
      this._wizardService.getWizardFactors(this.newCalculationId, this.drInstallType).subscribe(result => {
        if (result.items.length > 0) {
          this.wizardFactorOutput = result.items;
          for (let wizardFactor of this.wizardFactorOutput) {
            let stepId = wizardFactor.stepId;
            let callby = wizardFactor.stepName.toLowerCase();
            switch (stepId) {
              case 1:
                this.drBunchingType = 1;
                if (callby === 'bunched circuits') {/* In air - Bunched Circuits */
                  this.drBunchingType = 2;
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table22model.Arrangement = parseInt(wizardFactor.controlValue);
                    // $('#drTable22Arrangement').val(wizardFactor.controlValue).trigger('change');
                  }
                  if (wizardFactor.controlId == 2) {/* control 2 */
                    this.table22model.NoOfCircuits = parseInt(wizardFactor.controlValue);
                    // $('#drTable22NoOfCircuits').val(wizardFactor.controlValue).trigger('change');
                  }
                  if (wizardFactor.isLastControl)
                    this.GetTable22Dr(null);
                }
                else if (callby === 'in trays') { /* In air - Cable Trays */
                  this.drBunchingType = 3;
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table23model.Row = parseInt(wizardFactor.controlValue);
                    // $('#drTable23Row').val(wizardFactor.controlValue).trigger('change');
                  }
                  else if (wizardFactor.controlId == 2) {/* control 2 */
                    this.table23model.Cables = parseInt(wizardFactor.controlValue);
                    // $('#drTable23Cable').val(wizardFactor.controlValue).trigger('change');
                  }
                  else if (wizardFactor.controlId == 3) {/* control 3 */
                    this.table23model.Installation = parseInt(wizardFactor.controlValue);
                    this.onSelectInstall(this.table23model.Installation);
                  }
                  if (wizardFactor.isLastControl) {
                    this.table23model.CableType = this.drBunchingCore;
                    this.GetTable23Dr(null);
                  }
                }
                else if (callby === 'buried groups') { /* In ground - Buried Circuits */
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table25model.NoOfCircuits = parseInt(wizardFactor.controlValue);
                    // $('#drTable25NoOfCicruits').val(wizardFactor.controlValue).trigger('change');
                  }
                  if (this.table25model.NoOfCircuits > 1 && wizardFactor.controlId == 2) {/* control 2 */
                    this.table25model.Arrangement = parseInt(wizardFactor.controlValue);
                    // $('#drTable25Arrangement').val(wizardFactor.controlValue).select2({
                    //     width: '100%',
                    //     minimumResultsForSearch: Infinity // disable search
                    // }).trigger('change');
                  }
                  if (wizardFactor.isLastControl) {
                    this.drInstallType = 2;
                    this.table25model.CableType = this.drBunchingCore;
                    this.table25model.InstallType = wizardFactor.buriedType;
                    this.GetTable25Dr();
                    this.setTable25Values(this.table25model.Arrangement);
                  }
                }
                else if (wizardFactor.installationType == 1 && callby === 'air temprature') {/* In air */
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
                    this.table271model.UseStandard = wizardFactor.useDefaultValue;
                    $('#inputUseStandard').val(wizardFactor.controlValue).trigger('change');
                    $('#drTable271UseStandard').val(wizardFactor.controlValue).trigger('change');
                  }
                  else if (!this.table271model.UseStandard && wizardFactor.controlId == 2) {/* control 2 */
                    this.table271model.Insulation = parseInt(wizardFactor.controlValue);
                    // $('#drTable271Insulation').val(wizardFactor.controlValue).trigger('change');
                  }
                  if (wizardFactor.isLastControl)
                    this.GetTable271Dr(null);
                }
                break;
              case 2:
              case 4:
                if (stepId == 2) {
                  if (wizardFactor.installationType == 1 && callby === 'air temprature') {/* In air */
                    if (wizardFactor.controlId == 1) {/* control 1 */
                      this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
                      this.table271model.UseStandard = wizardFactor.useDefaultValue;
                      $('#inputUseStandard').val(wizardFactor.controlValue).trigger('change');
                      $('#drTable271UseStandard').val(wizardFactor.controlValue).trigger('change');
                    }
                    else if (!this.table271model.UseStandard && wizardFactor.controlId == 2) {/* control 2 */
                      this.table271model.Insulation = parseInt(wizardFactor.controlValue);
                      // $('#drTable271Insulation').val(wizardFactor.controlValue).trigger('change');
                    }
                    if (wizardFactor.isLastControl)
                      this.GetTable271Dr(null);
                  }
                  else if (wizardFactor.installationType == 2 && callby === 'depth of burial') {/* In ground */

                    if (wizardFactor.controlId == 1) {/* control 1 */
                      this.table28model.Depth = parseFloat(wizardFactor.controlValue);
                      this.table28model.UseStandard = wizardFactor.useDefaultValue;
                      this.table28model.Buried = wizardFactor.buriedType;
                      $('#inputDepth').val(wizardFactor.controlValue).trigger('change');
                    }
                    if (wizardFactor.isLastControl)
                      this.GetTable28Dr(null);
                  }
                }
                else if (stepId === 4 && wizardFactor.installationType == 2 && callby === 'soil temprature') {/* In ground */
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table271model.AmbientTemp = parseFloat(wizardFactor.controlValue);
                    this.table271model.UseStandard = wizardFactor.useDefaultValue;
                  }
                  else if (!this.table271model.UseStandard && wizardFactor.controlId == 2) {/* control 2 */
                    this.table271model.Insulation = parseInt(wizardFactor.controlValue);
                  }
                  if (wizardFactor.isLastControl)
                    this.GetTable271Dr(null);
                }
                break;
              case 3:
                if (wizardFactor.installationType == 2 && callby === 'soil resistivity') {/* In ground */
                  if (wizardFactor.controlId == 1) {/* control 1 */
                    this.table29model.Resitivity = parseFloat(wizardFactor.controlValue);
                    this.table29model.UseStandard = wizardFactor.useDefaultValue;
                  }

                  if (this.table29model.UseStandard)
                    $('#txtresitivity').attr('disabled', 'true');
                  else
                    $('#txtresitivity').removeAttr('disabled');

                  if (wizardFactor.isLastControl)
                    this.GetTable29Dr(null);
                }
                break;
            }
          }
        }
      });
    }
  }
  showWarningOnInstallationChange(methodIndex: any, tableId: any, name: string, description: string, callby: string) {
    if (callby == 'mainpage') {
      this.SelectInstallTableMethodIndex = methodIndex;
      this.SelectInstallTableTableId = tableId;
      this.SelectInstallTableName = name;
      this.SelectInstallTableDescription = description;
      // this.selectInstallTableVoltagedropTable = voltagedropTable;
      // this.selectInstallTableCurrentTable = currentTable;
    }
    var mainInstallationType = 0;

    let newImageName = (name + ' ' + description).toLowerCase().trim();

    if (newImageName.search('ground') == -1)
      mainInstallationType = 1;
    else
      mainInstallationType = 2;

    if (this.wizardFactorOutput.length > 0) {
      let wizardInstallationtype = this.wizardFactorOutput[0].installationType;
      if (wizardInstallationtype == 0)
        wizardInstallationtype = this.wizardFactorOutput[0].installationType;

      if (wizardInstallationtype != mainInstallationType) {
        wizardInstallationtype = mainInstallationType;
        if (callby == 'mainpage')
          this.onSelectInstallTable();
        this.UserWizard = false;
        this.CableSize['isderatingwiz'] = "0";
        //   $('.chkUW').removeAttr('checked');
        $('.chkUW').prop('checked', false);
        // this.onCancel();

        this.onResetControlValues();
        this.resetWizardFactorValue();
      }
      else {
        if (callby == 'mainpage')
          this.onSelectInstallTable();
        //                     if (mainInstallationType == 2)
        //                     {
        //                       //  this.resetWizardControlValuesOnInstallationChange(newImageName);

        //                     }
        if (callby == 'getdata')
          this.resetWizardFactorValue();
      }
    }
    else {
      if (callby == 'mainpage')
        this.onSelectInstallTable();
      if (callby == 'getdata')
        this.resetWizardFactorValue();
      this.onResetControlValues();
      this.setWizardFactorValues();
    }



  }
  loadPreviousValues() {
    this.setWizardFactorValues();
  }
  resetWizardFactorValue() {
    if (this.finalDrf) {
      this.CalculationReportInput.wizardValues = new DRFWizrd();
      this.CalculationReportInput.wizardValues.finalDrf = parseFloat(this.finalDrf.toFixed(2));
      this.CalculationReportInput.wizardValues.result = [];
      this.updateDeratingFactorValue(false, this.CalculationReportInput.wizardValues);
    }
  }

  getShortCircuitCurrent(): string {
    const currentPhaseValue = this.CableproInput.PhaseId;
    let returnStr: string;
    if (this.Xml && currentPhaseValue) {
      switch (currentPhaseValue) {
        case 108:
          returnStr = 'Ph.to-neutral short-cct';
          if (this.Xml.Phase_To_Neutral_SC_circuitCurrent)
            this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.Phase_To_Neutral_SC_circuitCurrent.Val * 10) / 10;
          break;
        case 109:
          returnStr = 'Three Ph. Short-cct';
          if (this.Xml.Three_phaseShort_circuitCurrent)
            this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.Three_phaseShort_circuitCurrent.Val * 10) / 10;
          break;
        case 110:
          returnStr = 'Active-to-neutral short-cct';
          if (this.Xml.Phase_To_Neutral_SC_circuitCurrent)
            this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.Phase_To_Neutral_SC_circuitCurrent.Val * 10) / 10;
          break;
        // case 103:
        //   returnStr = 'Phase short-cct';
        //   if (this.Xml.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct)
        //     this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct.Val * 10) / 10;
        //   break;
        // case 104:
        //   returnStr = 'Phase short-cct';
        //   if (this.Xml.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct)
        //     this.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct = Math.round(this.Xml.ShortCircuitPerformance_Short_cct_Currents_PhaseShort_cct.Val * 10) / 10;
        //   break;
        default:
          returnStr = 'Phase short-cct';
          break;
      }
    }
    return returnStr;
  }

  generateErrorsModel(errorStr) {
    this.warningErrorList = errorStr;
    if (this.warningErrorList && errorStr != "[]" && this.warningErrorList.length > 0) {
      this.warningErrorList = this.warningErrorList.filter(m => m.ErrorCode);
      if (this.warningErrorList && this.warningErrorList.length > 0) {
        this.warningErrorList = this.warningErrorList.sort((a, b) => a.ErrorCode < b.ErrorCode ? -1 : 1).sort((a, b) => a.Type < b.Type ? -1 : 1).sort((a, b) => parseInt(a.IsError) > parseInt(b.IsError) ? -1 : 1);
        this.warningErrorStrData = JSON.stringify(this.warningErrorList);
        this.paginationConfig.totalItems = this.warningErrorList.length;
        let errors = this.warningErrorList.filter(m => m.IsError == "1");
        let warnings = this.warningErrorList.filter(m => m.IsError == "0");
        if (errors && errors.length > 0) {
          this.warningErrorBtnText = "Errors (" + errors.length + ")";
        }
        else {
          this.warningErrorBtnText = "Warnings (" + warnings.length + ")";
        }

        if ((errors && errors.length > 0) && (warnings && warnings.length > 0)) {
          this.warningErrorHeader = "Errors (" + errors.length + ") and Warnings (" + warnings.length + ")";
        }
        else if ((errors && errors.length > 0) && (!warnings || warnings.length == 0))
          this.warningErrorHeader = "Errors (" + errors.length + ") and Warnings";
        else if ((warnings && warnings.length > 0) && (!errors || errors.length == 0))
          this.warningErrorHeader = "Errors and Warnings (" + warnings.length + ")";
        else {
          this.warningErrorHeader = "Errors and Warnings";
        }
      }
    }
    this.updateStatusBar();
  }

  showWarningErrorPopup() {
    $('#warnings-errors-model-cablesize').modal('show');
  }

  pageChanged(event) {
    this.paginationConfig.currentPage = event;
  }

  getErrorMsg(error: string): string {
    let ret: string = '';
    if (error) {
      return error.replace(/\\"/g, '"').replace(/lessthansymbol/g, "<");
    }
    return ret;
  }

  onddlDeviceChange(value) {
    this.device = value;
    $(".tooltip").hide();
    let val: string = '';
    if (this.device == '0') {
      val = 'Unknown';
    } else if (this.device == '1') {
      val = 'MCB';
    } else if (this.device == '2') {
      val = 'MCCB';
    } else if (this.device == '3') {
      val = 'ACB';
    } else if (this.device == '4') {
      val = 'HRC Fuse';
    } else if (this.device == '5') {
      val = 'Custom';
    }
    this.CableSize['device'] = this.device;

    if (this.flag !== true) {
      this._calculationService.setPrevValue('-1').subscribe((result) => {
        this.GetData('protection', '', 0, 0, 0, 0, 0, 0, 0, '', val, this.newCalculationId, 0, 0, 0);

      }, error => { });
    }
    setTimeout(function () {
      $('#protection').find('select').each(function () {
        $(this).select2({
          width: '100%',
          minimumResultsForSearch: Infinity // disable search
        });
      });
    }, 1000);/**/
    this.showHideProtectionWarning();
  }

  onddlActiveChange(e) {
    this.CableproInput.ActiveId = e.id;
    this.PrevActiveValue = e.value;
    this.CableSize['specifyconductor']['phase']['mode'] = '1';
    this.CableSize['specifyconductor']['phase']['size'] = parseFloat(this.PrevActiveValue.replace(' mm²', ''));
    this.getAllControlsValue();
  }

  onddlConduitSizeChange(e) {
    this.CableproInput.ConduitSizeId = e.id;
    this.PrevConduitSize = e.id;
    this.CableSize['conduitsize']['mode'] = '1';
    this.CableSize['conduitsize']['size'] = e.id;
    this.getAllControlsValue();
  }

  onddlNeutralChange(e) {
    this.CableproInput.NeutralId = e.id;
    this.PrevNeutralValue = e.value;
    this.CableSize['specifyconductor']['neutral']['mode'] = '1';
    this.CableSize['specifyconductor']['neutral']['size'] = parseFloat(this.PrevNeutralValue);
    this.getAllControlsValue();
  }

  onddlEarthChange(e) {
    this.CableproInput.EarthId = e.id;
    let val = e.text;
    this.CableSize['specifyconductor']['earth']['mode'] = '2';
    this.CableSize['specifyconductor']['earth']['size'] = parseFloat(val);
    this.getAllControlsValue();
  }

  onddlPowerUnitChange(value, isTriggered = "false") {
    this.powerunit = value;
    this.currentUnit = value;
    if (this.currentUnit == "0") {
      if (this.voltageSupplyLabel == "rise") {
        this.lblcurrent = 'Output current';
      }
      else
        this.lblcurrent = 'Current';
    }
    else {
      if (this.voltageSupplyLabel == "rise") {
        this.lblcurrent = 'Output power';
      }
      else
        this.lblcurrent = 'Power';
    }


    if (this.currentUnit == "3") {
      this.showEfficency = true;
    }
    else {
      this.showEfficency = false;

    }

    if (this.currentUnit != null && this.currentUnit != "") {

      this.CableSize['powerunit'] = this.currentUnit;
      //console.log('onCurrentChange-getAllControlsValue');
      if (isTriggered != "true")
        this.getAllControlsValue();
    }
  }

  onddlPhaseChange(e) {
    this.CableproInput.PhaseId = e.id;
    if (this.CableproInput.PhaseId.toString() == '108') {
      this.CableSize['supplyvoltage'] = this.onePhase_Voltage;
    } else if (this.CableproInput.PhaseId.toString() == '109') {
      this.CableSize['supplyvoltage'] = this.threePhase_Voltage;
      if (this.CableSize['tableno'] == '17') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img2.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img3.png');
        }, 100);
      } else if (this.CableSize['tableno'] == '18') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img3.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img4.png');
          $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img5.png');
        }, 100);
      }
    } else if (this.CableproInput.PhaseId.toString() == '110') {
      this.CableSize['supplyvoltage'] = this.dc_Voltage;
    } else if (this.CableproInput.PhaseId.toString() == '108') {
      this.CableSize['supplyvoltage'] = this.onePhase_Voltage;
      if (this.CableSize['tableno'] == '17') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img2.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img3.png');
        }, 100);
      } else if (this.CableSize['tableno'] == '18') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img3.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img4.png');
          $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img5.png');
        }, 100);
      }
    } else if (this.CableproInput.PhaseId.toString() == '108') {
      this.CableSize['supplyvoltage'] = this.onePhase_Voltage;
      if (this.CableSize['tableno'] == '17') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img2.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table17_img3.png');
        }, 100);
      } else if (this.CableSize['tableno'] == '18') {
        setTimeout(() => {
          $('#divInstallTbl table tr:first img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img3.png');
          $('#divInstallTbl table tr:nth-child(2) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img4.png');
          $('#divInstallTbl table tr:nth-child(3) img')[0].setAttribute('src', 'assets/cablepro/img/Table18_img5.png');
        }, 100);
      }
    }

    if (this.CableproInput.PhaseId.toString() == '108' || this.CableproInput.PhaseId.toString() == '110') {
      if ($('#neutral-toggle').prop('checked')) {
        $('#neutral-toggle').click();
      }
      this.NeutralDisabled = true;
      $('#neutral-toggle').attr('disabled', 'true');
      $('#Neutral_c').attr('disabled', 'true');

    } else {
      this.NeutralDisabled = false;
      $('#neutral-toggle').removeAttr('disabled');
    }
    this.voltage_txt = this.CableSize['supplyvoltage'];
    this.CableSize['phase'] = e.xmlValue.toString();// (e.target as HTMLSelectElement).options[(e.target as HTMLSelectElement).selectedIndex].getAttribute('xmlvalue').toString();
    this.GetData('phase', this.CableproInput.PhaseId.toString(), this.CableproInput.InsulationId, this.CableproInput.ConductorId, this.CableproInput.CoreId, 0, this.CableproInput.MethodIndex, 0, 0, '', '', this.newCalculationId, 0, 0, this.CableproInput.EarthConductorId);
  }

  onddlInsulationChange(e) {
    this.CableproInput.InsulationId = parseInt(e.id);
    if ((this.CableproInput.InsulationId == 110 && (this.PrevConductorId == 1 || this.PrevConductorId == 2)) ||
      (this.CableproInput.InsulationId == 111 && (this.PrevConductorId == 1 || this.PrevConductorId == 2)) ||
      (this.CableproInput.InsulationId == 112 && (this.PrevConductorId == 1 || this.PrevConductorId == 2)) ||
      (this.CableproInput.InsulationId == 113 && (this.PrevConductorId == 1 || this.PrevConductorId == 2)) ||
      (this.CableproInput.InsulationId == 114 && (this.PrevConductorId == 1 || this.PrevConductorId == 2)) ||
      (this.CableproInput.InsulationId == 115 && (this.PrevConductorId == 1 || this.PrevConductorId == 2))) {
      this.PrevConductorId = 0;
    }

    this.UserWizard = false;
    this.CableSize['isderatingwiz'] = "0";
    // $('#checkboxUseWizard').removeAttr('checked');
    this.CableSize['insulation'] = e.xmlValue.toString();//(e.target as HTMLSelectElement).options[(e.target as HTMLSelectElement).selectedIndex].getAttribute('xmlvalue').toString();
    this.GetData('insulation', e.id, 0, 0, 0, this.CableproInput.PhaseId, this.CableproInput.MethodIndex, 0, 0, '', '', this.newCalculationId, this.PrevConductorId, this.PrevCoreId, this.PrevEarthConductorId);
  }

  onddlConductorChange(value) {
    this.CableproInput.ConductorId = value;
    let obj = this.conductorData.find(m => m.id == this.CableproInput.ConductorId);
    if (obj) {
      this.PrevConductorId = obj.xmlValue;
      this.CableSize['conductor'] = obj.xmlValue.toString();// (e.target as HTMLSelectElement).options[(e.target as HTMLSelectElement).selectedIndex].getAttribute('xmlvalue').toString();
      this.GetData('conductor', value, this.CableproInput.InsulationId, 0, 0, this.CableproInput.PhaseId, this.CableproInput.MethodIndex, 0, 0, '', '', this.newCalculationId, 0, this.PrevCoreId, this.CableproInput.EarthConductorId);
    }
  }

  onddlCoreChange(e) {
    this.CableproInput.CoreId = parseInt(e.id);
    this.PrevCoreId = e.xmlValue;
    let bunchingCore: string = e.xmlValue.toString();
    this.CableSize['core'] = bunchingCore;
    if (bunchingCore == "0") {
      this.drBunchingCore = 1;
    }
    else
      this.drBunchingCore = 2;

    if (this.drInstallType == 1) {
      this.table23model.Row = 1;
      this.table23model.Cables = 1;
      this.table23model.Installation = 1;
      this.table23model.CableType = this.drBunchingCore;
      this.table23model.drf = this.drBunchingCore == 1 ? 0.95 : 0.97;
      this.OnChangeCore(null);
      this.GetTable23Dr(null);
    }
    else {
      if (this.table25model.NoOfCircuits > 1) {
        this.table25model.CableType = this.drBunchingCore;
        this.setTable25Dr();
      }
      if (!this.table28model.UseStandard && this.table28model.Buried == 2)
        this.GetTable28Dr(null);
    }
    this.UserWizard = false;
    this.CableSize['isderatingwiz'] = "0";
    // $('#checkboxUseWizard').removeAttr('checked');
    this.GetData('core', e.id.toString(), this.CableproInput.InsulationId, this.CableproInput.ConductorId, 0, this.CableproInput.PhaseId, this.CableproInput.MethodIndex, 0, 0, '', '', this.newCalculationId, 0, 0, this.CableproInput.EarthConductorId);
  }

  onddlWindChange(e) {
    this.CableproInput.WindSpeedId = parseInt(e.id);
    this.CableSize['installtablewind']['wind'] = e.xmlValue.toString();
    this.getAllControlsValue();
  }

  onddldrTable22ArrangementChange(e) {
    this.table22model.Arrangement = parseInt(e.value);

    this.drTable22CircuitValues = [
      { "name": 1, "value": 1 },
      { "name": 2, "value": 2 },
      { "name": 3, "value": 3 },
      { "name": 4, "value": 4 },
      { "name": 5, "value": 5 },
      { "name": 6, "value": 6 },
      { "name": 7, "value": 7 },
      { "name": 8, "value": 8 },
      { "name": 9, "value": 9 },
      { "name": 12, "value": 12 },
      { "name": 16, "value": 16 },
      { "name": 20, "value": 20 }];

    this.GetTable22Dr(null);
  }

  onddldrTable22NoOfCircuitsChange(e) {
    this.table22model.NoOfCircuits = parseInt(e.value);
    if (this.table22model.NoOfCircuits == 1) {
      this.table22model.drf = 1;
      this.drTable22output = undefined;
      return false;
    }
    this.GetTable22Dr(null);
  }

  onddldrTable23RowChange(e) {
    this.table23model.Row = e.value;
    setTimeout(() => {
      this.GetTable23Dr(null);
    }, 800);
  }

  onddldrTable23CableChange(e) {
    this.table23model.Cables = parseInt(e.value);
    setTimeout(() => {
      this.GetTable23Dr(null);
    }, 800);
  }

  onddldrTable25NoOfCicruitsChange(e) {
    this.table25model.NoOfCircuits = parseInt(e.value);
    this.GetTable25Dr();
    this.setTable25Values(this.table25model.Arrangement);
  }

  onddldrTable25ArrangementChange(e) {
    this.table25model.Arrangement = parseInt(e.value);
    this.setTable25Values(e.value);
  }

  onddlEarthFaultTimeChange(e) {
    this.earthfaulttime = parseInt(e.value);
    this.CableSize['protection']['earthfaulttime'] = e.value.toString();
    this.getAllControlsValue();
  }

  getCurveLabel(family: string): string {
    let selectListFive = 'Curve class: ';
    if (family) {
      var arr = family.split(' ')[1];
      if (arr != null && arr != "" && (arr == "MCCB" || arr == "ACB")) {
        selectListFive = "Trip unit: ";
      }
      else if (arr != null && arr != "" && arr == "Fuse") {
        selectListFive = "Fuse type: ";
      }
    }
    return selectListFive;
  }

  onddlProtectionCurveChange(e) {
    this.protection_curve = parseInt(e.value);

    this.CableSize['protection']['curve'] = e.value.toString();
    this.PrevCurveVal = e.value.toString();

    if (this.CableSize['protection']['curve'] == '0') {
      // if (isTriggered != 'false')
      $('input[caption="Trip Multiplier"]').val('4');
      let trip = $('input[caption="Trip Multiplier"]').val().toString();
      let rat: any = $('#select_MCB option:selected')[0].innerText.split(" ")[1];
      if (!isNaN(rat) && rat.toString().indexOf('.') != -1) {
        rat = parseFloat(rat);
      } else {
        rat = parseInt(rat);
      }
      let count = parseInt(trip) * rat;
      $('input').filter("[caption='Trip current']").val(count);
      this.CableSize['protection']['tripcurrent'] = count;
      this.CableSize['protection']['tripmultiplier'] = trip;
    } else if (this.CableSize['protection']['curve'] == '1') {

      // if (isTriggered != 'false')
      $('input[caption="Trip Multiplier"]').val('7.5');
      let trip = $('input[caption="Trip Multiplier"]').val().toString();
      let rat: any = $('#select_MCB option:selected')[0].innerText.split(" ")[1];
      if (!isNaN(rat) && rat.toString().indexOf('.') != -1) {
        rat = parseFloat(rat);
      } else {
        rat = parseInt(rat);
      }
      let count = parseFloat(trip) * rat;
      $('input').filter("[caption='Trip current']").val(count);
      this.CableSize['protection']['tripcurrent'] = count;
      this.CableSize['protection']['tripmultiplier'] = trip;
    } else {

      // if (isTriggered != 'false')
      $('input[caption="Trip Multiplier"]').val('15');
      let trip = $('input[caption="Trip Multiplier"]').val().toString();
      let rat: any = $('#select_MCB option:selected')[0].innerText.split(" ")[1];
      if (!isNaN(rat) && rat.toString().indexOf('.') != -1) {
        rat = parseFloat(rat);
      } else {
        rat = parseInt(rat);
      }
      let count = parseInt(trip) * rat;
      $('input').filter("[caption='Trip current']").val(count);
      this.CableSize['protection']['tripcurrent'] = count;
      this.CableSize['protection']['tripmultiplier'] = trip;
    }
    this.getAllControlsValue();
  }

  select2Dropdown() {
    if ($('.c-select').length) {
      let $singleSelect = $('.c-select'),
        $singleSelectHasSearch = $('.c-select.has-search'),
        $multipleSelect = $('.c-select.c-select--multiple'),
        $disabledSelect = $('.c-select.is-disabled');

      $singleSelect.select2({
        width: '100%',
        minimumResultsForSearch: Infinity // disable search
      });

      // multiple select
      $multipleSelect.select2({
        width: '100%',
        multiple: true
      });

      // disabled select
      $disabledSelect.select2({
        width: '100%',
        disabled: true
      });
    }
  }
  private inputSubject = new Subject<any>();
  GetTable271DrInputChange(e: any, checkdecimalplaces: boolean = false) {
    this.inputSubject.next({ e: e, checkdecimalplaces: checkdecimalplaces });
  }

  calltable29(Buried: number) {
    this.drfBSDService.getTable29(this.table29model.Resitivity, Buried, true).subscribe(result => {
      this.table29model.drf = parseFloat(parseFloat(result["Correction Factor:"]).toFixed(2));
      this.table29output = result;
    });
  }

  public deleteVisible: Boolean = false;
  public defaultLogoImagePath = '/assets/common/images/Nologo.png';
  removeLogo(): void {
    // this.CalculationReportInput.companyLogo_LogoUrl = '';
    this.CalculationReportInput.companyLogo_FileName = '';
    this.companyLogo_FileName = undefined;
    this.company_Logo_LogoPresignedUrl = this.defaultLogoImagePath;
    this.deleteVisible = false;
  }

  openfileControl(): void {
    $('#fileupload').click();
  }
  private baseUrl: string;
  public btnuploadDisabled: boolean = false;
  public company_Logo_LogoPresignedUrl: string = 'assets/common/images/Nologo.png';
  SetLogoImage(event: any) {
    let url_ = this.baseUrl + '/api/services/app/Setting/CreateFile';
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      if (!this.validateFile(file.name)) {
        return false;
      }
      else {
        let resizedFile: File;
        var utils = new ImageUtils();
        utils.resizeImage(file, 600, 600).then(blob => {
          //You can upload the resized image: doUpload(blob)
          resizedFile = utils.blobToFile(blob, file.name);
          let formData: FormData = new FormData();
          formData.append('file', resizedFile, file.name);
          // formData.append('file', file, file.name);
          let headers = new Headers();
          headers.append('Content-Type', 'multipart/form-data');
          headers.append('Accept', 'application/json');
          this.btnuploadDisabled = true;
          this.getUploadResponse(url_, formData).subscribe(result => {
            this.settingOutput = result;
            if (this.settingOutput !== undefined) {
              // this.CalculationReportInput.companyLogo_LogoUrl = this.settingOutput['result'].companyLogo_LogoUrl;
              this.company_Logo_LogoPresignedUrl = this.settingOutput['result'].company_Logo_LogoPresignedUrl;
              this.companyLogo_FileName = this.settingOutput['result'].companyLogo_LogoUrl;
              this.deleteVisible = true;
              this.btnuploadDisabled = false;
            }
          }, (error) => {
            this.btnuploadDisabled = false;
            this.isInvalidFileType = true;
          });
        }, err => {
          console.error("Photo error", err);
        });
      }
    }
  }

  public isInvalidFileType: boolean = false;
  validateFile(name: string): boolean {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'gif' || ext.toLowerCase() == 'jpeg' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'png'
      || ext.toLowerCase() == 'tiff' || ext.toLowerCase() == 'ico' || ext.toLowerCase() == 'bmp') {
      this.isInvalidFileType = false;
      return true;
    }
    else {
      this.isInvalidFileType = true;
      return false;
    }
  }

  getUploadResponse(url_: string, formData: FormData): Observable<SettingOutput> {
    return this.http.post<SettingOutput>(url_, formData);
  }

  onProtectiveUnknownChange(isFromCode: boolean = false) {
    this.Isfromunknownchk = false;
    this.CableSize['protection']['IsUnknown'] = this.protectiveUnknown;
    //this.getAllControlsValue();
    if (this.protectiveUnknown == true) {
      if (isFromCode == false) {
        this.getAllControlsValue();
      }
    }
    else {
      if (!isFromCode) {
        this.Isfromunknownchk = true;
        this.showProtectiveDeviceUI('1');
      }
    }
  }

  public index: number = 0;
  public IsFormvalid: boolean = true;
  public deviceNumber: string = 'Device 01';
  public ddlmodel: number;
  public btnAddDeviceDisabled: boolean = false;
  public btnAddDeviceRequestCounter: number = 0;
  public ListLoadStorage: ProtectiveItem[] = [];
  public ProtectiveLoadStorage: ProtectiveItem = new ProtectiveItem();
  public protectiveXmlInputList: ProtectiveXmlInput[] = [];
  public chkexportlimited: boolean = false;
  public protectiveXmlInput: ProtectiveXmlInput = new ProtectiveXmlInput();
  showProtectiveDeviceUI(fromclient = "") {
    this.FilterBreaking = 5;
    this.IsFormvalid = true;
    this.deviceNumber = "";

    if (fromclient == "1") {
      this.modifyindex = -1;
      //this.ChkIncomer=false;
      this.btnAddDeviceDisabled = false;
      this.btnAddDeviceRequestCounter = 0;
      this.deviceNumber = "Device 01";//this.deviceNoInString(this.deviceno + 1);

    }
    if (this.modifyindex == -1) {
      this.deviceNumber = "Device 01";//this.deviceNoInString(this.deviceno + 1);

    }


    if (this.ListLoadStorage && this.ListLoadStorage.length > 0) {
      this.deviceNumber = this.ListLoadStorage[this.index].devicenostr;
    }

    $('#protectiveSelector').modal('show');
    this.btnAddDeviceRequestCounter = 0;
  }

  CloseReport() {
    if (this.Isfromunknownchk) {
      this.protectiveUnknown = true;
      this.CableSize['protection']['IsUnknown'] = this.protectiveUnknown;
      this.getAllControlsValue();
      this.Isfromunknownchk = false;
    }
    $('#protectiveSelector').modal('hide');
  }

  searchTerm: string = '';
  showDropdown: boolean = false;
  filteredOptions: any[] = [];
  searchSubject = new Subject<string>();
  loadingSearch = false;
  lazyLoading = false;
  totalDeviceCount: number = 0;
  startAt: number = 0;
  pageSize: number = 20;
  public isSelectorChange: boolean = false;

  searchItems(term: string, startAt: number): Observable<ProtectiveDeviceData[]> {
    if (!term) {
      this.resetSearch();
      return of([]);
    }
    return this._settingService.SearchProtectiveDevices(term, startAt, false)
  }

  // Method to load more data when the user scrolls to the bottom
  onScroll(event: any) {
    if (this.filteredOptions.length >= this.totalDeviceCount || this.loading || this.lazyLoading) {
      event.stopPropagation();
      return;
    }

    this.lazyLoading = true;
    this.startAt += this.pageSize;

    this.searchItems(this.searchTerm, this.startAt).pipe(
    ).subscribe(result => {
      this.filteredOptions = [...this.filteredOptions, ...result];
      this.lazyLoading = false;
    });
  }

  // Check if the user has scrolled near the bottom of the dropdown
  checkScroll(event: any) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) { // 10px buffer to ensure smooth loading
      this.onScroll(event);
    }
  }

  onItemSelect(selected: ProtectiveDeviceData) {
    this.showDropdown = false;
    // this.totalDeviceCount = 0;
    // this.searchTerm = '';
    // this.filteredOptions = [];

    if (this.loadProtectiveXmlInput == null || this.loadProtectiveXmlInput == undefined)
      this.loadProtectiveXmlInput = new ProtectiveXmlInput();
    this.loadProtectiveXmlInput.manufacturer_id = selected.manufacturer_id;
    this.loadProtectiveXmlInput.range_id = selected.family_id;
    this.loadProtectiveXmlInput.tripunit = selected.curve_class;
    this.loadProtectiveXmlInput.model = selected.model_id;
    this.loadProtectiveXmlInput.rating = selected.rating;

    this.defaultManId = selected.manufacturer_id;
    this.defaultFamilyId = selected.family_id.toString();
    this.defaultModelId = selected.model_id;
    this.defaultRatingId = selected.rating;
    this.defaultCurveId = selected.curve_class;
    this.defaultModelName = selected.model;

    this.isSelectorChange = true;
    this.btnAddDeviceRequestCounter += 1;
    this.GetManufacturer(() => {
      let selectedObj = this.manufacturerOutput.find(m => m.id == selected.manufacturer_id);
      if (!selectedObj)
        selectedObj = this.manufacturerOutput[0];
      if (selectedObj.name != "Generic") {
        var name = selectedObj.name + "logo";
        this.protectiveImgSrc2 = 'assets/cablepro/logo/' + name + '.svg';
      }
      else {
        this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';
      }
    });
  }

  onBlur() {
    this.showDropdown = false;
    if (!this.searchTerm.trim()) {
      this.resetSearch();
    }
  }

  onFocus() {
    if (this.filteredOptions.length > 0) {
      this.showDropdown = true;
    }
  }

  // Reset search and pagination state
  resetSearch() {
    this.showDropdown = false;
    this.totalDeviceCount = 0;
    this.startAt = 0;
    this.filteredOptions = [];
  }

  public breakingOutput: BreakingOutput[] = [];
  public polesTableOutput: MCBOutput[] = [];
  public manufacturerOutput: ManufacturerOutput[] = [];
  public filesOutput: ManufacturerOutput[] = [];
  public familyOutput: ManufacturerOutput[] = [];
  public selectedFamily: ManufacturerOutput = new ManufacturerOutput();
  public modelOutput: ManufacturerOutput[] = [];
  public deviceOutput: DeviceOutput = new DeviceOutput();
  public mcbOutput: MCBOutput[] = [];
  public curveOutput: MCBOutput[] = [];
  public ratingPlugList: MCBOutput[] = [];

  // protective device changes
  GetManufacturer(callback: any = undefined) {

    this._settingService.getManufacturer(false).subscribe(result => {

      if (result !== undefined && result !== null) {

        this.manufacturerOutput = result[0].items;
        if (this.manufacturerOutput.length > 0) {
          var manId = 104;
          // if (this.canHaveHv) {
          //   manId = this.manufacturerOutput[0].id;
          //   this.defaultManId = manId;
          //   let selectedObj = this.manufacturerOutput.find(m => m.id == manId);
          //   var name = selectedObj.name + "logo";
          //   this.protectiveImgSrc2 = 'assets/cablepro/logo/' + name + '.svg';
          // }

          if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.manufacturer_id > 0) {

            manId = this.loadProtectiveXmlInput.manufacturer_id;
            this.defaultManId = manId;


          }

          if (callback)
            callback();
          this.GetFamilyGroupByManufacturerId(manId, true);

        }

      }
    }, error => {
    });
  }
  GetFamilyGroupByManufacturerId(manufacturerId: number, pageload: boolean = false) {

    this._settingService.getFamilyByManufacturer(manufacturerId, false).subscribe(result => {

      if (result !== undefined && result !== null) {
        this.selectedFamily = result[0].items[0];

        this.familyOutput = result[0].items;
        this.model = result[0].items[0].familyid;

        this.defaultFamilyId = this.model;
        if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.range_id != null && this.loadProtectiveXmlInput.range_id != "") {
          this.model = this.loadProtectiveXmlInput.range_id;
          this.defaultFamilyId = this.model;
        }

        if (this.model != null && this.model != "") {
          var arr = this.model.split(' ')[1];
          if (arr != null && arr != "" && (arr == "MCCB" || arr == "ACB")) {
            this.selectListFive = "Trip unit";
            // this.curveClassOrTripUnit = "Trip unit";
          }
          else if (arr != null && arr != "" && arr == "Fuse") {
            this.selectListFive = "Fuse type";
            // this.curveClassOrTripUnit = "Fuse type";
          }
          else {
            this.selectListFive = "Curve class";
            // this.curveClassOrTripUnit = "Curve class";
          }
        }
        this.GetModelGroupByManufacturerIdnew(manufacturerId, this.model, this.FilterBreaking);



      }

    },
      err => {
        this.btnAddDeviceRequestCounter = 0;
      });
  }
  GetModelGroupByManufacturerIdnew(manufacturerId: number, familyId: string, filterBreaking: number) {

    if (this.chkexportlimited == true) {

    }
    else {
      filterBreaking = 0;
    }

    this.deviceOutput = new DeviceOutput();
    this._settingService.getModelByManufacturernew(manufacturerId, familyId, filterBreaking, false).subscribe(result => {
      if (result !== undefined && result.one !== null) {
        this.modelOutput = result.one;


      }
      if (result !== undefined && result.two !== null) {
        this.mcbOutput = result.two;

      }
      else {
        this.mcbOutput = [];
      }
      if (this.selectedModalId != null && this.selectedModalId != 0) {
        let selectedModel = this.modelOutput.find(m => m.id == this.selectedModalId);
        // this.txtmodal = (selectedModel != null ? selectedModel.name : '');
      }
      if (result !== undefined && result.three !== null) {
        this.curveOutput = result.three;

      }
      else {
        this.curveOutput = [];
      }
      if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.tripunit != null && this.loadProtectiveXmlInput.tripunit != "" && this.loadProtectiveXmlInput.tripunit != undefined) {
        this.defaultCurveId = this.loadProtectiveXmlInput.tripunit;
      }
      else {
        if (this.curveOutput && this.curveOutput.length > 0)
          this.defaultCurveId = this.curveOutput[0].cc;
      }


      if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.xml != null && this.loadProtectiveXmlInput.xml != "" && this.loadProtectiveXmlInput.xml != undefined) {
        this.xmlData = this.loadProtectiveXmlInput.xml;

      }

      if (this.defaultModelName != undefined && this.defaultModelName != "") {
        let selectedModel = this.modelOutput.find(x => x.name == this.defaultModelName);
        if (selectedModel && selectedModel.id > 0) {
          this.defaultModelId = selectedModel.id;
          this.GetRatingByManufacturerId(manufacturerId, familyId, this.defaultModelId, true);
          return;
        }
      }

      if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.model != null && this.loadProtectiveXmlInput.model != 0 && this.loadProtectiveXmlInput.model != undefined) {
        this.defaultModelId = this.loadProtectiveXmlInput.model;

        this.GetRatingByManufacturerId(manufacturerId, familyId, this.defaultModelId, true);

      } else {

        this.defaultModelId = this.modelOutput[0].id;
        this.GetRatingByManufacturerId(manufacturerId, familyId, this.modelOutput[0].id, true);
      }




    },
      err => {
        this.btnAddDeviceRequestCounter = 0;
      });
  }
  GetRatingByManufacturerId(manufacturerId: number, familyId: string, modelId: number, triggerEvent: boolean) {
    this.mcbOutput = [];

    this._settingService.getRatingByManufacturer(manufacturerId, familyId, modelId).subscribe(result => {
      if (result !== undefined && result !== null) {
        this.mcbOutput = result[0].items;
        if (this.isloadfirsttime) {
          this.defaultRatingId = '100';
        }
        else {
          if (this.mcbOutput && this.mcbOutput.length > 0)
            this.defaultRatingId = (this.mcbOutput[0].ina.toString());
        }

        this.isloadfirsttime = false;
        if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.rating != null && this.loadProtectiveXmlInput.rating != "") {
          this.defaultRatingId = this.loadProtectiveXmlInput.rating;
        }


        if (triggerEvent && this.mcbOutput.length > 0) {
          this.GetCurveByManufacturerId(manufacturerId, familyId, modelId, true, this.defaultRatingId);
        }
      }
    },
      err => {
        this.btnAddDeviceRequestCounter = 0;
      });
  }
  GetCurveByManufacturerId(manufacturerId: number, familyId: string, modelId: number, triggerEvent: boolean, rating: string) {
    this.curveOutput = [];
    this._settingService.getCurveByManufacturer(manufacturerId, familyId, modelId, rating).subscribe(result => {

      this.btnAddDeviceDisabled = false;

      if (result !== undefined && result !== null) {
        this.curveOutput = result[0].items;

        if (this.curveOutput) {
          if (!this.isloadedfirst) {
            if (this.curveOutput && this.curveOutput.length > 0)
              this.defaultCurveId = (this.curveOutput[0].cc.toString());

            if (this.loadProtectiveXmlInput != null && this.loadProtectiveXmlInput.tripunit != null && this.loadProtectiveXmlInput.tripunit != "") {
              this.defaultCurveId = this.loadProtectiveXmlInput.tripunit;
            }
            this.GetBreakingByManufacturerId(manufacturerId, familyId, modelId, rating, this.defaultCurveId);
          }
          else {
            this.isloadedfirst = false;
          }
        }

      }
      setTimeout(() => {
        if (this.btnAddDeviceRequestCounter > 0)
          this.btnAddDeviceRequestCounter -= 1;
      }, 1000);

    },
      err => {
        this.btnAddDeviceDisabled = false;
        this.btnAddDeviceRequestCounter = 0;

      });
  }
  GetPolesTableByManufacturerId(manufacturerId: number, familyId: string, modelId: number, rating: string, curve: string) {
    this.polesTableOutput = [];
    this._settingService.getPolesTableByManufacturer(manufacturerId, familyId, modelId, rating, curve).subscribe(result => {


      if (result !== undefined && result !== null) {
        this.polesTableOutput = result[0].items;


      }
    },
      err => {

      });

  }
  GetBreakingByManufacturerId(manufacturerId: number, familyId: string, modelId: number, rating: string, curve: string) {

    this._settingService.getBreakingByManufacturerId(manufacturerId, familyId, modelId, rating, curve).subscribe(result => {
      if (result !== undefined && result !== null) {
        this.breakingOutput = result[0].items;


      }
    },
      err => {

      });
  }

  onManufacturerChange(val) {
    if (val != undefined) {
      this.btnAddDeviceDisabled = true;
      this.isSelectorChange = true;
      this.btnAddDeviceRequestCounter += 1;
      this.loadProtectiveXmlInput = new ProtectiveXmlInput();
      let selectedObj = this.manufacturerOutput.find(m => m.id == parseInt(val));
      this.GetFamilyGroupByManufacturerId(parseInt(val));
      if (selectedObj.name != "Generic") {
        this.IsGeneric = true;
        var name = selectedObj.name + "logo";
        this.protectiveImgSrc2 = 'assets/cablepro/logo/' + name + '.svg';
        // $('#divlogo img').attr('src', '/assets/cablepro/logo/' + name + '.svg');
      }
      else {
        this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';
        // $('#divlogo img').attr('src', '/assets/cablepro/logo/a.png');
        this.IsGeneric = false;

      }
      this.defaultManId = val;
    }
  }

  onFamilyChange(val) {
    if (val !== undefined) {
      this.btnAddDeviceDisabled = true;
      this.isSelectorChange = true;
      this.btnAddDeviceRequestCounter += 1;
      this.loadProtectiveXmlInput = new ProtectiveXmlInput();
      var familyId = val.toString();
      if (familyId != null && familyId != "") {
        var arr = familyId.split(' ')[1];
        if (arr != null && arr != "" && (arr == "MCCB" || arr == "ACB")) {
          this.selectListFive = "Trip unit";
          // this.curveClassOrTripUnit = "Trip unit";

        }
        else if (arr != null && arr != "" && arr == "Fuse") {
          this.selectListFive = "Fuse type";
          // this.curveClassOrTripUnit = "Fuse type";

        }
        else {
          this.selectListFive = "Curve class";
          // this.curveClassOrTripUnit = "Curve class";

        }
      }
      this.defaultFamilyId = val;
      this.model = val;
      this.gfamilyId = familyId;
      this.gmanufacturerId = this.defaultManId;
      this.changed();


    }
  }

  onModelChange(val) {
    if (val !== undefined) {
      this.btnAddDeviceDisabled = true;
      this.isSelectorChange = true;
      this.btnAddDeviceRequestCounter += 1;
      this.loadProtectiveXmlInput = new ProtectiveXmlInput();
      var a = this.defaultManId;//$('#ddlManufacturer option:selected').val();
      var manufacturerId = parseInt(a.toString());

      this.ddlmodel = val;//parseInt($('#ddlModel option:selected').val().toString());

      this.defaultModelId = val;
      this.gfamilyId = this.defaultFamilyId;
      this.gmanufacturerId = manufacturerId;
      this.gmodelId = this.defaultModelId;
      this.ddlchanged();

    }
  }
  public ddlmodelChanged = new Subject<DeviceOutput>();
  public protectiveModelChanged = new Subject<DeviceOutput>();
  changed() {
    this.protectiveModelChanged.next();
  }
  ddlchanged() {
    this.ddlmodelChanged.next();
  }
  onRatingChange(val) {
    if (val !== undefined) {
      this.btnAddDeviceDisabled = true;
      this.isSelectorChange = true;
      this.btnAddDeviceRequestCounter += 1;
      this.loadProtectiveXmlInput = new ProtectiveXmlInput();
      this.defaultRatingId = val;
      this.GetCurveByManufacturerId(this.defaultManId, this.defaultFamilyId.toString(), this.defaultModelId, true, val);
    }
  }

  onCurveChange(val) {
    if (val !== undefined) {
      this.defaultCurveId = val;
      this.isSelectorChange = true;
    }
  }

  public deviceList: string[] = [];
  deviceNoInString(number: number) {
    // if (number <= 9) {
    //     return "Device 0" + number;

    // }
    // else {
    //     return "Device " + number;

    // }
    var indexCoordinationCurve = this.deviceList[number - 1];
    if (indexCoordinationCurve == undefined) {
      if (number <= 9) {
        return "Device 0" + number;

      }
      else {
        return "Device " + number;

      }
    }

    return indexCoordinationCurve.replace(/\\'/g, "'").replace(/'/g, "\\'");

  }

  objectKeys(obj: any): string[] {
    return obj && typeof obj === 'object' ? Object.keys(obj) : [];
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  GetIECProtectiveDataByCalculationId(newCalculationId: any, callback?: any) {
    this._settingService.getIECProtectiveDataByCalculationId(newCalculationId).subscribe(result => {

      this.protectiveXmlInputList = [];
      this.ListLoadStorage = [];

      if (result !== undefined && result.currentrow) {
        this.index = result.currentrow;
      }

      if (result !== undefined && result.items) {
        for (var i = 0; i < result.items.length; i++) {

          this.ProtectiveLoadStorage = new ProtectiveItem();
          this.ProtectiveLoadStorage.model = result.items[i].model
          if (i == 0)
            this.model = result.items[i].model
          this.ProtectiveLoadStorage.family = result.items[i].family
          this.ProtectiveLoadStorage.protectiondevicetype = result.items[i].protectiondevicetype
          this.ProtectiveLoadStorage.rating = result.items[i].rating
          this.ProtectiveLoadStorage.manufacturer = result.items[i].manufacturer
          this.ProtectiveLoadStorage.tripunit = result.items[i].tripunit
          this.ProtectiveLoadStorage.deviceno = result.items[i].deviceno
          this.ProtectiveLoadStorage.devicetype = result.items[i].family.split(' ')[1].toString();
          if (result.items[i].devicenostr != null && result.items[i].devicenostr != "")
            this.ProtectiveLoadStorage.devicenostr = result.items[i].devicenostr.trim()
          this.ProtectiveLoadStorage.desc = result.items[i].desc;
          this.ProtectiveLoadStorage.nodeid = result.items[i].nodeid;
          this.ProtectiveLoadStorage.isVisible = result.items[i].isVisible;
          this.ListLoadStorage.push(this.ProtectiveLoadStorage);
          this.fillDeviceList();
          this.protectiveXmlInput = new ProtectiveXmlInput();
          this.protectiveXmlInput.xml = result.items[i].xml;// this.xmlData // Changed to get xml from database
          this.protectiveXmlInput.model = parseInt(result.items[i].model);
          this.protectiveXmlInput.manufacturer_id = parseInt(result.items[i].manufacturer);
          this.protectiveXmlInput.range_id = result.items[i].family;
          this.protectiveXmlInput.devicenostr = result.items[i].devicenostr;
          this.protectiveXmlInput.tripunit = result.items[i].tripunit;;
          this.protectiveXmlInput.rating = result.items[i].rating;
          this.protectiveXmlInput.protectiondevicetype = result.items[i].protectiondevicetype;
          this.protectiveXmlInput.chartdata = '';
          this.protectiveXmlInput.id = result.items[i].id;
          this.protectiveXmlInput.rownumber = i;
          this.protectiveXmlInput.nodeid = result.items[i].nodeid;
          this.protectiveXmlInput.isVisible = result.items[i].isVisible;

          if (result.items[i].earthingsystem) {
            if (!this.protectionConfigurationModel)
              this.protectionConfigurationModel = new ProtectionConfigurationModel();

            this.protectionConfigurationModel.EarthingSystem = result.items[i].earthingsystem;
            this.protectionConfigurationModel.MaxDisconnectionTime = result.items[i].maxdisconnectiontime;
            this.protectionConfigurationModel.CustomTime = result.items[i].customtime;

            this.protectionConfigurationModel_Pristine = Object.assign({}, this.protectionConfigurationModel);
          }
          this.protectiveXmlInputList.push(this.protectiveXmlInput);
        }
        //this.fillDeviceList();

      }

      if (this.protectiveXmlInputList.length > 0) {
        this.rowClick(this.index, false, false);
      }
      else {
        this.txtrating = undefined;
        this.txtmodal = undefined;
        this.txtfamily = undefined;
        this.txtTripUnit = undefined;
        this.loadProtectiveXmlInput = null;
        this.defaultManId = 104;
        this.protectiveImgSrc = 'assets/cablepro/logo/a.png';
        this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';
        this.protectiveIncomerImgSrc = 'assets/cablepro/logo/a.png';
        this.GetManufacturer();
        // this.showProtectiveDeviceUI()
        // this.hideLoader();
      }
      if (callback) {
        // this.hideLoader();
        callback();
      }
      //this.highLightRow(this.index);
    });
  }

  public ProtectiveLoadDataXml: ProtectiveData = new ProtectiveData();
  public multiplierEIR: number = 0;
  public multiplierEIO: number = 0;
  public multiplierIN: number = 0;
  addDevice(savexml: string = "") {
    if (this.modifyindex >= 0) {
      savexml = "";
    }
    this.Isfromunknownchk = false;

    var modifynameonly = true;
    if (this.isSelectorChange)
      modifynameonly = false;

    this.ProtectiveLoadDataXml = new ProtectiveData();
    if (true) {
      this.showLoader();
      this.btnAddDeviceDisabled = true;
      this.btnAddDeviceRequestCounter += 1;
      var a = this.defaultManId;
      var manufacturerId = parseInt(a.toString());
      var familyId = this.model.toString();
      var modelId = this.defaultModelId;
      var d = this.defaultRatingId;
      var ee = this.defaultCurveId;
      var curve = (ee.toString());
      var res = curve;
      if (curve.indexOf('-') != -1) {
        res = curve.substr(0, curve.lastIndexOf('-'));
        res = this.trimChar(res.trim(), "-");
      }
      this.GetBreakingByManufacturerId(manufacturerId, familyId, modelId, this.defaultRatingId.toString(), res);
      this.GetPolesTableByManufacturerId(manufacturerId, familyId, modelId, this.defaultRatingId.toString(), res);
      this.ProtectiveLoadStorage = new ProtectiveItem();
      this.ProtectiveLoadStorage.model = modelId.toString();
      this.ProtectiveLoadStorage.family = this.model.toString();
      this.ProtectiveLoadStorage.devicetype = this.ProtectiveLoadStorage.family.split(' ')[1].toString();
      this.ProtectiveLoadStorage.rating = this.defaultRatingId.toString();
      this.ProtectiveLoadStorage.manufacturer = a.toString();
      this.ProtectiveLoadStorage.tripunit = ee.toString();
      this.ProtectiveLoadStorage.isVisible = this.ListLoadStorage.length > 0 ? this.ListLoadStorage[this.index].isVisible : true;

      if (this.modifyindex == -1) {
        this.ProtectiveLoadStorage.deviceno = 1;
      }
      //        if (this.deviceno <= 9) {
      //                this.LoadStorage.devicenostr = "Device 0" + this.deviceno;
      this.ProtectiveLoadStorage.devicenostr = this.deviceNumber.trim();

      //      }
      //    else {
      //      this.LoadStorage.devicenostr = "Device " + this.deviceno;

      //}
      let selectedMan = this.manufacturerOutput.find(m => m.id == this.defaultManId);
      let selectedFamily = this.familyOutput.find(m => m.familyid == this.defaultFamilyId);
      let selectedModel = this.modelOutput.find(m => m.id == this.defaultModelId);
      let selectedRating = this.mcbOutput.find(m => m.ina == this.defaultRatingId);
      this.txtrating = (selectedRating != null ? selectedRating.ina : '');
      this.txtmodal = (selectedModel != null ? selectedModel.name : '');
      this.txtfamily = (selectedFamily != null ? selectedFamily.name : '');
      this.ProtectiveLoadStorage.desc = ((selectedMan != null ? selectedMan.name.trim() : '') + ", "
        + (selectedFamily != null ? selectedFamily.name.trim() : '') + ", " +
        (selectedModel != null ? selectedModel.name.split('-')[0].trim() : '') + ", " + (selectedRating != null ? selectedRating.ina.trim() : '') + " A"
        + ", " + res.trim()).trim();
      if (savexml == "1") {

        this.index = 0;
        if (this.index >= 0 && this.ListLoadStorage.length > 0) {
          this.ListLoadStorage[this.index].model = this.ProtectiveLoadStorage.model;
          this.ListLoadStorage[this.index].family = this.ProtectiveLoadStorage.family;
          this.ListLoadStorage[this.index].devicetype = this.ProtectiveLoadStorage.devicetype;
          this.ListLoadStorage[this.index].deviceno = this.ProtectiveLoadStorage.deviceno;
          this.ListLoadStorage[this.index].rating = this.ProtectiveLoadStorage.rating;
          this.ListLoadStorage[this.index].manufacturer = this.ProtectiveLoadStorage.manufacturer;
          this.ListLoadStorage[this.index].tripunit = this.ProtectiveLoadStorage.tripunit;
          this.ListLoadStorage[this.index].desc = this.ProtectiveLoadStorage.desc;
          this.ListLoadStorage[this.index].devicenostr = this.ProtectiveLoadStorage.devicenostr;

        }
        else {
          this.ListLoadStorage.push(this.ProtectiveLoadStorage);
          this.index = this.ListLoadStorage.length - 1;

        }
        this.fillDeviceList();
      }
      else {

        if (this.modifyindex == -1) {
          manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
          familyId = this.ListLoadStorage[this.index].family;

          modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
          d = this.ListLoadStorage[this.index].rating.toString();
          ee = this.ListLoadStorage[this.index].tripunit.toString();
          curve = (ee.toString());
          this.ProtectiveLoadStorage.desc = this.ListLoadStorage[this.index].desc.toString()
        }
        else {

          this.ListLoadStorage[this.index].model = modelId.toString();
          this.ListLoadStorage[this.index].family = this.model.toString();
          this.ListLoadStorage[this.index].devicetype = this.ProtectiveLoadStorage.family.split(' ')[1].toString();
          this.ListLoadStorage[this.index].rating = d.toString();
          this.ListLoadStorage[this.index].manufacturer = a.toString();
          this.ListLoadStorage[this.index].tripunit = ee.toString();
          this.ListLoadStorage[this.index].desc = this.ProtectiveLoadStorage.desc;
          this.ListLoadStorage[this.index].devicenostr = this.deviceNumber.trim();

        }
        this.fillDeviceList();
      }
      this.CableSize['devicename'] = this.deviceNumber;
      let selectednode = JSON.parse(sessionStorage.getItem("currentnode"));

      var res = curve;
      if (curve.indexOf('-') != -1) {
        res = curve.substr(0, curve.lastIndexOf('-'));
        res = this.trimChar(res.trim(), "-");
      }

      this.multiplierEIR = 1;
      this.multiplierIN = 1;
      this.multiplierEIO = 1;
      $('#mcbacb-device').text(this.ProtectiveLoadStorage.desc);
      var arr = this.model.split(' ')[1];
      $(".clsreset").show();
      $(".clstripunit").show();
      $(".clscurveclass").show();
      $(".clsfustype").show();
      $("#devicesettingli").show();
      $("#normalDetail").show();
      $("#hvRelayDetail").hide();
      if (this.modifyindex >= 0) {
        // savexml="1";
      }
      if (arr != null && arr != "" && (arr == "MCB" || arr == "Fuse")) {
        $("#devicesettingli").hide();
        //document.getElementById('tab2Open').click();
        if (arr == "MCB") {
          $(".clsfustype").hide();
        }
        if (arr == "Fuse") {
          $(".clscurveclass").hide();

        }
        $(".clstripunit").hide();
        $(".clsreset").hide();
        $("#divmcbacbonly").show();
        $("#divelectronic").hide();
        $("#divmagneticonly").hide();
        $("#divtmagneticonly").hide();
        if (this.modifyindex >= 0) {
          this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
            , '', '', '', ''
            , '', ''
            , '', ''
            , '', ''
            , '', 1, '', '', false, false);
        }
        else {
          this.ProtectiveLoadControls(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
            , '', '', '', ''
            , '', ''
            , '', ''
            , '', ''
            , '', '', savexml, false, false, modifynameonly);
        }
      }
      else {

        $(".clsfustype").hide();
        $(".clscurveclass").hide();

        $("#divmcbacbonly").hide();

        if (this.modifyindex >= 0) {
          this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
            , '', '', '', ''
            , '', ''
            , '', ''
            , '', ''
            , '', 1, '', '', false, false);
        }
        else {
          this.ProtectiveLoadControls(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
            , '', '', '', ''
            , '', ''
            , '', ''
            , '', ''
            , '', '', savexml, false, false, modifynameonly);
        }

      }

      this.protectiveUnknown = false;
      this.onProtectiveUnknownChange(true);
    }

    this.isSelectorChange = false;
    //        this.saveOtherDetail();

  }

  trimChar(string, charToRemove) {
    while (string.charAt(0) == charToRemove) {
      string = string.substring(1);
    }

    while (string.charAt(string.length - 1) == charToRemove) {
      string = string.substring(0, string.length - 1);
    }

    return string;
  }

  fillDeviceList() {
    var str = ""
    this.deviceList = [];

    for (var i = 0; i < this.ListLoadStorage.length; i++) {
      // if (this.ListLoadStorage[i].deviceno <= 9) {
      //     str = "Device 0" + this.ListLoadStorage[i].deviceno;

      // }
      // if (this.ListLoadStorage[i].deviceno > 9) {
      //     str = "Device " + this.ListLoadStorage[i].deviceno;

      // }
      this.deviceList.push(this.ListLoadStorage[i].devicenostr);


    }
  }

  protectionConfigurationModel: ProtectionConfigurationModel = new ProtectionConfigurationModel();
  protectionConfigurationModel_Pristine: ProtectionConfigurationModel = new ProtectionConfigurationModel();
  ListProtectiveInputCurrentObj: ListProtectiveInput;
  public deviceType: string = "1";
  public rp: string = "";

  ProtectiveLoadControls(manufacturerId: number, familyId: string, modelId: number, rating: string, curve: string
    , tmir: string, tmim: string, mim: string, currenttolerance: string, timetolerance: string, timetobreak: string
    , eratingplug: string, eltbool: string, estbool: string, eintbool: string
    , eio: string, eir: string
    , etr: string, eisd: string
    , etsd: string, ei2tcurve: string
    , eli: string, idmtl: string, savexml: string = "", generatexmlonly: boolean = false
    , callfromcoordination: boolean = false, modifyonlydevice: boolean = false, isFromTreeNode: boolean = false
    , isIncomerDevice: boolean = false, callNetworkCalcDLL: boolean = true
  ) {
    var objinput = new ListProtectiveInput();
    objinput.calculationid = this.newCalculationId;

    // objinput.nodeid = this.activeNode.objectcode;
    objinput.tmir = tmir;
    objinput.tmim = tmim;
    objinput.mim = mim;
    objinput.currenttolerance = currenttolerance;
    objinput.timetolerance = timetolerance;
    objinput.timetobreak = timetobreak;
    objinput.eltboolproperty = eltbool;
    objinput.estboolproperty = estbool;
    objinput.eintboolproperty = eintbool;
    objinput.eio = eio;
    objinput.eir = eir;
    objinput.etr = etr;
    objinput.eisd = eisd;

    //  objinput.trippingcurrent = $("#current").val().toString()//s.trippingcurrent;
    objinput.eratingplug = eratingplug;
    objinput.etsd = etsd;
    objinput.ei2tcurve = ei2tcurve;
    objinput.eli = eli;
    objinput.idmtl = idmtl;
    objinput.rownumber = this.index;
    let trippingtime;
    if (!this.protectionConfigurationModel.MaxDisconnectionTime)
      trippingtime = "0.4";
    else {
      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;
    }
    objinput.trippingtime = trippingtime;
    objinput.isincomerdevice = isIncomerDevice;
    objinput.earthingSystem = this.protectionConfigurationModel.EarthingSystem;
    objinput.maxDisconnectionTime = this.protectionConfigurationModel.MaxDisconnectionTime;
    objinput.customTime = this.protectionConfigurationModel.CustomTime;
    if (savexml == "1") {

      this.protectiveXmlInput = new ProtectiveXmlInput();
      this.protectiveXmlInput.xml = this.xmlData;
      this.protectiveXmlInput.model = modelId;
      this.protectiveXmlInput.manufacturer_id = manufacturerId;
      this.protectiveXmlInput.range_id = familyId;
      this.protectiveXmlInput.tripunit = curve;
      this.protectiveXmlInput.rating = rating;
      this.protectiveXmlInput.chartdata = '';
      if (this.protectiveXmlInputList.length > this.index) {
        this.protectiveXmlInput.id = this.protectiveXmlInputList[this.index].id;
        this.protectiveXmlInput.rownumber = this.protectiveXmlInputList[this.index].rownumber;
      }
      else {
        this.protectiveXmlInput.id = 0;
        this.protectiveXmlInput.rownumber = this.protectiveXmlInputList.length;
      }

      this.protectiveXmlInput.devicenostr = this.deviceNumber.trim();
      this.protectiveXmlInput.isVisible = this.ListLoadStorage.length > 0 ? this.ListLoadStorage[this.index].isVisible : true;

      // if (this.protectiveXmlInputList.length > this.index)
      this.protectiveXmlInputList[0] = this.protectiveXmlInput;
      // else
      //   this.protectiveXmlInputList.push(this.protectiveXmlInput);


    }
    else {
      //this.protectiveXmlInputList = this.protectiveXmlInput[this.index];
    }

    // if (modifyonlydevice) {
    //     for (var j = 0; j < this.protectiveXmlInputList.length; j++) {
    //         this.protectiveXmlInputList[j].ischanged = false;
    //     }
    // }
    // else {
    if (this.protectiveXmlInputList.length == 1) {
      for (var j = 0; j < this.protectiveXmlInputList.length; j++) {
        if (j == 0) {
          this.protectiveXmlInputList[j].ischanged = true;
        }
      }
    }
    else {
      for (var j = 0; j < this.protectiveXmlInputList.length; j++) {
        if (this.protectiveXmlInputList[j].rownumber != this.index) {
          this.protectiveXmlInputList[j].ischanged = false;
        }
        else {
          this.protectiveXmlInputList[j].ischanged = true;

        }
      }

      for (var j = 0; j < this.ListLoadStorage.length; j++) {
        this.protectiveXmlInputList.find(x => x.rownumber == j).isVisible = this.ListLoadStorage[j].isVisible;
      }
    }
    //  }
    if (isIncomerDevice == true)
      objinput.devices = this.protectiveXmlInputList.filter(x => x.protectiondevicetype == 2);
    else
      objinput.devices = this.protectiveXmlInputList.filter(x => x.protectiondevicetype != 2);

    this.ListProtectiveInputCurrentObj = objinput;
    objinput.generatexmlonly = generatexmlonly;
    if (objinput.devices && objinput.devices.length > 0 && (!objinput.devices[0].id || objinput.devices[0].id == 0)) {
      if (!this.protectionConfigurationModel.EarthingSystem) {
        objinput.earthingSystem = "TN";
        this.protectionConfigurationModel.EarthingSystem = "TN";
      }
      this.getMaxDisconnectionTimeOptions();
      if (!this.protectionConfigurationModel.MaxDisconnectionTime) {
        objinput.maxDisconnectionTime = this.MaxDisconnectionTimeOptions[0].id;
      }
      else {
        let currentObj = this.MaxDisconnectionTimeOptions.find(m => m.id == this.protectionConfigurationModel.MaxDisconnectionTime);
        if (!currentObj) {
          objinput.maxDisconnectionTime = this.MaxDisconnectionTimeOptions[0].id;
        }
        else {
          objinput.maxDisconnectionTime = this.protectionConfigurationModel.MaxDisconnectionTime;
        }
      }
    }
    // Call when we change the slider
    // generatexmlonly is true when we use new coordination popup.
    // If user changed the slider then we are not updating the xml in ECPNetworkProtectiveCalcDetail table we are just updating the clientside temp list..
    // To reload the slider we need to send the updated xml from templist.
    this._settingService.StoreIECProtectiveData(objinput).subscribe(result => {
      this.btnAddDeviceDisabled = false;
      this.btnAddDeviceRequestCounter = 0;
      if (result !== undefined && result !== null) {
        var arr = JSON.parse(result);
        this.xmlData = arr.xml;
        if (!generatexmlonly) {
          this.xmlData_Original = arr.xml_Original;
          this.xmlData_Tripping = arr.xml_TrippingCalculation;
        }
        if (this.protectiveXmlInputList.find(x => x.rownumber == arr.rownumber) != undefined
          && this.protectiveXmlInputList.find(x => x.rownumber == arr.rownumber) != null
          && this.protectiveXmlInputList.find(x => x.rownumber == arr.rownumber).id == 0)
          this.protectiveXmlInputList.find(x => x.rownumber == arr.rownumber).id = arr.calcdetailid;


        if (arr.isrpnumber == "1") {
          this.rpcaption = "Characteristics";
        }
        else {
          this.rpcaption = "Rating plug";
        }

        this.CableSize['protection']['Xml'] = this.xmlData;
        this.CableSize['xml'] = this.xmlData;
        this.CableSize['row'] = 0;
        this.CableSize['BrowserName'] = this.detectBrowserName();
        this.CableSize['calculationType'] = "IEC Calculation";
        this.CableSize['calculationId'] = this.newCalculationId;
        this.CableSize['UserName'] = this.user.userName;
        if (this.xmlData) {
          this._CableproCalc.ProtectiveCalculate(this.CableSize).subscribe((result) => {
            this.discriminatedData = {
              discriminatedfirst: result.discriminatedfirst,
              discriminatedfirstone: result.discriminatedfirstone,
              discriminatedfirsttwo: result.discriminatedfirsttwo,
              discriminatedfirstthree: result.discriminatedfirstthree,
              discriminatedfirstfour: result.discriminatedfirstfour,
              discriminatedsecond: result.discriminatedsecond,
              discriminatedsecondone: result.discriminatedsecondone,
              discriminatedsecondtwo: result.discriminatedsecondtwo,
              discriminatedsecondthree: result.discriminatedsecondthree,
              discriminatedsecondfour: result.discriminatedsecondfour,
            }
            if (!generatexmlonly) {
              // this.CableSize['protection']['Xml'] = this.xmlData_Original;
              // this.CableSize['protection']['TrippingXml'] = this.xmlData_Tripping;
            }
            else {
              // this.protectivecoordinationoutputxml = result.xml;
              // this.coordinationGenerateErrorsModel(result.discriminatedfirst, result.discriminatedsecond);
            }
            this.chartData = result.curve;
            this.dimSizeData = result.finaldimsize;
            this.outputXmlData = result.xml;
            this.trippingCurrentAtSpecifiedTime = result.trippingCurrentAtSpecifiedTime;
            // this.saveOtherDetail();
            $('.spnmanufacurer').text(result.manufacturer);
            $('.spnfamily').text(result.family);
            $('.spnmodel').text(result.model);
            $('.spnteststandard').text(result.teststandard);
            $('.spntripunit').text(result.tripunit);
            $('.spnrating').text(result.rating);
            $('.spntripunittype').text(result.tripunittype);
            $('.spnratedvoltage').text(result.ratedmaximum);
            $('.spncurveclass').text(result.curveclass);
            $('.spnfusetype').text(result.fusetype);
            this.selectedModalId = this.protectiveXmlInputList[this.index]?.model;

            if (!isIncomerDevice) {
              this.txtmodal = result.model;
              this.txtrating = result.rating;
              this.txtfamily = result.familywithdevicetype;

            }
            else {
              this.txtmodalprotection = result.model;
              this.txtratingprotection = result.rating;
              this.txtfamilyprotection = result.familywithdevicetype;

            }
            if (result.manufacturer != "Generic") {
              this.IsGeneric = true;
              var name = result.manufacturer + "logo";
              this.protectiveImgSrc = 'assets/cablepro/logo/' + name + '.svg';
              this.protectiveImgSrc2 = 'assets/cablepro/logo/' + name + '.svg';
              if (isIncomerDevice == true)
                this.protectiveIncomerImgSrc = 'assets/cablepro/logo/' + name + '.svg';
            }
            else {
              this.protectiveImgSrc = 'assets/cablepro/logo/a.png';
              this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';
              if (isIncomerDevice == true)
                this.protectiveIncomerImgSrc = 'assets/cablepro/logo/a.png';
              this.IsGeneric = false;
            }


            var devicearr = this.defaultFamilyId.split(' ')[1];
            if (isIncomerDevice == false) {
              if (devicearr == "MCCB" || devicearr == "ACB") {
                this.txtTripUnit = result.tripunit;
                this.selectListFive = "Trip unit";
                this.curveClassOrTripUnit = "Trip unit";
              }
              else if (devicearr == "Fuse") {
                this.txtTripUnit = result.fusetype;
                this.txtTripUnitfuse = this.txtTripUnit;
                this.selectListFive = "Fuse type";
                this.curveClassOrTripUnit = "Fuse type";

                this.txtmodalfuse = result.model;
                this.txtratingfuse = result.rating;
                this.txtfamilyfuse = result.familywithdevicetype;
              }
              else {
                this.txtTripUnit = result.curveclass;
                this.selectListFive = "Curve class";
                this.curveClassOrTripUnit = "Curve class";
              }
              if (result.tripunit != null && result.tripunit != '') {
                this.txtTripUnit = result.tripunit;
              }
              if (result.fusetype != null && result.fusetype != '') {
                this.txtTripUnit = result.fusetype;
                this.txtTripUnitfuse = this.txtTripUnit;
              }
              if (result.curveclass != null && result.curveclass != '') {
                this.txtTripUnit = result.curveclass;
              }

            }
            else {
              if (devicearr == "MCCB" || devicearr == "ACB") {
                this.txtTripUnitprotection = result.tripunit;
                this.curveClassOrTripUnitProtection = "Trip unit";
              }
              else if (devicearr == "Fuse") {
                this.txtTripUnitprotection = result.fusetype;
                this.curveClassOrTripUnitProtection = "Fuse type";

              }
              else {
                this.txtTripUnitprotection = result.curveclass;
                this.curveClassOrTripUnitProtection = "Curve class";
              }
              if (result.tripunit != null && result.tripunit != '') {
                this.txtTripUnitprotection = result.tripunit;
              }
              if (result.fusetype != null && result.fusetype != '') {
                this.txtTripUnitprotection = result.fusetype;
              }
              if (result.curveclass != null && result.curveclass != '') {
                this.txtTripUnitprotection = result.curveclass;
              }

            }
            this.getAllControlsValue();
            this.runCurveEvent(this.index);
          });
        }


        var devicearr = familyId.split(' ')[1];
        if (devicearr != null && devicearr != "" && (devicearr == "MCB" || devicearr == "Fuse")) {
          $("#divmcbacbonly").show();
          $("#divelectronic").hide();
          $("#divmagneticonly").hide();
          $("#divtmagneticonly").hide();
        }
        else {
          $("#divmcbacbonly").hide();
          //this.deviceType="3";
          this.deviceType = arr.type;
          this.multiplierIN = arr.inrating;
          var setvalue = 1;
          if (this.deviceType == "3") {
            $("#divelectronic").hide();
            $("#divmagneticonly").show();
            $("#divtmagneticonly").hide();
            this.getInputValues(arr.mim, '#pickupcurrmgpr', "#pickupcurrmgprspn", "#pickupcurrmgprhdn", "#pickupcurrmgprdiv", setvalue, arr.defaultmim);
          }
          if (this.deviceType == "2") {
            $("#divelectronic").hide();
            $("#divmagneticonly").hide();
            $("#divtmagneticonly").show();
            this.getInputValues(arr.tmir, '#pickupcurrth', "#gridSizeValue", "#pickupcurrthhdn", "#pickupcurrthdiv", setvalue, arr.defaulttmir);
            this.getInputValues(arr.tmim, '#pickupcurrmg', "#pickupcurrmgspn", "#pickupcurrmgshdn", "#pickupcurrmgsdiv", setvalue, arr.defaulttmim);
          }
          if (this.deviceType == "1") {
            $("#divelectronic").show();
            $("#divmagneticonly").hide();
            $("#divtmagneticonly").hide();

            this.multiplierEIR = arr.defaulteir != "-" ? arr.defaulteir : 1;
            if (arr.rp != null && arr.rp != "") {
              $("#ratingplugdiv").show();

              $("#ratingplug").val(arr.rp);
              this.ratingPlugList = arr.rplist;
              this.rp = arr.rp;
            }
            else {
              $('#ratingplug option:selected').val('');
              $("#ratingplugdiv").hide();
            }

            this.multiplierEIO = arr.defaulteio != "-" ? arr.defaulteio : 1;
            if (arr.ei2tcurve != "1" && arr.ei2tcurve != "0") {
              $("#I2tdiv").hide();
              $('#chcki2curve').prop('checked', false);
            }
            else {
              $("#I2tdiv").show();
              if (arr.ei2tcurve == "1") {

                $('#chcki2curve').prop('checked', true);
              }
              else {
                $('#chcki2curve').prop('checked', false);

              }
            }

            this.getInputValues(arr.currenttolerance, '#current-tolerance-range', "#current-tolerance-rangespn", "#current-tolerance-rangehdn", "#current-tolerance-rangediv", setvalue, arr.defaultcurrenttolerance);
            this.getInputValues(arr.timetolerance, '#time-tolerance-range', "#time-tolerance-rangespn", "#time-tolerance-rangehdn", "#time-tolerance-rangediv", setvalue, arr.defaulttimetolerance);
            this.getInputValues(arr.timetobreak, '#time-tobreak-range', "#time-tobreak-rangespn", "#time-tobreak-rangehdn", "#time-tobreak-rangediv", setvalue, arr.defaulttimetobreak);
            this.getInputValues(arr.eio, '#pickupcurrpre-range', "#pickupcurrpre-rangespn", "#pickupcurrpre-rangehdn", "#pickupcurrpre-rangediv", setvalue, arr.defaulteio);
            this.getInputValues(arr.eir, '#pickupcurr-range', "#pickupcurr-rangespn", "#pickupcurr-rangehdn", "#pickupcurr-rangediv", setvalue, arr.defaulteir);
            this.getInputValues(arr.etr, '#timedelay-range', "#timedelay-rangespn", "#timedelay-rangehdn", "#timedelay-rangediv", setvalue, arr.defaultetr);
            this.getInputValues(arr.eisd, '#pickupshort-range', "#pickupshort-rangespn", "#pickupshort-rangehdn", "#pickupshort-rangediv", setvalue, arr.defaulteisd);
            this.getInputValues(arr.etsd, '#timedelayshort-range', "#timedelayshort-rangespn", "#timedelayshort-rangehdn", "#timedelayshort-rangediv", setvalue, arr.defaultetsd);
            this.getInputValues(arr.eli, '#pickupcurrinst-range', "#pickupcurrinst-rangespn", "#pickupcurrinst-rangehdn", "#pickupcurrinst-rangediv", setvalue, arr.defaulteli);
            this.getInputValues(arr.idmtl, '#idmtl-settings', "#idmtl-settingsspn", "#idmtl-settingshdn", "#idmtl-settingsdiv", setvalue, arr.defaultidmtl);
            if (arr.eltboolproperty == "show") {
              //
              if (arr.chklong == "0") {
                $("#divlongtimeprot").hide();
                $('#chcklongtime').prop('checked', false);
              }
              else {
                $('#chcklongtime').prop('checked', true);
                $("#divlongtimeprot").show();

              }
              $("#divlongtimeprotchk").show();
              $("#divlongtimeprotchk :input").removeAttr('disabled');
            }
            else if (arr.eltboolproperty == "hide") {

              $('#chcklongtime').prop('checked', false);
              if (arr.isrpnumber == "1") {
                $('#chcklongtime').prop('checked', true);
                $("#timedelay-rangediv").hide();
              }
              $("#divlongtimeprotchk").hide();
            }
            else if (arr.eltboolproperty == "disabled" || arr.eltboolproperty == null) {
              $('#chcklongtime').prop('checked', true);
              $("#divlongtimeprot").show();
              $("#divlongtimeprotchk").show();
              $("#divlongtimeprotchk :input").attr('disabled', 'true');
            }
            if ($('#ratingplug option:selected').val() == "OFF" || this.rp == "OFF") {
              $("#pickupcurr-rangediv").hide();
              $("#timedelay-rangediv").hide();
            }
            if (arr.estboolproperty == "show") {
              $("#divshorttime").show();
              $("#divshorttimechk").show();
              $("#divshorttimechk :input").removeAttr('disabled');
              $('#chckshorttime').prop('checked', true);
              if (arr.chkshort == "0") {
                $("#divshorttime").hide();
                $('#chckshorttime').prop('checked', false);
              }
              else {
                $('#chckshorttime').prop('checked', true);
                $("#divshorttime").show();

              }


            }
            else if (arr.estboolproperty == "hide") {
              $("#divshorttime").hide();
              $("#divshorttimechk").hide();

              $('#chckshorttime').prop('checked', false);
              if (arr.isrpnumber == "1") {
                $('#chckshorttime').prop('checked', true);
              }


            }
            else if (arr.estboolproperty == "disabled" || arr.estboolproperty == null) {
              $("#divshorttime").show();
              $("#divshorttimechk").show();
              $("#divshorttimechk :input").attr('disabled', 'true');
              $('#chckshorttime').prop('checked', true);

            }

            if (arr.eintboolproperty == "show") {
              $("#divinstant").show();
              $("#divinstantchk").show();
              // $('#chckInstant').prop('checked', true);
              if (arr.chkinst == "0") {
                $("#divinstant").hide();
                $('#chckInstant').prop('checked', false);
              }
              else
                $('#chckInstant').prop('checked', true);

              $("#divinstantchk :input").removeAttr('disabled');
            }
            else if (arr.eintboolproperty == "hide") {
              $("#divinstant").hide();
              $('#chckInstant').prop('checked', false);
              if (arr.isrpnumber == "1") {
                $('#chckInstant').prop('checked', true);
              }

              $("#divinstantchk").hide();
            }
            else if (arr.eintboolproperty == "disabled" || arr.eintboolproperty == null) {
              $("#divinstant").show();
              //  $('#chckInstant').prop('checked', true);
              $("#divinstantchk").show();
              $("#divinstantchk :input").attr('disabled', 'true');

              if (arr.chkinst == "0") {
                $("#divinstant").hide();
                $("#divinstantchk").hide();
                $('#chckInstant').prop('checked', false);
              }
              else
                $('#chckInstant').prop('checked', true);
            }
          }
        }
      }
      this.hideLoader();
      $('#protectiveSelector').modal('hide');
    },
      err => {
        this.btnAddDeviceDisabled = false;
        this.btnAddDeviceRequestCounter = 0;
        $('#protectiveSelector').modal('hide');
        this.hideLoader();
      });
  }

  getInputValues(str: string, controlid: string, controlspanid: string, controlhdn: string, controldiv: string, setvalue: number = 0, defaultvalue: string = "") {
    $(controlid).removeClass('hastype3');
    $(controlid).removeAttr('multiplier');
    $(controlid).removeClass('showmin');
    $(controlid).removeClass('excesselements');
    $(controlid).removeClass('classtype');
    if (str != null && str != "-" && str != "") {

      if (str.split(' ')[0].split('-')[0] == "Type1") {

        var val = str.split(' ')[0].split('-')[1].split(',');
        var Arr = [];
        var obj: any;
        var i = 0;
        val.forEach(element => {
          obj = new Object();
          obj.value = i++;
          obj.legend = element.split(',')[0].toString();
          Arr.push(obj);
        });
        if (val != null && val.length > 14) {
          $(controlid).addClass('excesselements');
        }

        $(controlid).removeAttr('multiplier');
        this.setOptions(controlid, { stepsArray: Arr, showTicks: true });
        if (setvalue == 1) {
          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, defaultvalue);


        }
      }
      else if (str.split(' ')[0].split('-')[0] == "Type2") {
        var val = str.split(' ')[0].split('-')[1].split(',');
        var minval = val[0].split("=")[1];
        var maxval = val[1].split("=")[1];
        var step = val[2].split("=")[1];

        $(controlid).addClass('showmin');
        $(controlid).removeAttr('multiplier');
        this.setOptions(controlid, {
          floor: minval,
          ceil: maxval, step: step
        });

        if (setvalue == 1) {
          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, defaultvalue);

        }

      }
      else if (str.split(' ')[0].split('-')[0] == "Type3") {
        // $(controlid).addClass('hastype3'); 
        $(controlid).addClass('showmin');
        var val = str.split(' ')[0].split('-')[2].split(',');
        var multipliercolumn = str.split(' ')[0].split('-')[1];
        var multipliervalue = 1;
        var minval = val[0].split("=")[1];
        var maxval = val[1].split("=")[1];
        var step = val[2].split("=")[1];

        if (setvalue == 1) {

          if (multipliercolumn == "E_Io") {
            multipliervalue = this.multiplierEIO;
          }
          if (multipliercolumn == "E_Ir") {
            multipliervalue = this.multiplierEIR;

          }
          if (multipliercolumn == "In") {
            multipliervalue = this.multiplierIN;

          }


          this.setDefaultValues(controlid, (parseFloat(defaultvalue)).toString());
          this.setCalculatedValues(controlid, (parseFloat(defaultvalue)).toString());
        }

        this.setOptions(controlid, {
          floor: (parseFloat(minval) * multipliervalue),
          ceil: (parseFloat(maxval) * multipliervalue), step: step
        });

      }
      else if (str.split(' ')[0].split('-')[0] == "Type4") {
        var val = str.split(' ')[0].split('-')[2].split(',');
        var multipliercolumn = str.split(' ')[0].split('-')[1];
        var multipliervalue = 1;
        var Arr = [];
        var obj: any;

        var i = 0;
        val.forEach(element => {
          obj = new Object();
          obj.value = i++;
          obj.legend = element.split(',')[0].toString();
          Arr.push(obj);
        });
        if (val != null && val.length > 14) {
          $(controlid).addClass('excesselements');
        }
        this.setOptions(controlid, { stepsArray: Arr, showTicks: true });

        if (setvalue == 1) {


          if (multipliercolumn == "E_Io") {
            multipliervalue = this.multiplierEIO;
          }
          if (multipliercolumn == "E_Ir") {
            multipliervalue = this.multiplierEIR;

          }
          if (multipliercolumn == "In") {
            multipliervalue = this.multiplierIN;
          }

          $(controlid).attr('multiplier', multipliercolumn);
          $(controlid).addClass('multiplier');

          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, this.RemoveTrailingZeros((Math.round((parseFloat(defaultvalue) * multipliervalue) * 100) / 100).toFixed(2)));
        }


      }
      else if (str.split(' ')[0].split('-')[0] == "Type5") {
        $(controlid).addClass('showmin');
        var val = str.split(' ')[0].split('-')[2].split(',');
        var multipliercolumn = str.split(' ')[0].split('-')[1];

        var minval = val[0].split("=")[1];
        var maxval = val[1].split("=")[1];
        var step = val[2].split("=")[1];
        var multipliervalue = 1;
        this.setOptions(controlid, {
          floor: minval,
          ceil: maxval, step: step
        });


        if (setvalue == 1) {
          if (multipliercolumn == "E_Io") {
            multipliervalue = this.multiplierEIO;
          }
          if (multipliercolumn == "E_Ir") {
            multipliervalue = this.multiplierEIR;

          }
          if (multipliercolumn == "In") {
            multipliervalue = this.multiplierIN;

          }
          $(controlid).attr('multiplier', multipliercolumn);
          $(controlid).addClass('multiplier');
          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, this.RemoveTrailingZeros((Math.round((parseFloat(defaultvalue) * multipliervalue) * 100) / 100).toFixed(2)));

        }



      }
      else if (str.split(' ')[0].split('-')[0] == "Type6") {
        var val = str.split('(')[0].split('-')[1].split(',');
        var Arr = [];
        var obj: any;
        $(controlid).removeAttr('multiplier');
        var i = 0;
        val.forEach(element => {
          obj = new Object();
          obj.value = i++;
          obj.legend = element.split(',')[0].toString();
          Arr.push(obj);
        });
        if (val != null && val.length > 0) {
          if (val[0] == 'Class 5') {
            $(controlid).addClass('classtype');
          }

        }
        if (val != null && val.length > 14) {

          $(controlid).addClass('excesselements');
        }
        this.setOptions(controlid, { stepsArray: Arr, showTicks: true });
        if (setvalue == 1) {
          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, defaultvalue);
        }

      }

      if (str.split(' ')[0].split('-')[0] == "Type7") {
        var val = str.split(' ')[0].split('-')[1].split(',,');
        var Arr = [];
        var obj: any;
        var i = 0;
        $(controlid).removeAttr('multiplier');
        val.forEach(element => {
          obj = new Object();
          obj.value = i++;
          obj.legend = element.split(',')[0].toString();
          Arr.push(obj);
        });
        if (val != null && val.length > 14) {
          $(controlid).addClass('excesselements');
        }
        this.setOptions(controlid, { stepsArray: Arr, showTicks: true, value: defaultvalue });
        if (setvalue == 1) {
          this.setDefaultValues(controlid, defaultvalue);
          this.setCalculatedValues(controlid, defaultvalue);
        }
      }
      $(controldiv).show();
    }
    else {
      defaultvalue = '-';
      this.setDefaultValues(controlid, defaultvalue);
      $(controldiv).hide();
    }

    if (controlid == "#pickupcurr-range") {
      // this.slidereir=event;
      // this.multiplierEIR=event;
      if (this.slidereircalc != null && this.slidereircalc != "-" && this.slidereircalc != "")
        this.multiplierEIR = parseFloat(this.slidereircalc);
    }
  }


  public slidertmir: string = '';
  public slidertmircalc: string = '';
  public slidertmiroptions: any;

  public slidertmim: string = '';
  public slidertmimcalc: string = '';
  public slidertmimoptions: any;

  public slidermim: string = '';
  public slidermimcalc: string = '';
  public slidermimoptions: any;
  public slidercurrenttolerance: string = '';
  public slidercurrenttolerancecalc: string = '';
  public slidercurrenttoleranceoptions: any;

  public slidertimetolerance: string = '';
  public slidertimetolerancecalc: string = '';
  public slidertimetoleranceoptions: any = '';

  public slidertimetobreak: string = '';
  public slidertimetobreakcalc: string = '';
  public slidertimetobreakoptions: any = '';

  public slidereio: string = '';
  public slidereiocalc: string = '';
  public slidereiooptions: any = '';

  public slidereir: string = '';
  public slidereircalc: string = '';
  public slidereiroptions: any = '';

  public slideridmtl: string = '';
  public slideridmtlcalc: string = '';
  public slideridmtloptions: any = '';


  public slideretr: string = '';
  public slideretrcalc: string = '';
  public slideretroptions: any = '';

  public slidereisd: string = '';
  public slidereisdcalc: string = '';
  public slidereisdoptions: any = '';

  public slideretsd1: any = '1';
  public slideretsdcalc: string = '';
  public slideretsdoptions: any = '';

  public slidereli: string = '';
  public sliderelicalc: string = '';
  public sliderelioptions: any = '';
  setOptions(controlid: string, defaultarr: any) {
    if (controlid == "#pickupcurrth") {
      this.slidertmiroptions = defaultarr;
    }
    else if (controlid == "#pickupcurrmg") {
      this.slidertmimoptions = defaultarr;

    }
    else if (controlid == "#pickupcurrmgpr") {
      this.slidermimoptions = defaultarr;

    }



    if (controlid == "#current-tolerance-range") {
      this.slidercurrenttoleranceoptions = defaultarr;
    }
    else if (controlid == "#time-tolerance-range") {
      this.slidertimetoleranceoptions = defaultarr;

    }
    else if (controlid == "#time-tobreak-range") {
      this.slidertimetobreakoptions = defaultarr;

    }

    if (controlid == "#pickupcurrpre-range") {
      this.slidereiooptions = defaultarr;
    }
    else if (controlid == "#pickupcurr-range") {
      this.slidereiroptions = defaultarr;

    }
    else if (controlid == "#idmtl-settings") {
      this.slideridmtloptions = defaultarr;

    }

    else if (controlid == "#timedelay-range") {
      this.slideretroptions = defaultarr;

    }

    else if (controlid == "#pickupshort-range") {
      this.slidereisdoptions = defaultarr;

    }
    else if (controlid == "#timedelayshort-range") {
      this.slideretsdoptions = defaultarr;

    }
    else if (controlid == "#pickupcurrinst-range") {
      this.sliderelioptions = defaultarr;

    }
  }
  setDefaultValues(controlid: string, defaultvalue: string) {

    if (controlid == "#pickupcurrth") {
      this.slidertmir = this.getValueFromLegend(defaultvalue, this.slidertmiroptions);
    }
    else if (controlid == "#pickupcurrmg") {
      this.slidertmim = this.getValueFromLegend(defaultvalue, this.slidertmimoptions);

    }
    else if (controlid == "#pickupcurrmgpr") {

      // this.slidermim=this.getValueFromLegend(defaultvalue,this.slidermimoptions);
      this.slidermim = this.getValueFromLegend(defaultvalue, this.slidermimoptions);

    }

    else if (controlid == "#idmtl-settings") {
      this.slideridmtl = this.getValueFromLegend(defaultvalue, this.slideridmtloptions);

    }


    if (controlid == "#current-tolerance-range") {
      this.slidercurrenttolerance = this.getValueFromLegend(defaultvalue, this.slidercurrenttoleranceoptions);
    }
    if (controlid == "#time-tolerance-range") {
      this.slidertimetolerance = this.getValueFromLegend(defaultvalue, this.slidertimetoleranceoptions);

    }

    if (controlid == "#time-tobreak-range") {
      this.slidertimetobreak = this.getValueFromLegend(defaultvalue, this.slidertimetobreakoptions);
    }
    if (controlid == "#pickupcurrpre-range") {
      this.slidereio = this.getValueFromLegend(defaultvalue, this.slidereiooptions);

    }

    if (controlid == "#pickupcurr-range") {
      this.slidereir = this.getValueFromLegend(defaultvalue, this.slidereiroptions);
    }
    if (controlid == "#timedelay-range") {
      this.slideretr = this.getValueFromLegend(defaultvalue, this.slideretroptions);

    }
    if (controlid == "#pickupshort-range") {
      this.slidereisd = this.getValueFromLegend(defaultvalue, this.slidereisdoptions);

    }
    if (controlid == "#timedelayshort-range") {

      this.slideretsd1 = this.getValueFromLegend(defaultvalue, this.slideretsdoptions);
    }
    if (controlid == "#pickupcurrinst-range") {
      this.slidereli = this.getValueFromLegend(defaultvalue, this.sliderelioptions);

    }


  }
  getValueFromLegend(showValue: string, arry: any): any {
    if (arry["showTicks"]) {
      if (showValue != "-") {
        let returnedValue: any = arry.stepsArray.find(e => {
          return e['legend'] == showValue.toString();
        });
        if (returnedValue != null && returnedValue != undefined && isNaN(returnedValue["value"]) == false) {
          return returnedValue["value"];
        }
        else {
          return showValue;
        }
      }
    }
    else {
      return showValue;
    }
  }
  getLegendFromValue(showValue: string, arry: any): string {
    if (showValue == "NaN") {
      return "-";
    }
    if (arry["showTicks"]) {
      let returnedValue: any = arry.stepsArray.find(e => {
        return e.value == showValue;
      });

      if (returnedValue != null && returnedValue != undefined) {
        return returnedValue["legend"];
      }
      else {
        return showValue;
      }
    }
    else {
      return showValue;
    }

  }
  setCalculatedValues(controlid: string, calcvalue: string) {
    if (controlid == "#pickupcurrth") {
      this.slidertmircalc = calcvalue;
    }
    else if (controlid == "#pickupcurrmg") {
      this.slidertmimcalc = calcvalue;

    }
    else if (controlid == "#pickupcurrmgpr") {
      this.slidermimcalc = calcvalue;

    }
    else if (controlid == "#idmtl-settings") {
      this.slideridmtlcalc = calcvalue;

    }

    if (controlid == "#current-tolerance-range") {
      this.slidercurrenttolerancecalc = Math.round(100 * parseFloat(calcvalue)).toString();
    }
    if (controlid == "#time-tolerance-range") {
      this.slidertimetolerancecalc = Math.round(100 * parseFloat(calcvalue)).toString();

    }

    if (controlid == "#time-tobreak-range") {
      this.slidertimetobreakcalc = calcvalue;
    }
    if (controlid == "#pickupcurrpre-range") {
      this.slidereiocalc = calcvalue;

    }

    if (controlid == "#pickupcurr-range") {
      this.slidereircalc = calcvalue;
    }
    if (controlid == "#timedelay-range") {
      this.slideretrcalc = calcvalue;

    }
    if (controlid == "#idmtl-settings") {
      this.slideridmtlcalc = calcvalue;

    }
    if (controlid == "#pickupshort-range") {
      this.slidereisdcalc = calcvalue;

    }
    if (controlid == "#timedelayshort-range") {

      this.slideretsdcalc = calcvalue;

    }
    if (controlid == "#pickupcurrinst-range") {
      this.sliderelicalc = calcvalue;

    }

  }


  isProtectiveConfigChanged: boolean = false;
  ProtectiveGetXml(manufacturerId: number, familyId: string, modelId: number, rating: string, curve: string
    , tmir: string, tmim: string, mim: string, currenttolerance: string, timetolerance: string, timetobreak: string
    , eratingplug: string, eltbool: string, estbool: string, eintbool: string
    , eio: string, eir: string
    , etr: string, eisd: string
    , etsd: string, ei2tcurve: string
    , eli: string, setvalue: number = 0

    , controlchangedId: string = "", idmtl: string, rpchanged: boolean = false, modifyonlydevice: boolean = false
  ) {

    var objinput = new ListProtectiveInput();
    objinput.calculationid = this.newCalculationId;

    objinput.tmir = tmir;
    objinput.tmim = tmim;
    objinput.mim = mim;
    // if (ei2tcurve == '') {
    //     ei2tcurve = "-";

    // } 
    objinput.currenttolerance = currenttolerance;
    objinput.timetolerance = timetolerance;
    objinput.timetobreak = timetobreak;
    objinput.eltboolproperty = eltbool;
    objinput.estboolproperty = estbool;
    objinput.eintboolproperty = eintbool;
    objinput.eio = eio;
    objinput.eir = eir;
    objinput.etr = etr;
    objinput.eisd = eisd;
    objinput.eratingplug = eratingplug;
    objinput.etsd = etsd;
    objinput.ei2tcurve = ei2tcurve;
    objinput.eli = eli;
    objinput.idmtl = idmtl;
    let trippingtime;
    if (!this.protectionConfigurationModel.MaxDisconnectionTime)
      trippingtime = "0.4";
    else {
      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;
    }
    objinput.trippingtime = trippingtime;
    //objinput.trippingcurrent = $("#current").val().toString()//s.trippingcurrent;
    if (this.modifyindex >= 0) {
      // if (modifyonlydevice == false) {
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).model = modelId;
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).manufacturer_id = manufacturerId;
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).range_id = familyId;
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).tripunit = curve;
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).rating = rating;

      for (var j = 0; j < this.ListLoadStorage.length; j++) {
        this.protectiveXmlInputList.find(x => x.rownumber == j).isVisible = this.ListLoadStorage[j].isVisible;
      }

      // }
      this.protectiveXmlInputList.find(x => x.rownumber == this.index).devicenostr = this.deviceNumber.trim();
    }
    else {
      if (this.index >= 0) {

        if (modifyonlydevice == false) {
          if (this.protectiveXmlInputList.length == 1) {
            this.protectiveXmlInputList[0].ischanged = true;
          }
        }
        else {
          for (var j = 0; j < this.protectiveXmlInputList.length; j++) {

            if (this.protectiveXmlInputList[j].rownumber == this.index)

              this.protectiveXmlInputList[j].ischanged = true;
            else
              this.protectiveXmlInputList[j].ischanged = false;

          }
        }
      }
    }
    var devicetype = 1;
    if (this.protectiveXmlInputList.length > this.index)
      devicetype = this.protectiveXmlInputList[this.index].protectiondevicetype;

    objinput.devices = this.protectiveXmlInputList.filter(x => x.protectiondevicetype == devicetype);
    this.isProtectiveConfigChanged = true;
    this.ListProtectiveInputCurrentObj = objinput;
    objinput.generatexmlonly = modifyonlydevice;


    this._settingService.updateIECProtectiveXmlTwo(objinput).subscribe(result => {
      if (result !== undefined && result !== null) {
        var arr = JSON.parse(result);
        this.xmlData = arr.xml;
        this.xmlData_Original = arr.xml_Original;
        this.xmlData_Tripping = arr.xml_TrippingCalculation;
        this.deviceType = arr.type;
        if (this.deviceType == "3") {
          $("#divelectronic").hide();
          $("#divmagneticonly").show();
          $("#divtmagneticonly").hide();

        }
        if (this.deviceType == "2") {
          $("#divelectronic").hide();
          $("#divmagneticonly").hide();
          $("#divtmagneticonly").show();
        }
        if (this.deviceType == "1") {
          $("#divelectronic").show();
          $("#divmagneticonly").hide();
          $("#divtmagneticonly").hide();
          var multiplier = 1;
          var multipliercolumn = $(controlchangedId).attr('multiplier');
          if (multipliercolumn != undefined) {
            if (multipliercolumn == "E_Io") {
              multiplier = this.multiplierEIO;
            }
            if (multipliercolumn == "E_Ir") {
              multiplier = this.multiplierEIR;

            }
            if (multipliercolumn == "In") {
              multiplier = this.multiplierIN;

            }
          }
        }

        this.CableSize['protection']['Xml'] = this.xmlData;
        this.CableSize['xml'] = this.xmlData;
        this.CableSize['row'] = 0;
        // if (devicetype == 2)
        //   this.CableSize['row'] = 0;

        this.protectiveXmlInputList[0].xml = arr.xml_Original;
        // this.getAllControlsValue();
        if (this.xmlData) {
          this.CableSize['BrowserName'] = this.detectBrowserName();
          this.CableSize['calculationType'] = "Network Calculation";
          this.CableSize['calculationId'] = this.newCalculationId;
          this.CableSize['UserName'] = this.user.userName;
          this._CableproCalc.ProtectiveCalculate(this.CableSize).subscribe((result) => {
            this.coordinationloader = false;
            this.discriminatedData = {
              discriminatedfirst: result.discriminatedfirst,
              discriminatedfirstone: result.discriminatedfirstone,
              discriminatedfirsttwo: result.discriminatedfirsttwo,
              discriminatedfirstthree: result.discriminatedfirstthree,
              discriminatedfirstfour: result.discriminatedfirstfour,
              discriminatedsecond: result.discriminatedsecond,
              discriminatedsecondone: result.discriminatedsecondone,
              discriminatedsecondtwo: result.discriminatedsecondtwo,
              discriminatedsecondthree: result.discriminatedsecondthree,
              discriminatedsecondfour: result.discriminatedsecondfour,
            }


            this.CableSize['protection']['Xml'] = this.xmlData;
            this.CableSize['protection']['TrippingXml'] = this.xmlData_Tripping;

            this.getAllControlsValue();



            this.chartData = result.curve;
            this.dimSizeData = result.finaldimsize;
            this.outputXmlData = result.xml;
            this.trippingCurrentAtSpecifiedTime = result.trippingCurrentAtSpecifiedTime;
            this.GenerateMaxAllowedEFLImpedance();
            $('.spnmanufacurer').text(result.manufacturer);
            $('.spnfamily').text(result.family);
            $('.spnmodel').text(result.model);
            $('.spnteststandard').text(result.teststandard);
            $('.spntripunit').text(result.tripunit);
            $('.spnrating').text(result.rating);
            $('.spntripunittype').text(result.tripunittype);
            $('.spnratedvoltage').text(result.ratedmaximum);
            $('.spncurveclass').text(result.curveclass);
            $('.spnfusetype').text(result.fusetype);
            this.txtrating = result.rating;
            this.selectedModalId = this.protectiveXmlInputList[this.index].model;
            // let selectedModel = this.modelOutput.find(m => m.id == this.protectiveXmlInputList[0].model);
            this.txtmodal = result.model;
            this.txtfamily = result.familywithdevicetype;
            if (result.manufacturer != "Generic") {
              this.IsGeneric = true;
              var name = result.manufacturer + "logo";
              this.protectiveImgSrc = 'assets/cablepro/logo/' + name + '.svg';
              this.protectiveImgSrc2 = 'assets/cablepro/logo/' + name + '.svg';


            }
            else {
              this.protectiveImgSrc = 'assets/cablepro/logo/a.png';
              this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';


              this.IsGeneric = false;
            }

            var devicearr = this.defaultFamilyId.split(' ')[1];
            if (devicearr == "MCCB" || devicearr == "ACB") {
              this.txtTripUnit = result.tripunit;
              this.selectListFive = "Trip unit";
              this.curveClassOrTripUnit = "Trip unit";
            }
            else if (devicearr == "Fuse") {
              this.txtTripUnit = result.fusetype;
              this.selectListFive = "Fuse type";
              this.curveClassOrTripUnit = "Fuse type";
            }
            else {
              this.txtTripUnit = result.curveclass;
              this.selectListFive = "Curve class";
              this.curveClassOrTripUnit = "Curve class";
            }
            this.txtTripUnitfuse = this.txtTripUnit;
            this.txtTripUnitprotection = this.txtTripUnit;
            var shownumber = 1;
            // for (var i = 0; i < this.listCoordinationCriteria.length; i++) {
            //     this.addCurve(this.getDevicenumber(this.listCoordinationCriteria[i].devicenostr), this.listCoordinationCriteria[i].model.toString(), this.getDevicenumber(this.listCoordinationCriteria[i].devicenostr)
            //         , parseFloat(this.listCoordinationCriteria[i].manufacturer), parseFloat(this.listCoordinationCriteria[i].rating), parseFloat(this.listCoordinationCriteria[i].tripunit), parseInt(this.listCoordinationCriteria[i].desc), i, this.listCoordinationCriteria[i].devicenostr);

            // }
            // if ($("#current").val().toString() != "")
            //     this.sequenceofoperation = result.sequenceofoperation;

            this.runCurveEvent(this.index);

            // this.highLightRow(this.index);
            //this.saveOtherDetail();
            //  this.hideLoader();
          });
        }

        if (rpchanged || this.modifyindex >= 0) {
          this.modifyindex = -1;
          var devicearr = familyId.split(' ')[1];
          if (devicearr != null && devicearr != "" && (devicearr == "MCB" || devicearr == "Fuse")) {
            $("#divmcbacbonly").show();
            $("#divelectronic").hide();
            $("#divmagneticonly").hide();
            $("#divtmagneticonly").hide();
          }
          else {
            $("#divmcbacbonly").hide();
            //this.deviceType="3";
            if (arr.type != null) {
              this.deviceType = arr.type;

              this.multiplierIN = arr.inrating;
            }
            var setvalue = 1;
            if (this.deviceType == "3") {
              $("#divelectronic").hide();
              $("#divmagneticonly").show();
              $("#divtmagneticonly").hide();
              this.getInputValues(arr.mim, '#pickupcurrmgpr', "#pickupcurrmgprspn", "#pickupcurrmgprhdn", "#pickupcurrmgprdiv", setvalue, arr.defaultmim);
            }
            if (this.deviceType == "2") {
              $("#divelectronic").hide();
              $("#divmagneticonly").hide();
              $("#divtmagneticonly").show();
              this.getInputValues(arr.tmir, '#pickupcurrth', "#gridSizeValue", "#pickupcurrthhdn", "#pickupcurrthdiv", setvalue, arr.defaulttmir);
              this.getInputValues(arr.tmim, '#pickupcurrmg', "#pickupcurrmgspn", "#pickupcurrmgshdn", "#pickupcurrmgsdiv", setvalue, arr.defaulttmim);
            }
            if (this.deviceType == "1") {
              $("#divelectronic").show();
              $("#divmagneticonly").hide();
              $("#divtmagneticonly").hide();


              this.multiplierEIR = arr.defaulteir != "-" ? arr.defaulteir : 1;
              if (arr.rp != null && arr.rp != "") {
                $("#ratingplugdiv").show();

                $("#ratingplug").val(arr.rp);
                this.ratingPlugList = arr.rplist;
                this.rp = arr.rp;
              }
              else {
                $('#ratingplug option:selected').val('');
                $("#ratingplugdiv").hide();
              }

              this.multiplierEIO = arr.defaulteio != "-" ? arr.defaulteio : 1;
              if (arr.ei2tcurve != "1" && arr.ei2tcurve != "0") {
                $("#I2tdiv").hide();
                $('#chcki2curve').prop('checked', false);
              }
              else {
                $("#I2tdiv").show();
                if (arr.ei2tcurve == "1") {

                  $('#chcki2curve').prop('checked', true);
                }
                else {
                  $('#chcki2curve').prop('checked', false);

                }
              }

              this.getInputValues(arr.currenttolerance, '#current-tolerance-range', "#current-tolerance-rangespn", "#current-tolerance-rangehdn", "#current-tolerance-rangediv", setvalue, arr.defaultcurrenttolerance);
              this.getInputValues(arr.timetolerance, '#time-tolerance-range', "#time-tolerance-rangespn", "#time-tolerance-rangehdn", "#time-tolerance-rangediv", setvalue, arr.defaulttimetolerance);
              this.getInputValues(arr.timetobreak, '#time-tobreak-range', "#time-tobreak-rangespn", "#time-tobreak-rangehdn", "#time-tobreak-rangediv", setvalue, arr.defaulttimetobreak);
              this.getInputValues(arr.eio, '#pickupcurrpre-range', "#pickupcurrpre-rangespn", "#pickupcurrpre-rangehdn", "#pickupcurrpre-rangediv", setvalue, arr.defaulteio);
              this.getInputValues(arr.eir, '#pickupcurr-range', "#pickupcurr-rangespn", "#pickupcurr-rangehdn", "#pickupcurr-rangediv", setvalue, arr.defaulteir);
              this.getInputValues(arr.etr, '#timedelay-range', "#timedelay-rangespn", "#timedelay-rangehdn", "#timedelay-rangediv", setvalue, arr.defaultetr);
              this.getInputValues(arr.eisd, '#pickupshort-range', "#pickupshort-rangespn", "#pickupshort-rangehdn", "#pickupshort-rangediv", setvalue, arr.defaulteisd);
              this.getInputValues(arr.etsd, '#timedelayshort-range', "#timedelayshort-rangespn", "#timedelayshort-rangehdn", "#timedelayshort-rangediv", setvalue, arr.defaultetsd);
              this.getInputValues(arr.eli, '#pickupcurrinst-range', "#pickupcurrinst-rangespn", "#pickupcurrinst-rangehdn", "#pickupcurrinst-rangediv", setvalue, arr.defaulteli);
              this.getInputValues(arr.idmtl, '#idmtl-settings', "#idmtl-settingsspn", "#idmtl-settingshdn", "#idmtl-settingsdiv", setvalue, arr.defaultidmtl);
              if (arr.eltboolproperty == "show") {
                //
                $('#chcklongtime').prop('checked', true);
                $("#divlongtimeprot").show();
                $("#divlongtimeprotchk").show();
                $("#divlongtimeprotchk :input").removeAttr('disabled');
              }
              else if (arr.eltboolproperty == "hide") {

                $('#chcklongtime').prop('checked', false);
                if (arr.isrpnumber == "1") {
                  $('#chcklongtime').prop('checked', true);
                  $("#timedelay-rangediv").hide();
                }
                $("#divlongtimeprotchk").hide();
              }
              else if (arr.eltboolproperty == "disabled" || arr.eltboolproperty == null) {
                $('#chcklongtime').prop('checked', true);
                $("#divlongtimeprot").show();
                $("#divlongtimeprotchk").show();
                $("#divlongtimeprotchk :input").attr('disabled', 'true');
              }

              if ($('#ratingplug option:selected').val() == "OFF") {
                $("#pickupcurr-rangediv").hide();
                $("#timedelay-rangediv").hide();
              }
              if (arr.estboolproperty == "show") {
                $("#divshorttime").show();
                $("#divshorttimechk").show();
                $("#divshorttimechk :input").removeAttr('disabled');
                $('#chckshorttime').prop('checked', true);

              }
              else if (arr.estboolproperty == "hide") {
                $("#divshorttime").hide();
                $("#divshorttimechk").hide();

                $('#chckshorttime').prop('checked', false);
                if (arr.isrpnumber == "1") {
                  $('#chckshorttime').prop('checked', true);
                }


              }
              else if (arr.estboolproperty == "disabled" || arr.estboolproperty == null) {
                $("#divshorttime").show();
                $("#divshorttimechk").show();
                $("#divshorttimechk :input").attr('disabled', 'true');
                $('#chckshorttime').prop('checked', true);

              }

              if (arr.eintboolproperty == "show") {
                // $("#divinstant").show();
                //  $("#divinstantchk").show();
                // $('#chckInstant').prop('checked', true);
                //  $("#divinstantchk :input").removeAttr('disabled');

                $("#divinstant").show();
                $("#divinstantchk").show();
                // $('#chckInstant').prop('checked', true);
                if (arr.chkinst == "0") {
                  $("#divinstant").hide();
                  $('#chckInstant').prop('checked', false);
                }
                else
                  $('#chckInstant').prop('checked', true);

                $("#divinstantchk :input").removeAttr('disabled');
              }
              else if (arr.eintboolproperty == "hide") {
                $("#divinstant").hide();
                $('#chckInstant').prop('checked', false);
                if (arr.isrpnumber == "1") {
                  $('#chckInstant').prop('checked', true);
                }

                $("#divinstantchk").hide();
              }
              else if (arr.eintboolproperty == "disabled" || arr.eintboolproperty == null) {
                $("#divinstant").show();
                $('#chckInstant').prop('checked', true);
                $("#divinstantchk").show();
                $("#divinstantchk :input").attr('disabled', 'true');
              }
            }
          }
        }
      }
      $('#protectiveSelector').modal('hide');
      this.hideLoader();
    },
      err => {
        this.hideLoader();
        $('#protectiveSelector').modal('hide');
      });
  }

  rowClick(index: any, generatexmlonly: boolean = false, isFromTreeNode: boolean = false, callNetworkCalcDLL: boolean = true) {
    // this.showLoader();
    this.index = index;
    var savexml = "0";
    // if (saveanotherdetail)
    //     this.saveOtherDetail();
    if (this.ListLoadStorage.length > 0) {
      var manufacturerId = parseInt(this.ListLoadStorage[index].manufacturer);
      var familyId = this.ListLoadStorage[index].family;

      var modelId = parseInt(this.ListLoadStorage[index].model.toString());
      var d = this.ListLoadStorage[index].rating.toString();
      var isIncomerDevice = false;

      var ee = this.ListLoadStorage[index].tripunit.toString();
      var curve = (ee.toString());
      this.ProtectiveLoadStorage = new ProtectiveItem();
      this.ProtectiveLoadStorage = this.ListLoadStorage[index];
      var res = curve;
      if (curve.indexOf('-') != -1) {
        res = curve.substr(0, curve.lastIndexOf('-'));
        res = this.trimChar(res.trim(), "-");
      }
      this.GetBreakingByManufacturerId(manufacturerId, familyId, modelId, d.toString(), res);
      this.GetPolesTableByManufacturerId(manufacturerId, familyId, modelId, d.toString(), res);

      this.multiplierEIR = 1;
      this.multiplierIN = 1;
      this.multiplierEIO = 1;

      var arr = familyId.split(' ')[1];


      this.btnAddDeviceRequestCounter += 1;
      this.btnAddDeviceDisabled = true;
      // this.modifyindex = this.index;
      var data = this.ListLoadStorage[this.index];
      if (this.loadProtectiveXmlInput == null || this.loadProtectiveXmlInput == undefined)
        this.loadProtectiveXmlInput = new ProtectiveXmlInput();
      this.loadProtectiveXmlInput.manufacturer_id = parseInt(data.manufacturer);
      this.loadProtectiveXmlInput.range_id = data.family;
      this.loadProtectiveXmlInput.tripunit = data.tripunit;
      this.loadProtectiveXmlInput.model = parseInt(data.model);
      this.loadProtectiveXmlInput.rating = data.rating;
      this.loadProtectiveXmlInput.devicenostr = data.devicenostr;
      this.deviceNumber = data.devicenostr.trim();
      this.protectiveImgSrc2 = 'assets/cablepro/logo/a.png';

      this.GetManufacturer();
      $(".clstripunit").show();
      $(".clscurveclass").show();
      $(".clsfustype").show();
      $(".clsreset").show();
      $("#devicesettingli").show();
      $("#normalDetail").show();
      $("#hvRelayDetail").hide();
      if (arr != null && arr != "" && (arr == "MCB" || arr == "Fuse")) {
        $("#devicesettingli").hide();
        // if (document.querySelector("#ulprotectioncoordination").querySelector("#protectiveTab2Open") != null && $("#protectiveConfiguration").data('bs.modal') && $("#protectiveConfiguration").data('bs.modal')._isShown) {
        //   (<HTMLElement>document.querySelector("#ulprotectioncoordination").querySelector("#protectiveTab2Open")).click();
        // }
        if (arr == "MCB") {
          $(".clsfustype").hide();
        }
        if (arr == "Fuse") {
          $(".clscurveclass").hide();

        }
        $(".clstripunit").hide();
        $(".clsreset").hide();
        $("#divmcbacbonly").show();
        $("#divelectronic").hide();
        $("#divmagneticonly").hide();
        $("#divtmagneticonly").hide();
        this.ProtectiveLoadControls(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
          , '', '', '', ''
          , '', ''
          , '', ''
          , '', ''
          , '', '', savexml, generatexmlonly, false, false, isFromTreeNode, isIncomerDevice, callNetworkCalcDLL);
      }
      else {
        $(".clsfustype").hide();
        $(".clscurveclass").hide();

        $("#divmcbacbonly").hide();
        this.ProtectiveLoadControls(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
          , '', '', '', ''
          , '', ''
          , '', ''
          , '', ''
          , '', '', savexml, generatexmlonly, false, false, isFromTreeNode, isIncomerDevice, callNetworkCalcDLL);

      }
    }
  }

  runCurveEvent(rownumber) {
    // if (this.listCoordinationCurve.length > 0 && $(".tblcurveelements").find('tr') != null && $(".tblcurveelements").find('tr') != undefined && $(".tblcurveelements").find('tr').length > 1 && this.listCoordinationCurve.find(x => x.rownumber == rownumber) != undefined) {
    //     this.listCoordinationCurve.forEach(element => {
    //         if (element.rownumber == rownumber) {
    //             this.changeCriteriaCurrent(element.criteriarownumber);
    //         }
    //     });
    // }
    // else {
    var data = this.chartData;
    var dimsize = this.dimSizeData;
    this.getChartLatest(data, dimsize);
    // this.saveOtherDetail();
    // }
  }

  updatem(controlchangedId: string = "", $event: any) {
    if ($event.value.toString() != "NaN") {
      this.coordinationloader = true;
      var manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
      var familyId = this.ListLoadStorage[this.index].family;

      var modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
      var d = this.ListLoadStorage[this.index].rating.toString();
      var ee = this.ListLoadStorage[this.index].tripunit.toString();
      var curve = (ee.toString());

      var multiplier = 1;
      var multipliercolumn = $(controlchangedId).attr('multiplier');
      if (multipliercolumn != undefined) {
        if (multipliercolumn == "E_Io") {
          multiplier = this.multiplierEIO;
        }
        if (multipliercolumn == "E_Ir") {
          multiplier = this.multiplierEIR;

        }
        if (multipliercolumn == "In") {
          multiplier = this.multiplierIN;

        }
      }


      if (controlchangedId == "#pickupcurrmgpr") {
        this.slidermim = $event.value;
        this.slidermimcalc = this.RemoveTrailingZeros((Math.round((parseFloat(this.getLegendFromValue(this.slidermim, this.slidermimoptions)) * multiplier) * 100) / 100).toFixed(2));
      }


      var mim = this.getLegendFromValue(this.slidermim, this.slidermimoptions)

      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', mim, '', '', ''
        , '', '', '', ''
        , '', ''
        , '', ''
        , '', ''
        , '', 0, controlchangedId, '');
    }
  }

  updateTm(controlchangedId: string = "", $event: any) {

    if ($event.value.toString() != "NaN") {
      this.coordinationloader = true;
      var manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
      var familyId = this.ListLoadStorage[this.index].family;

      var modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
      var d = this.ListLoadStorage[this.index].rating.toString();
      var ee = this.ListLoadStorage[this.index].tripunit.toString();
      var curve = (ee.toString());

      var multiplier = 1;
      var multipliercolumn = $(controlchangedId).attr('multiplier');
      if (multipliercolumn != undefined) {
        if (multipliercolumn == "E_Io") {
          multiplier = this.multiplierEIO;
        }
        if (multipliercolumn == "E_Ir") {
          multiplier = this.multiplierEIR;

        }
        if (multipliercolumn == "In") {
          multiplier = this.multiplierIN;

        }
      }


      if (controlchangedId == "#pickupcurrth") {
        this.slidertmir = $event.value;
        this.slidertmircalc = this.RemoveTrailingZeros((Math.round((parseFloat(this.getLegendFromValue(this.slidertmir, this.slidertmiroptions)) * multiplier) * 100) / 100).toFixed(2));
      }
      if (controlchangedId == "#pickupcurrmg") {
        this.slidertmim = $event.value;
        this.slidertmimcalc = this.RemoveTrailingZeros((Math.round((parseFloat(this.getLegendFromValue(this.slidertmim, this.slidertmimoptions)) * multiplier) * 100) / 100).toFixed(2));

      }
      if (this.deviceType == "2") {
        var tmir = this.getLegendFromValue(this.slidertmir, this.slidertmiroptions);

        var tmim = this.getLegendFromValue(this.slidertmim, this.slidertmimoptions);


      }
      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, tmir, tmim, '', '', '', ''
        , '', '', '', ''
        , '', ''
        , '', ''
        , '', ''
        , '', 0, controlchangedId, '');
    }
  }

  getChartLatest(data: any, dimsize: number) {

    const hiddenIndexes = []; //this.isFromCoordination == true ? this.ListLoadStorage.map((item, index) => !item.isVisible ? index : -1).filter(index => index !== -1) : [];
    var str = ``;
    var colorarray = new Array();
    var colorDefinedArrayHVRelay = ['rgba(255,0,0,1.0)'];
    var fillDefinedArrayHVRelay = ['rgba(255,0,0,0.5)'];

    var colorDefinedArray = ['rgba(255,0,0,1.0)', 'rgba(0,0,255,1.0)', 'rgba(128,0,255,1.0)', 'rgba(255,127,0,1.0)', 'rgba(0,255,255,1.0)', 'rgba(255,0,255,1.0)', 'rgba(255,255,0,1.0)'];
    var fillDefinedArray = ['rgba(255,0,0,0.5)', 'rgba(0,0,255,0.5)', 'rgba(128,0,255,0.5)', 'rgba(255,127,0,0.5)', 'rgba(0,255,255,0.5)', 'rgba(255,0,255,0.5)', 'rgba(255,255,0,0.5)'];

    var strdata = ``;
    var j = 0;
    var annot = [

    ];

    var shapes = [

    ];


    if (!this.CableSize['protection']['IsUnknown']) {
      for (j = 0; j < data.length; j++) {
        // avoid checking of isvisible flag for HV relay       
        if (data[j] != undefined && data[j] != null && data[j] != "") {

          var t1x = [];
          var t1y = [];

          var t2x = [];
          var t2y = [];
          var t3x = [];
          var t3y = [];

          if (this.index == j) {
            colorarray.push(colorDefinedArray[j].replace(',1.0)', ',0.8)'));
            colorarray.push(colorDefinedArray[j].replace(',1.0)', ',0.8)'));
            if (dimsize[j] > 4) {
              colorarray.push(colorDefinedArray[j].replace(',1.0)', ',0.8)'));
            }
          }
          else {
            colorarray.push(colorDefinedArray[j]);
            colorarray.push(colorDefinedArray[j]);
            if (dimsize[j] > 4) {
              colorarray.push(colorDefinedArray[j]);
            }
          }


          var length = (data[j].length);

          for (let i = 0; i < length - 1; (i = i + parseInt(dimsize[j].toString()))) {


            if (parseFloat(data[j][i].Val) > 0)
              t1x.push([parseFloat(data[j][i].Val).toFixed(4)]);
            if (parseFloat(data[j][i + 1].Val) > 0)
              t1y.push([parseFloat(data[j][i + 1].Val).toFixed(4)]);
            if (parseFloat(data[j][i + 2].Val) > 0)
              t2x.push([parseFloat(data[j][i + 2].Val).toFixed(4)]);
            if (parseFloat(data[j][i + 3].Val) > 0)
              t2y.push([parseFloat(data[j][i + 3].Val).toFixed(4)]);
            if (dimsize[j] > 4) {

              if (parseFloat(data[j][i + 4].Val) > 0)
                t3x.push([parseFloat(data[j][i + 4].Val).toFixed(4)]);
              if (parseFloat(data[j][i + 5].Val) > 0)
                t3y.push([parseFloat(data[j][i + 5].Val).toFixed(4)]);
            }


          }
          let deviceName;
          let ind = j;

          deviceName = this.deviceNoInString(j + 1)
          if (this.index == j) {
            str = str + ` ` + `var trace` + j + `1 = {
              x: [`+ t1x + `],
              y: [`+ t1y + `],
              mode: 'lines',
              showlegend:false,
              autorange: true,
              name: '`+ this.deviceNoInString(j + 1) + `',
              visible: `+ !hiddenIndexes.includes(j) + `
          };
          
          var trace`+ j + `2 = {
              x: [`+ t2x + `],
              y: [`+ t2y + `],
              mode: 'lines',
              fill:'tonexty' ,
              autorange: true,
              fillcolor: '`+ fillDefinedArray[j].replace(',0.5)', ',0.8)') + `',
              name: '`+ deviceName + `',      
              visible: `+ !hiddenIndexes.includes(j) + `,
              showlegend:false
          };`


          }
          else {
            str = str + ` ` + `var trace` + j + `1 = {
                  x: [`+ t1x + `],
                  y: [`+ t1y + `],
                  mode: 'lines',
                  showlegend:false,
                  autorange: true,
                  name: '`+ this.deviceNoInString(j + 1) + `',
                  visible: `+ !hiddenIndexes.includes(j) + `
              };
              
              var trace`+ j + `2 = {
                  x: [`+ t2x + `],
                  y: [`+ t2y + `],
                  mode: 'lines',
                  fill:'tonexty',
                  autorange: true,
                  fillcolor: '`+ fillDefinedArray[j] + `',
                  name: '`+ deviceName + `',      
                  visible: `+ !hiddenIndexes.includes(j) + `,   
                  showlegend:false
              };`


          }

          if (dimsize[j] > 4) {
            str = str + ` ` + ` var trace` + j + `3 = {
              x: [`+ t3x + `],
              y: [`+ t3y + `],
              mode: 'lines' ,
              showlegend:false,
              autorange: true,
              name: '`+ this.deviceNoInString(j + 1) + `',
              visible: `+ !hiddenIndexes.includes(j) + `
          };`

          }

          if (strdata == ``) {
            if (dimsize[j] > 4) {
              strdata = `trace` + j + `1, trace` + j + `2, trace` + j + `3`;
            }
            else {
              strdata = `trace` + j + `1, trace` + j + `2`;
            }
          }
          else {

            if (dimsize[j] > 4) {
              strdata = `trace` + j + `1, trace` + j + `2, trace` + j + `3` + `,` + strdata;
            }
            else {
              strdata = `trace` + j + `1, trace` + j + `2` + `,` + strdata;
            }


          }
        }
      }

      this.CalculationReportInput.damagetime = null;
      this.CalculationReportInput.damagecurrent = null;
    }


    // if (annot.length > 0)
    //     this.protectionCoordinationAnnotations = annot;
    var shapesvalues = ``;
    var no = 0;

    var seqx = [];
    var seqy = [];
    var seqx2 = [];
    var seqy2 = [];
    if (this.trippingCurrentAtSpecifiedTime != "Not Applicable" && !this.RCD) {
      shapesvalues = shapesvalues + ` ` + "x";
      let trippingtime;
      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;

      str = str + ` ` + ` var tracesequence2 = {
                  x: [`+ this.trippingCurrentAtSpecifiedTime + `],
                  y: [`+ trippingtime + `],
                  mode: 'markers',
                  name:'',                
                  autorange: true,
                  showlegend:false,
                  line: {                                  
                      color:'rgb(0, 0, 255)'                    
                  } 
                };`

      annot.push({
        x: Math.log10(parseFloat(this.trippingCurrentAtSpecifiedTime)),
        y: Math.log10(parseFloat(trippingtime)),
        xref: 'x',
        yref: 'y',
        text: parseFloat(parseFloat(this.trippingCurrentAtSpecifiedTime).toFixed(2).replace(/\.0+$/, '')) + ' A @ ' + trippingtime + ' s',
        showarrow: false,
        font: {
          family: 'Source Sans Pro',
          size: 14,
          color: 'rgb(0, 0, 255)'
        },
        align: 'right',
        bgcolor: '#ffffff',
        opacity: 0.8,
        xanchor: 'left',
        xshift: 10
      });

      seqx.push([this.trippingCurrentAtSpecifiedTime]);
      seqx.push([this.trippingCurrentAtSpecifiedTime]);
      seqy.push([trippingtime]);
      seqy.push([0]);
      str = str + ` ` + ` var tracesequence = {
                  x: [`+ seqx + `],
                  y: [`+ seqy + `],
                  mode: 'lines',
                  name: 'Lines',
                  autorange: true,    
                  showlegend:false,
                  line: {
                      dash: 'dash',                    
                      color:'rgb(0, 0, 255)'                    
                  }                
                };`

      seqx2.push([0]);
      seqx2.push([this.trippingCurrentAtSpecifiedTime]);
      seqy2.push([trippingtime]);
      seqy2.push([trippingtime]);
      str = str + ` ` + ` var tracesequence1 = {
                  x: [`+ seqx2 + `],
                  y: [`+ seqy2 + `],
                  mode: 'lines',
                  name: 'Lines',
                  autorange: true,
                  showlegend:false,
                  line: {
                      dash: 'dash',                
                      color:'rgb(0, 0, 255)'                    
                  }                
                };`

      strdata = strdata + ` , tracesequence` + `,` + `tracesequence1 ` + `,` + `tracesequence2 `;
      // shapes = ` `;
    }

    var ii = 1;

    var strdatastart = `var data = [`;
    var strdataend = `];`;

    var strcolortart = `[`;
    var strcolorend = `]`;
    var colorarry = ``;

    colorarray.forEach(element => {

      if (element != null && element != "") {
        if (colorarry == ``)
          colorarry = "'" + element + "'";
        else
          colorarry = "'" + element + "'" + `,` + colorarry;

      }
    });

    strdata = strdatastart + strdata + strdataend;
    if (shapesvalues != '') {
      colorarry = strcolortart + colorarry + " , 'rgba(0, 0, 0, 0.5)' , 'rgba(0, 0, 0, 1.0) '" + strcolorend;
    }
    else {
      colorarry = strcolortart + colorarry + strcolorend;
    }
    // width: 500,
    //             height: 500,

    // colorway : ['#FF3333', '#FFFC33', '#6BFF33', '#33FFE3', '#339CFF', '#B833FF', '#FF337A']
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = `
              {
                  `+ str + strdata + `
                   
                 
                    
                    var layout = { 
                      // autosize: true,  
                      // height:650,  
                      showlegend: false,
                      legend: {
                        x: 1,
                        xanchor: 'right',
                        y: 1,
                        font: {
                          family: 'Source Sans Pro',
                          size: 14
                        },
                        title: {
                          font: {
                            family: 'Source Sans Pro',
                            size: 14
                          }
                        },
                        item: {
                          font: {
                            family: 'Source Sans Pro',
                            size: 14
                          }
                        }
                      },
                      annotations: `+ JSON.stringify(annot) + `, 
                      shapes: `+ JSON.stringify(shapes) + `,                     
                      colorway : `+ colorarry + `,               
                      margin: {
                          l: 40,
                          r: 40,
                          b: 40,
                          t: 30,
                          pad: 4
                        },
                      xaxis: {                        
                          title: {
                              text: 'Current (A)',
                              font: {
                                family: 'Source Sans Pro',
                                size: 14,
                                color: '#7f7f7f'
                              }
                            },
                            autosize: false,
                        type: 'log',
                        autorange: true,
                        showspikes: true,
                        spikemode: 'toaxis'
                      },
                      yaxis: {                        
                          title: {
                              text: 'Time (s)',
                              font: {
                                family: 'Source Sans Pro',
                                size: 14,
                                color: '#7f7f7f'
                              }
                            },
                        type: 'log',
                        autosize: true,                      
                        autorange: true,
                        showspikes: true,
                        spikemode: 'toaxis'
                      },
  
                     
    hovermode: 'closest',
    dragmode: 'pan'
                    };
                   
                    var config = {
                      scrollZoom: true,
                      responsive: true,
                      displaylogo: false,
                      displayModeBar: true,
                      autoscaleYAxis: true ,
                      editable: false,
                      modeBarButtonsToRemove: ['select2d','lasso2d','hoverCompareCartesian']}
                    Plotly.newPlot('myDiv' , data, layout, config).then(
                      function(gd)
                       {
                          setTimeout(function() {
                        Plotly.toImage(gd,{height:580})
                           .then(
                               function(url)
                           {
                              $(".clsimg").val(url.split(',')[1]);
                             // this.plotData=url.split(',')[1];
                            
                              
                            //  img_jpg.attr("src", url);
                           }
                           )
                      });
                  }, 1000); // 1 second delay
                      }
          `;

    this._renderer2.appendChild(this._document.body, script);
  }

  onProtectiveRcdChange() {
    if (this.RCD == true) {
      this.CableSize['protection']['rcd'] = "1";
    }
    else {
      this.CableSize['protection']['rcd'] = "0";
    }

    this.getAllControlsValue();
  }

  public coordinationloader: boolean = false;
  protectiveConfigurationAccept() {
    // (<HTMLElement>document.querySelector("#ulcablesize").querySelector("#aCableSize")).click();

    //if ($("#devicesettingli").css('display') != "none" && this.isProtectiveConfigChanged == true) {
    this.coordinationloader = true;
    this._settingService.updateIECProtectiveXml({ calculationid: this.newCalculationId, xml: this.xmlData_Original, earthingsystem: this.protectionConfigurationModel.EarthingSystem, maxdisconnectiontime: this.protectionConfigurationModel.MaxDisconnectionTime, customTime: this.protectionConfigurationModel.CustomTime }).subscribe(result => {
      if (result) {
        this.coordinationloader = false;
        $('#protectiveConfiguration').modal('hide');
      }
    }, (err) => {

    }, () => {
      this.coordinationloader = false;
    });
    // }
    // else
    //   $('#protectiveConfiguration').modal('hide');


    this.CableSize['protection']['protectionConfigurationModel'] = this.protectionConfigurationModel;
    this.protectionConfigurationModel_Pristine = Object.assign({}, this.protectionConfigurationModel);
    this.trippingCurrentAtSpecifiedTime_Original = this.trippingCurrentAtSpecifiedTime;

    let trippingtime;

    if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
      trippingtime = this.protectionConfigurationModel.CustomTime;
    else
      trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;

    let update_Tripping_Xml = this.Tripping_Xml_Original;
    update_Tripping_Xml = update_Tripping_Xml.replace("[Tripping_time]", trippingtime);
    this.xmlData_Tripping = update_Tripping_Xml;
    this.CableSize['protection']['TrippingXml'] = update_Tripping_Xml;


    this.getAllControlsValue();

  }

  protectiveConfigurationCancel() {
    if ($("#devicesettingli").css('display') != "none" && this.isProtectiveConfigChanged == true) {
      this.index = 0;
      this.GetIECProtectiveDataByCalculationId(this.newCalculationId);
    }
    // (<HTMLElement>document.querySelector("#ulcablesize").querySelector("#aCableSize")).click();
    this.protectionConfigurationModel = Object.assign({}, this.protectionConfigurationModel_Pristine);
    this.trippingCurrentAtSpecifiedTime = this.trippingCurrentAtSpecifiedTime_Original;
  }

  onProtectiveCustomTimeChange(e: any) {
    this.CommonValidationFn(e);
    this.Allowdecimalwithplaces(e, 2);
    this.protectionConfigurationModel.CustomTime = e.target.value;

    let trippingtime;
    if (!this.protectionConfigurationModel.MaxDisconnectionTime)
      trippingtime = "0.4";
    else {
      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;
    }

    // let update_Tripping_Xml = this.Tripping_Xml_Original;
    // update_Tripping_Xml = update_Tripping_Xml.replace("[Tripping_time]", trippingtime);
    // this.xmlData_Tripping = update_Tripping_Xml;
    if (this.ListProtectiveInputCurrentObj)
      this.ListProtectiveInputCurrentObj.trippingtime = trippingtime;
    // this.updatecablesizeinarray();
    // this.onInputChange();
    this.callProtectiveXmlWithExisting();
  }

  onEarthinSystemChange() {
    // this.protectionConfigurationModel.EarthingSystem = (e.target as HTMLOptionElement).value;
    this.getMaxDisconnectionTimeOptions();
    this.protectionConfigurationModel.MaxDisconnectionTime = this.MaxDisconnectionTimeOptions[0].id;
    this.onMaxDisconnectionTimeChange(true);
    // $('#maxDisconnectionTime').val(this.protectionConfigurationModel.MaxDisconnectionTime).select2({
    //   width: '100%',
    //   minimumResultsForSearch: Infinity // disable search
    // }).trigger('change', "true");

  }

  onMaxDisconnectionTimeChange(isTriggered: boolean = false) {

    if (isTriggered === true) {
      let trippingtime;

      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;

      // let update_Tripping_Xml = this.Tripping_Xml_Original;
      // update_Tripping_Xml = update_Tripping_Xml.replace("[Tripping_time]", trippingtime);
      // this.xmlData_Tripping = update_Tripping_Xml;
      if (this.ListProtectiveInputCurrentObj)
        this.ListProtectiveInputCurrentObj.trippingtime = trippingtime;
      // this.updatecablesizeinarray();
      // this.onInputChange();
      this.callProtectiveXmlWithExisting();
    }
    else {

      //this.protectionConfigurationModel.MaxDisconnectionTime = (e.target as HTMLOptionElement).value;

      if (this.protectionConfigurationModel.MaxDisconnectionTime != "Custom")
        this.protectionConfigurationModel.CustomTime = undefined;
      else {
        this.protectionConfigurationModel.CustomTime = "0.4";
      }
      let trippingtime;
      if (!this.protectionConfigurationModel.MaxDisconnectionTime)
        trippingtime = "0.4";
      else {
        if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
          trippingtime = this.protectionConfigurationModel.CustomTime;
        else
          trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;
      }

      // let update_Tripping_Xml = this.Tripping_Xml_Original;
      // update_Tripping_Xml = update_Tripping_Xml.replace("[Tripping_time]", trippingtime);
      // this.xmlData_Tripping = update_Tripping_Xml;
      if (this.ListProtectiveInputCurrentObj)
        this.ListProtectiveInputCurrentObj.trippingtime = trippingtime;
      // this.updatecablesizeinarray();
      // this.onInputChange();
      this.callProtectiveXmlWithExisting();
    }


    if (this.deviceType == "3") {
      // this.updatem('#pickupcurrmgpr')

    }
    else if (this.deviceType == "2") {
      // this.updateTm('#pickupcurrth', $event);
    }
    else if (this.deviceType == "1") {
      // this.updateElectronic('#current-tolerance-range',$event);            
    }
  }

  callProtectiveXmlWithExisting() {
    var objinput: any = {};
    objinput.calculationid = this.newCalculationId;

    let trippingtime;
    if (!this.protectionConfigurationModel.MaxDisconnectionTime)
      trippingtime = "0.4";
    else {
      if (this.protectionConfigurationModel.MaxDisconnectionTime == "Custom")
        trippingtime = this.protectionConfigurationModel.CustomTime;
      else
        trippingtime = this.protectionConfigurationModel.MaxDisconnectionTime;
    }
    objinput.trippingtime = trippingtime;
    var devicetype = 1;
    if (this.protectiveXmlInputList.length > this.index)
      devicetype = this.protectiveXmlInputList[this.index].protectiondevicetype;
    var isIncomerDevice = false;
    if (devicetype == 2) {
      isIncomerDevice = true;
    }
    objinput.items = this.protectiveXmlInputList.filter(x => x.protectiondevicetype == devicetype);

    // objinput.items = this.protectiveXmlInputList;
    objinput.xml_Original = this.xmlData_Original;
    this.coordinationloader = true;
    if (this.xmlData_Original) {
      this._settingService.updateIECProtectiveForConnectionTime(objinput).subscribe(result => {
        if (result !== undefined && result !== null) {
          var arr = JSON.parse(result);
          this.xmlData = arr.xml;
          this.xmlData_Original = arr.xml_Original;
          this.xmlData_Tripping = arr.xml_TrippingCalculation;
          this.deviceType = arr.type;

          this.CableSize['xml'] = this.xmlData;
          this.CableSize['row'] = this.index;
          if (this.xmlData) {
            this.CableSize['BrowserName'] = this.detectBrowserName();
            this.CableSize['calculationType'] = "Network Calculation";
            this.CableSize['calculationId'] = this.newCalculationId;
            this.CableSize['UserName'] = this.user.userName;
            this._CableproCalc.ProtectiveCalculate(this.CableSize).subscribe((result) => {
              this.coordinationloader = false;
              this.trippingCurrentAtSpecifiedTime = result.trippingCurrentAtSpecifiedTime;
              this.GenerateMaxAllowedEFLImpedance();
              this.runCurveEvent(this.index);
            });
          }
        }
      });
    }

  }

  public MaxDisconnectionTimeOptions: Array<any>;
  public EarthingSystemOptions: Array<any> = [
    { id: 'TN', text: 'TN' },
    { id: 'TT', text: 'TT' },
  ];
  getMaxDisconnectionTimeOptions() {
    this.MaxDisconnectionTimeOptions = [
      { text: "Custom", id: "Custom" }
    ];
    let phase = this.CableproInput.PhaseId;
    let voltage = parseFloat(this.voltage_txt);
    let earthingSystem = this.protectionConfigurationModel.EarthingSystem;
    if (phase == 110) {//DC
      if (earthingSystem == 'TN') {
        if (voltage <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.8 s", id: "0.8" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 120 && voltage <= 230) {
          // if (this.cableCalculationStandard == '2') {
          //   this.MaxDisconnectionTimeOptions = [
          //     { text: "1 s", id: "1" },
          //     { text: "5 s", id: "5" },
          //     { text: "Custom", id: "Custom" }
          //   ];
          // }
          // else if (this.cableCalculationStandard == '3') {
          //   {
          this.MaxDisconnectionTimeOptions = [
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
          //   }
          //}
        }
        else if (voltage > 230 && voltage <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.4 s", id: "0.4" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.1 s", id: "0.1" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
      else if (earthingSystem == 'TT') {
        if (voltage <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.3 s", id: "0.3" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 120 && voltage <= 230) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.4 s", id: "0.4" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" },
          ];
        }
        else if (voltage > 230 && voltage <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.2 s", id: "0.2" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.1 s", id: "0.1" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
    }
    else if (phase == 109) {//3 Phase
      let volateAfterSqrt = voltage / Math.sqrt(3);
      if (earthingSystem == 'TN') {
        if (volateAfterSqrt <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.8 s", id: "0.8" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 120 && volateAfterSqrt <= 231) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.4 s", id: "0.4" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 231 && volateAfterSqrt <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.2 s", id: "0.2" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.1 s", id: "0.1" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
      else if (earthingSystem == 'TT') {
        if (volateAfterSqrt <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.3 s", id: "0.3" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 120 && volateAfterSqrt <= 231) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.2 s", id: "0.2" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 231 && volateAfterSqrt <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.07 s", id: "0.07" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (volateAfterSqrt > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.04 s", id: "0.04" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
    }
    else {//1 Phase or 2 Phase
      if (earthingSystem == 'TN') {
        if (voltage <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.8 s", id: "0.8" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 120 && voltage <= 230) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.4 s", id: "0.4" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 230 && voltage <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.2 s", id: "0.2" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.1 s", id: "0.1" },
            { text: "5 s", id: "5" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
      else if (earthingSystem == 'TT') {
        if (voltage <= 120) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.3 s", id: "0.3" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 120 && voltage <= 230) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.2 s", id: "0.2" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 230 && voltage <= 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.07 s", id: "0.07" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
        else if (voltage > 400) {
          this.MaxDisconnectionTimeOptions = [
            { text: "0.04 s", id: "0.04" },
            { text: "1 s", id: "1" },
            { text: "Custom", id: "Custom" }
          ];
        }
      }
    }
  }

  GenerateMaxAllowedEFLImpedance() {
    if (this.RCD == true) {
      this.protectionConfigurationModel.MaxAllowedEFLImpedance = "RCD";
    }
    else {
      if (this.trippingCurrentAtSpecifiedTime == "Not Applicable")
        this.protectionConfigurationModel.MaxAllowedEFLImpedance = "N/A";
      else {
        let phase = this.CableproInput.PhaseId;
        let voltage = parseFloat(this.voltage_txt);
        //let voltageTolerance = this.VoltageTolerance;// $('#VoltageTolerance').val().toString();
        let voltageFactorConst = 0.9;
        //if (voltageTolerance == "0") {
        // }
        // else if (voltageTolerance == "0") {
        //   voltageFactorConst = 0.95;
        // }

        if (phase == 109) {//3 Phase
          let volateAfterSqrt = voltage / Math.sqrt(3);
          this.protectionConfigurationModel.MaxAllowedEFLImpedance = ((volateAfterSqrt / parseFloat(this.trippingCurrentAtSpecifiedTime) * voltageFactorConst).toFixed(4)).toString();
        }
        else {
          this.protectionConfigurationModel.MaxAllowedEFLImpedance = ((voltage / parseFloat(this.trippingCurrentAtSpecifiedTime) * voltageFactorConst).toFixed(4)).toString();
        }

      }
    }
  }

  showProtectiveDeviceConfigurationUI() {


    this.index = 0;
    this.isProtectiveConfigChanged = false;
    let isUpdated = false;
    this.trippingCurrentAtSpecifiedTime_Original = this.trippingCurrentAtSpecifiedTime;
    // this.onEarthinSystemChange();
    this.GenerateMaxAllowedEFLImpedance();

    // this.onMaxDisconnectionTimeChange();

    // if (this.cableCalculationStandard == '2' || this.cableCalculationStandard == '3') {
    if (!this.protectionConfigurationModel.EarthingSystem) {
      this.protectionConfigurationModel.EarthingSystem = "TN";
    }
    // $('#drpEarthingSystem').val(this.protectionConfigurationModel.EarthingSystem).select2({
    //   width: '100%',
    //   minimumResultsForSearch: Infinity // disable search
    // }).trigger('change', "true");
    this.getMaxDisconnectionTimeOptions();
    if (!this.protectionConfigurationModel.MaxDisconnectionTime) {
      this.protectionConfigurationModel.MaxDisconnectionTime = this.MaxDisconnectionTimeOptions[0].id;
      isUpdated = true;
    }
    else {
      let currentObj = this.MaxDisconnectionTimeOptions.find(m => m.id == this.protectionConfigurationModel.MaxDisconnectionTime);
      if (!currentObj) {
        this.protectionConfigurationModel.MaxDisconnectionTime = this.MaxDisconnectionTimeOptions[0].id;
        isUpdated = true;
      }
    }
    // }
    // else {
    //   if (!this.protectionConfigurationModel.MaxDisconnectionTime) {
    //     this.protectionConfigurationModel.MaxDisconnectionTime = "0.4";
    //     isUpdated = true;
    //   }
    //   // this.protectionConfigurationModel.EarthingSystem = undefined;
    //   this.MaxDisconnectionTimeOptions = [
    //     { text: "0.4 s", id: "0.4" },
    //     { text: "5 s", id: "5" },
    //     { text: "Custom", id: "Custom" }
    //   ];
    // }
    if (isUpdated) {
      this.onMaxDisconnectionTimeChange(true);
      // $('#maxDisconnectionTime').val(this.protectionConfigurationModel.MaxDisconnectionTime).select2({
      //   width: '100%',
      //   minimumResultsForSearch: Infinity // disable search
      // }).trigger('change', "true");
    }

    $('#protectiveConfiguration').modal('show');
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    if (this.ListLoadStorage.length > 0) {
      var familyId = this.ListLoadStorage[this.index].family;
      var arr = familyId.split(' ')[1];
      $("#devicesettingli").show();
      $("#normalDetail").show();
      $("#hvRelayDetail").hide();
      if (arr != null && arr != "" && (arr == "MCB" || arr == "Fuse")) {
        $("#devicesettingli").hide();
        if (document.querySelector("#ulprotectioncoordination").querySelector("#protectiveTab2Open") != null) {
          (<HTMLElement>document.querySelector("#ulprotectioncoordination").querySelector("#protectiveTab2Open")).click();
        }
        if (arr == "MCB") {
          $(".clsfustype").hide();
        }
        if (arr == "Fuse") {
          $(".clscurveclass").hide();
        }
        $(".clstripunit").hide();
        $(".clsreset").hide();
        $("#divelectronic").hide();
        $("#divmagneticonly").hide();
        $("#divtmagneticonly").hide();
      }
      else {
        $(".clsfustype").hide();
        $(".clscurveclass").hide();
        document.getElementById('defaultOpenProtective').click();
      }
    }
    this.protectionConfigurationModel_Pristine = Object.assign({}, this.protectionConfigurationModel);
    setTimeout(() => {

      if ($('.c-select').length) {
        let $singleSelect = $('.c-select'),
          $singleSelectHasSearch = $('.c-select.has-search'),
          $multipleSelect = $('.c-select.c-select--multiple'),
          $disabledSelect = $('.c-select.is-disabled');

        $singleSelect.select2({
          width: '100%',
          minimumResultsForSearch: Infinity // disable search
        });

        // multiple select
        $multipleSelect.select2({
          width: '100%',
          multiple: true
        });

        // disabled select
        $disabledSelect.select2({
          width: '100%',
          disabled: true
        });
      }

      var data = this.chartData;
      var dimsize = this.dimSizeData;
      this.getChartLatest(data, dimsize);


    }, 200);

  }

  tabChangeProtective(evt, tabId) {

    var i, tabcontent, tablinks;
    tabcontent = document.getElementById("protectiveTabContent").getElementsByClassName("protective-tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementById("ulprotectioncoordination").getElementsByClassName("protective-tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
      tablinks[i].className = tablinks[i].className.replace(" activebold", "");
    }
    document.getElementById(tabId).style.display = "block";
    evt.currentTarget.className += " active activebold";
  }

  chnagei2tcurve() {

    this.updateElectronic("", { value: 0 });

  }

  showlongtimeprot() {
    if ($("#chcklongtime").is(":checked")) {
      $("#divlongtimeprot").show();
    }
    else {
      $("#divlongtimeprot").hide();
    }

    this.updateElectronic("", { value: 0 });

  }
  showshorttimeprot() {
    if ($("#chckshorttime").is(":checked")) {
      $("#divshorttime").show();
    }
    else {
      $("#divshorttime").hide();
    }
    this.updateElectronic("", { value: 0 });
  }

  //      

  showinstantprot() {
    if ($("#chckInstant").is(":checked")) {
      $("#divinstant").show();
    }
    else {
      $("#divinstant").hide();
    }
    this.updateElectronic("", { value: 0 });

  }
  resetDevice() {
    this.ProtectiveLoadDataXml = new ProtectiveData();


    var manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
    var familyId = this.ListLoadStorage[this.index].family;

    var modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
    var d = this.ListLoadStorage[this.index].rating.toString();
    var ee = this.ListLoadStorage[this.index].tripunit.toString();
    var curve = (ee.toString());
    this.ProtectiveLoadStorage.desc = this.ListLoadStorage[this.index].desc.toString()
    var res = curve;
    if (curve.indexOf('-') != -1) {
      res = curve.substr(0, curve.lastIndexOf('-'));
      res = this.trimChar(res.trim(), "-");
    }
    this.GetBreakingByManufacturerId(manufacturerId, familyId, modelId, d.toString(), res);
    this.GetPolesTableByManufacturerId(manufacturerId, familyId, modelId, d.toString(), res);


    this.multiplierEIR = 1;
    this.multiplierIN = 1;
    this.multiplierEIO = 1;
    $('#mcbacb-device').text(this.ProtectiveLoadStorage.desc);
    var arr = familyId.split(' ')[1];
    $(".clsreset").show();
    $(".clstripunit").show();
    $(".clscurveclass").show();
    $(".clsfustype").show();
    $("#devicesettingli").show();
    $("#normalDetail").show();
    $("#hvRelayDetail").hide();
    if (arr != null && arr != "" && (arr == "MCB" || arr == "Fuse")) {
      $("#devicesettingli").hide();
      //document.getElementById('tab2Open').click();
      if (arr == "MCB") {
        $(".clsfustype").hide();
      }
      if (arr == "Fuse") {
        $(".clscurveclass").hide();

      }
      $(".clstripunit").hide();
      $(".clsreset").hide();
      $("#divmcbacbonly").show();
      $("#divelectronic").hide();
      $("#divmagneticonly").hide();
      $("#divtmagneticonly").hide();
      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
        , '', '', '', ''
        , '', ''
        , '', ''
        , '', ''
        , '', 1, '', '', true);
    }
    else {
      $(".clsfustype").hide();
      $(".clscurveclass").hide();

      $("#divmcbacbonly").hide();

      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', '', '', ''
        , '', '', '', ''
        , '', ''
        , '', ''
        , '', ''
        , '', 1, '---', '', true);

    }

  }

  updateElectronic2(controlchangedId: string = "", $event: any) {
    if ($event.value.toString() != "NaN") {
      this.coordinationloader = true;
      var manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
      var familyId = this.ListLoadStorage[this.index].family;

      var modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
      var d = this.ListLoadStorage[this.index].rating.toString();
      var ee = this.ListLoadStorage[this.index].tripunit.toString();
      var curve = (ee.toString());



      var multiplier = 1;
      var multipliercolumn = $(controlchangedId).attr('multiplier');
      if (multipliercolumn != undefined) {
        if (multipliercolumn == "E_Io") {
          multiplier = this.multiplierEIO;
        }
        if (multipliercolumn == "E_Ir") {
          multiplier = this.multiplierEIR;

        }
        if (multipliercolumn == "In") {
          multiplier = this.multiplierIN;

        }
      }
      if (controlchangedId == "#timedelayshort-range") {
        this.slideretsd1 = $event.value;
        this.slideretsdcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretsd1, this.slideretsdoptions), multiplier);

      }


      var currenttolerance = this.getLegendFromValue(this.slidercurrenttolerance, this.slidercurrenttoleranceoptions);
      if ($("#current-tolerance-range").hasClass("hastype3")) {
        currenttolerance = (parseFloat(currenttolerance) / this.multiplierIN).toFixed(2).toString();
      }

      var timetolerance = this.getLegendFromValue(this.slidertimetolerance, this.slidertimetoleranceoptions);
      if ($("#time-tolerance-range").hasClass("hastype3")) {
        timetolerance = (parseFloat(timetolerance) / this.multiplierIN).toFixed(2).toString();
      }

      var timetobreak = this.getLegendFromValue(this.slidertimetobreak, this.slidertimetobreakoptions);

      if ($("#time-tobreak-range").hasClass("hastype3")) {
        timetobreak = (parseFloat(timetobreak) / this.multiplierIN).toFixed(2).toString();
      }
      var eratingplug = "";
      if ($('#ratingplug option:selected').val() != undefined)
        eratingplug = $('#ratingplug option:selected').val().toString();//$('#ratingplug').val().toString();
      var eltbool = "0";
      if ($("#chcklongtime").is(":checked") && $('#ratingplug option:selected').val() != "OFF") {
        eltbool = "1";
      }


      var estbool = "0";
      if ($("#chckshorttime").is(":checked")) {
        estbool = "1";
      }
      else {
        $("#chcki2curve").prop("checked", false);
      }
      var eintbool = "0";
      if ($("#chckInstant").is(":checked")) {
        eintbool = "1";
      }



      var eio = this.getLegendFromValue(this.slidereio, this.slidereiooptions)
        ;
      if ($("#pickupcurrpre-range").hasClass("hastype3")) {
        eio = (parseFloat(eio) / this.multiplierIN).toFixed(2).toString();
      }
      var eir = this.getLegendFromValue(this.slidereir, this.slidereiroptions)
        ;

      if ($("#pickupcurr-range").hasClass("hastype3")) {
        eir = (parseFloat(eir) / this.multiplierIN).toFixed(2).toString();
      }
      var etr = this.getLegendFromValue(this.slideretr, this.slideretroptions)
        ;
      if ($("#timedelay-range").hasClass("hastype3")) {
        etr = (parseFloat(etr) / this.multiplierIN).toFixed(2).toString();
      }
      var idmtl = this.getLegendFromValue(this.slideridmtl, this.slideridmtloptions)
        ;
      if ($("#idmtl-settings").hasClass("hastype3")) {
        idmtl = (parseFloat(idmtl) / this.multiplierIN).toFixed(2).toString();
      }
      var eisd = this.getLegendFromValue(this.slidereisd, this.slidereisdoptions)
        ;
      if ($("#pickupshort-range").hasClass("hastype3")) {
        eisd = (parseFloat(eisd) / this.multiplierIN).toFixed(2).toString();
      }
      var etsd = this.getLegendFromValue(this.slideretsd1, this.slideretsdoptions)
        ;
      if ($("#timedelayshort-range").hasClass("hastype3")) {
        etsd = (parseFloat(etsd) / this.multiplierIN).toFixed(2).toString();
      }

      var ei2tcurve = "0";
      if ($("#chcki2curve").is(":checked")) {
        ei2tcurve = "1";
      }


      if ($('#I2tdiv').css('display') == 'none') {
        ei2tcurve = "";

      }
      var eli = this.getLegendFromValue(this.slidereli, this.sliderelioptions);

      if ($("#pickupcurrinst-range").hasClass("hastype3")) {
        eli = (parseFloat(eli) / this.multiplierIN).toFixed(2).toString();
      }






      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', currenttolerance, timetolerance, timetobreak
        , eratingplug, eltbool, estbool, eintbool
        , eio, eir
        , etr, eisd
        , etsd, ei2tcurve
        , eli, 0, controlchangedId, idmtl);
    }
  }


  updateElectronic(controlchangedId: string = "", $event: any) {

    if ($event.value.toString() != "NaN") {
      this.coordinationloader = true;
      var manufacturerId = parseInt(this.ListLoadStorage[this.index].manufacturer);
      var familyId = this.ListLoadStorage[this.index].family;

      var modelId = parseInt(this.ListLoadStorage[this.index].model.toString());
      var d = this.ListLoadStorage[this.index].rating.toString();
      var ee = this.ListLoadStorage[this.index].tripunit.toString();
      var curve = (ee.toString());



      var multiplier = 1;
      var multipliercolumn = $(controlchangedId).attr('multiplier');
      if (multipliercolumn != undefined) {
        if (multipliercolumn == "E_Io") {
          multiplier = this.multiplierEIO;
        }
        if (multipliercolumn == "E_Ir") {
          multiplier = this.multiplierEIR;

        }
        if (multipliercolumn == "In") {
          multiplier = this.multiplierIN;
        }
      }


      if (controlchangedId == "#current-tolerance-range") {
        this.slidercurrenttolerance = $event.value;
        this.slidercurrenttolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult
          (this.getLegendFromValue($event.value, this.slidercurrenttoleranceoptions), multiplier))).toString();
      }
      if (controlchangedId == "#time-tolerance-range") {
        this.slidertimetolerance = $event.value;
        this.slidertimetolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult(this.getLegendFromValue($event.value
          , this.slidertimetoleranceoptions), multiplier))).toString();

      }

      if (controlchangedId == "#time-tobreak-range") {
        this.slidertimetobreak = $event.value;
        this.slidertimetobreakcalc = this.getCalculatedResult(this.getLegendFromValue($event.value
          , this.slidertimetobreakoptions), multiplier);
      }
      if (controlchangedId == "#pickupcurrpre-range") {

        this.slidereio = $event.value;
        this.slidereiocalc = this.getCalculatedResult(this.getLegendFromValue($event.value
          , this.slidereiooptions), multiplier);
        this.multiplierEIO = parseFloat(this.slidereiocalc);
        var elementonwhichevents = "";
        $(".multiplier").each(function () {
          var a = $(this);
          if ($(a).attr('multiplier') == "E_Io") {
            elementonwhichevents = elementonwhichevents + "," + $(a).attr("id");
          }
        });
        var elementonwhicheventsarry = elementonwhichevents.split(',');
        for (var i = 0; i < elementonwhicheventsarry.length; i++) {
          if (elementonwhicheventsarry[i] != "") {
            if (elementonwhicheventsarry[i] == "current-tolerance-range") {
              this.slidercurrenttolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult
                (this.getLegendFromValue(this.slidercurrenttolerance, this.slidercurrenttoleranceoptions), this.multiplierEIO))).toString();
            }
            if (elementonwhicheventsarry[i] == "time-tolerance-range") {
              this.slidertimetolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult(this.getLegendFromValue(this.slidertimetolerance, this.slidertimetoleranceoptions)
                , this.multiplierEIO))).toString();

            }
            if (elementonwhicheventsarry[i] == "time-tobreak-range") {
              this.slidertimetobreakcalc = this.getCalculatedResult(this.getLegendFromValue(this.slidertimetobreak, this.slidertimetobreakoptions)
                , this.multiplierEIO);
            }

            if (elementonwhicheventsarry[i] == "pickupcurr-range") {
              // this.slidereir=event;
              // this.multiplierEIR=event;
              this.slidereircalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereir, this.slidereiroptions)
                , this.multiplierEIO);
            }
            if (elementonwhicheventsarry[i] == "idmtl-settings") {

              this.slideridmtlcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideridmtl, this.slideridmtloptions)
                , this.multiplierEIO);
            }
            if (elementonwhicheventsarry[i] == "timedelay-range") {
              this.slideretrcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretr, this.slideretroptions)
                , this.multiplierEIO);


            }
            if (elementonwhicheventsarry[i] == "pickupshort-range") {
              this.slidereisdcalc = this.getCalculatedResult(
                this.getLegendFromValue(this.slidereisd, this.slidereisdoptions), this.multiplierEIO);

            }
            if (elementonwhicheventsarry[i] == "timedelayshort-range") {

              this.slideretsdcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretsd1, this.slideretsdoptions)
                , this.multiplierEIO);

            }
            if (elementonwhicheventsarry[i] == "pickupcurrinst-range") {

              this.sliderelicalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereli, this.sliderelioptions)
                , this.multiplierEIO);

            }
          }
        }

      }

      if (controlchangedId == "#pickupcurr-range") {
        this.slidereir = $event.value;
        this.slidereircalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereir, this.slidereiroptions)
          , multiplier);

        this.multiplierEIR = parseFloat(this.slidereircalc);

        var elementonwhichevents = "";
        $(".multiplier").each(function () {
          var a = $(this);
          if ($(a).attr('multiplier') == "E_Ir") {
            elementonwhichevents = elementonwhichevents + "," + $(a).attr("id");
          }
        });
        var elementonwhicheventsarry = elementonwhichevents.split(',');
        for (var i = 0; i < elementonwhicheventsarry.length; i++) {
          if (elementonwhicheventsarry[i] != "") {
            if (elementonwhicheventsarry[i] == "current-tolerance-range") {
              this.slidercurrenttolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult(this.getLegendFromValue(this.slidercurrenttolerance, this.slidercurrenttoleranceoptions)
                , this.multiplierEIR))).toString();
            }
            if (elementonwhicheventsarry[i] == "time-tolerance-range") {
              this.slidertimetolerancecalc = Math.round(100 * parseFloat(this.getCalculatedResult(this.getLegendFromValue($event.value
                , this.slidertimetoleranceoptions), this.multiplierEIR))).toString();



            }
            if (elementonwhicheventsarry[i] == "time-tobreak-range") {
              this.slidertimetobreakcalc = this.getCalculatedResult(this.getLegendFromValue(this.slidertimetobreak, this.slidertimetobreakoptions)
                , this.multiplierEIR);
            }

            if (elementonwhicheventsarry[i] == "pickupcurrpre-range") {
              // this.slidereir=event;
              // this.multiplierEIR=event;
              this.slidereiocalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereio, this.slidereiooptions)
                , this.multiplierEIR);
            }
            if (elementonwhicheventsarry[i] == "idmtl-settings") {
              this.slideridmtlcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideridmtl, this.slideridmtloptions)
                , this.multiplierEIR);


            }
            if (elementonwhicheventsarry[i] == "timedelay-range") {
              this.slideretrcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretr, this.slideretroptions)
                , this.multiplierEIR);


            }
            if (elementonwhicheventsarry[i] == "pickupshort-range") {
              this.slidereisdcalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereisd, this.slidereisdoptions)
                , this.multiplierEIR);

            }
            if (elementonwhicheventsarry[i] == "timedelayshort-range") {
              this.slideretsdcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretsd1, this.slideretsdoptions)
                , this.multiplierEIR);

            }
            if (elementonwhicheventsarry[i] == "pickupcurrinst-range") {

              this.sliderelicalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereli, this.sliderelioptions)
                , this.multiplierEIR);

            }
          }
        }

      }
      if (controlchangedId == "#timedelay-range") {
        this.slideretr = $event.value;
        this.slideretrcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideretr, this.slideretroptions), multiplier);


      }
      if (controlchangedId == "#idmtl-settings") {
        this.slideridmtl = $event.value;
        this.slideridmtlcalc = this.getCalculatedResult(this.getLegendFromValue(this.slideridmtl, this.slideridmtloptions)
          , multiplier);


      }

      if (controlchangedId == "#pickupshort-range") {
        this.slidereisd = $event.value;
        this.slidereisdcalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereisd, this.slidereisdoptions)
          , multiplier);

      }
      if (controlchangedId == "#pickupcurrinst-range") {
        this.slidereli = $event.value;
        this.sliderelicalc = this.getCalculatedResult(this.getLegendFromValue(this.slidereli, this.sliderelioptions)
          , multiplier);

      }

      var currenttolerance = this.getLegendFromValue(this.slidercurrenttolerance, this.slidercurrenttoleranceoptions);
      if ($("#current-tolerance-range").hasClass("hastype3")) {
        currenttolerance = (parseFloat(currenttolerance) / this.multiplierIN).toFixed(2).toString();
      }

      var timetolerance = this.getLegendFromValue(this.slidertimetolerance, this.slidertimetoleranceoptions);
      if ($("#time-tolerance-range").hasClass("hastype3")) {
        timetolerance = (parseFloat(timetolerance) / this.multiplierIN).toFixed(2).toString();
      }

      var timetobreak = this.getLegendFromValue(this.slidertimetobreak, this.slidertimetobreakoptions);

      if ($("#time-tobreak-range").hasClass("hastype3")) {
        timetobreak = (parseFloat(timetobreak) / this.multiplierIN).toFixed(2).toString();
      }
      var eratingplug = "";
      if ($('#ratingplug option:selected').val() != undefined)
        eratingplug = $('#ratingplug option:selected').val().toString();//$('#ratingplug').val().toString();
      var eltbool = "0";
      if ($("#chcklongtime").is(":checked") && $('#ratingplug option:selected').val() != "OFF") {
        eltbool = "1";
      }

      var estbool = "0";
      if ($("#chckshorttime").is(":checked")) {
        estbool = "1";
      }
      else {
        $("#chcki2curve").prop("checked", false);
      }
      var eintbool = "0";
      if ($("#chckInstant").is(":checked")) {
        eintbool = "1";
      }

      var eio = this.getLegendFromValue(this.slidereio, this.slidereiooptions)
        ;
      if ($("#pickupcurrpre-range").hasClass("hastype3")) {
        eio = (parseFloat(eio) / this.multiplierIN).toFixed(2).toString();
      }
      var eir = this.getLegendFromValue(this.slidereir, this.slidereiroptions)
        ;

      if ($("#pickupcurr-range").hasClass("hastype3")) {
        eir = (parseFloat(eir) / this.multiplierIN).toFixed(2).toString();
      }
      var etr = this.getLegendFromValue(this.slideretr, this.slideretroptions)
        ;
      if ($("#timedelay-range").hasClass("hastype3")) {
        etr = (parseFloat(etr) / this.multiplierIN).toFixed(2).toString();
      }
      var idmtl = this.getLegendFromValue(this.slideridmtl, this.slideridmtloptions)
        ;
      if ($("#idmtl-settings").hasClass("hastype3")) {
        idmtl = (parseFloat(idmtl) / this.multiplierIN).toFixed(2).toString();
      }
      var eisd = this.getLegendFromValue(this.slidereisd, this.slidereisdoptions)
        ;
      if ($("#pickupshort-range").hasClass("hastype3")) {
        eisd = (parseFloat(eisd) / this.multiplierIN).toFixed(2).toString();
      }
      var etsd = this.getLegendFromValue(this.slideretsd1, this.slideretsdoptions)
        ;
      if ($("#timedelayshort-range").hasClass("hastype3")) {
        etsd = (parseFloat(etsd) / this.multiplierIN).toFixed(2).toString();
      }

      var ei2tcurve = "0";
      if ($("#chcki2curve").is(":checked")) {
        ei2tcurve = "1";
      }
      if ($('#I2tdiv').css('display') == 'none') {
        ei2tcurve = "";
      }
      var eli = this.getLegendFromValue(this.slidereli, this.sliderelioptions);

      if ($("#pickupcurrinst-range").hasClass("hastype3")) {
        eli = (parseFloat(eli) / this.multiplierIN).toFixed(2).toString();
      }


      this.ProtectiveGetXml(manufacturerId, familyId, modelId, d.toString(), curve, '', '', '', currenttolerance, timetolerance, timetobreak
        , eratingplug, eltbool, estbool, eintbool
        , eio, eir
        , etr, eisd
        , etsd, ei2tcurve
        , eli, 0, controlchangedId, idmtl);
    }
  }

  getCalculatedResult(event: string, multiplier: number) {
    try {
      let isnum = /^\d+(\.\d{1,4})?$/.test(event);
      if (!isnum) {
        return event;

      }
      else {
        return this.RemoveTrailingZeros((Math.round((parseFloat(event) * multiplier) * 100) / 100).toFixed(2));

      }
    }
    catch (err) {
      return event;

    }

  }

  ExportLimitedChange(e) {

    if (this.chkexportlimited == true) {
      this.showFilter = true;
    }
    else {
      this.showFilter = false;

    }
    var a = this.defaultManId;
    var manufacturerId = parseInt(a.toString());

    var familyId = this.model.toString();
    var modelId = this.defaultModelId;
    this.GetBreakingByManufacturerId(manufacturerId, familyId, modelId, this.defaultRatingId.toString(), this.defaultCurveId);


  }

  status = {
    type: 'complies', // 'complies', 'non-complies', 'warnings'
    color: 'green',   // 'green', 'red', 'yellow'
    errors: [] as ErrorWarningModel[],
    warnings: [] as ErrorWarningModel[],
    showButton: false
  };

  updateStatusBar() {
    const errors = this.warningErrorList.filter(a => a.IsError === '1' && !['9003', '9004'].includes(a.ErrorCode));
    const warnings = this.warningErrorList.filter(a => a.IsError === '0');
    const only3003_3004 = this.warningErrorList.every(a => ['9003', '9004'].includes(a.ErrorCode));

    if (this.warningErrorList.length === 0 || only3003_3004) {
      this.status.type = 'complies';
      this.status.color = 'green';
      this.status.errors = [];
      this.status.warnings = this.warningErrorList;
      this.status.showButton = this.warningErrorList.length > 0;
    } else if (errors.length > 0) {
      this.status.type = 'non-complies';
      this.status.color = 'red';
      this.status.errors = errors;
      this.status.warnings = warnings;
      this.status.showButton = true;
    } else if (warnings.length > 0) {
      this.status.type = 'non-complies';
      this.status.color = 'yellow';
      this.status.errors = [];
      this.status.warnings = warnings;
      this.status.showButton = true;
    }
    this.displayErrorBtn = true;
  }
}